(function(){"use strict";try{if(typeof document!="undefined"){var e=document.createElement("style");e.appendChild(document.createTextNode('.room-provider[data-v-465d16de]{width:100%;height:100%;position:relative}.participant-video[data-v-487bad4f]{width:100%;height:100%;object-fit:cover;background-color:transparent}.participant-tag[data-v-bc836abf]{position:absolute;z-index:3;pointer-events:none;width:95%}.tag-content[data-v-bc836abf]{display:flex;align-items:center;gap:6px;width:fit-content;transition:all .2s ease}.mic-icon[data-v-bc836abf]{color:#f87171;flex-shrink:0}.pin-icon[data-v-bc836abf]{color:#3b82f6;flex-shrink:0}.participant-name[data-v-bc836abf]{color:#fff;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}.participant-tile[data-v-c60d6f8f]{position:relative;border-radius:20px;overflow:hidden;border:2px solid transparent;cursor:pointer;transition:all .2s ease}.participant-tile[data-v-c60d6f8f]:hover{border-color:#ffffff4d}.participant-tile.speaking[data-v-c60d6f8f]{border-color:#0f0;box-shadow:0 0 0 2px #0f06;transition:border-color .1s ease,box-shadow .1s ease}.participant-tile[data-v-c60d6f8f]:not(.speaking){transition:border-color 3s ease,box-shadow 3s ease}.tile-avatar[data-v-c60d6f8f]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}.tile-video[data-v-c60d6f8f]{position:absolute;inset:0}.participant-tile[data-size=small][data-v-c60d6f8f]{min-height:80px;border-radius:12px}.participant-tile[data-size=small] .tile-name[data-v-c60d6f8f]{font-size:10px}.participant-tile[data-size=medium][data-v-c60d6f8f]{min-height:120px;border-radius:20px}.participant-tile[data-size=large][data-v-c60d6f8f]{min-height:200px;border-radius:20px}.participant-tile[data-size=fullscreen][data-v-c60d6f8f]{min-height:300px;border-radius:20px}.participant-tile[data-size=fullscreen] .tile-name[data-v-c60d6f8f]{font-size:16px}.menu-button[data-v-c60d6f8f]{position:absolute;top:4px;right:4px;display:flex;align-items:center;justify-content:center;width:32px;height:32px;border-radius:50%;border:2px solid rgba(255,255,255,.8);background:#000000b3;color:#ffffffe6;cursor:pointer;backdrop-filter:blur(4px);z-index:15;opacity:0;transform:scale(.8);transition:all .2s ease}.hand-raised-indicator[data-v-c60d6f8f]{position:absolute;top:8px;left:8px;display:flex;align-items:center;justify-content:center;z-index:15;opacity:1}.hand-emoji[data-v-c60d6f8f]{font-size:32px;line-height:1;display:block;filter:drop-shadow(0 2px 4px rgba(0,0,0,.5))}.menu-button.menu-animate-in[data-v-c60d6f8f]{opacity:1;transform:scale(1);transition:all .2s ease}.menu-button[data-v-c60d6f8f]:hover{background:#000000e6;border-color:#fff;color:#fff;transform:scale(1.1)}.participant-tile[data-size=small] .menu-button[data-v-c60d6f8f]{width:24px;height:24px;border:1px solid rgba(255,255,255,.8)}.participant-tile[data-size=medium] .menu-button[data-v-c60d6f8f]{width:32px;height:32px}.participant-tile[data-size=large] .menu-button[data-v-c60d6f8f]{width:36px;height:36px}.participant-tile[data-size=fullscreen] .menu-button[data-v-c60d6f8f]{width:40px;height:40px;top:12px;right:12px}.participant-tile[data-size=small] .hand-emoji[data-v-c60d6f8f]{font-size:16px}.participant-tile[data-size=medium] .hand-emoji[data-v-c60d6f8f]{font-size:24px}.participant-tile[data-size=large] .hand-emoji[data-v-c60d6f8f]{font-size:28px}.participant-tile[data-size=fullscreen] .hand-emoji[data-v-c60d6f8f]{font-size:32px}.participant-tile[data-size=fullscreen] .hand-raised-indicator[data-v-c60d6f8f]{top:12px;left:12px}.tile-moderation-dropdown[data-v-c60d6f8f]{background:#1e293bf2;backdrop-filter:blur(12px);border-radius:12px;box-shadow:0 8px 24px #0006;border:1px solid rgba(255,255,255,.1);padding:6px;min-width:140px;max-height:300px;overflow-y:auto;transform:translate(-100%)}.tile-moderation-dropdown.dropdown-centered[data-v-c60d6f8f]{transform:translate(-50%,-50%)}.tile-moderation-dropdown.dropdown-size-small[data-v-c60d6f8f]{min-width:110px;padding:4px;border-radius:8px}.tile-moderation-dropdown.dropdown-size-medium[data-v-c60d6f8f]{min-width:140px}.tile-moderation-dropdown.dropdown-size-large[data-v-c60d6f8f],.tile-moderation-dropdown.dropdown-size-fullscreen[data-v-c60d6f8f]{min-width:160px}.dropdown-item[data-v-c60d6f8f]{display:flex;align-items:center;gap:10px;width:100%;padding:10px 12px;background:none;border:none;border-radius:8px;font-size:14px;font-weight:500;color:#fff;cursor:pointer;transition:all .2s;text-align:left}.dropdown-size-small .dropdown-item[data-v-c60d6f8f]{padding:8px 10px;font-size:12px;gap:8px;border-radius:6px}.dropdown-item[data-v-c60d6f8f]:hover{background-color:#ffffff1a}.dropdown-item.dropdown-item-danger[data-v-c60d6f8f]{color:#ff6b6b}.dropdown-item.dropdown-item-danger[data-v-c60d6f8f]:hover{background-color:#ff6b6b26}.dropdown-item svg[data-v-c60d6f8f]{flex-shrink:0}.dropdown-backdrop[data-v-c60d6f8f]{position:fixed;inset:0;z-index:9998;background:transparent}.stage-grid[data-v-18e03a2a]{width:100%;height:100%;min-height:0;position:relative;overflow:hidden;box-sizing:border-box;padding:4px}.stage-tile[data-v-18e03a2a]{position:absolute;background:#ffffff0d;border-radius:8px;overflow:hidden;border:2px solid rgba(255,255,255,.1);cursor:pointer;transition:border-color .2s ease;box-sizing:border-box;max-width:100%;max-height:100%;margin:4px}.stage-tile[data-v-18e03a2a]:hover{border-color:#ffffff4d}.stage-tile-big[data-v-18e03a2a]{border-color:#1a73e8;background:#1a73e81a}.tile-placeholder[data-v-18e03a2a]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background-color:#0000004d;z-index:1}.tile-video[data-v-18e03a2a]{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:2}.tile-info[data-v-18e03a2a]{position:absolute;bottom:8px;left:8px;right:8px;background:#000000b3;padding:4px 8px;border-radius:4px;backdrop-filter:blur(4px);z-index:3}.tile-name[data-v-18e03a2a]{font-size:12px;font-weight:500;color:#fff;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.stage-area[data-v-c84dd164]{width:100%;height:100%;min-height:0;position:relative;border-radius:12px;overflow:hidden;display:flex;flex-direction:row;align-items:center;box-sizing:border-box}.pagination-button[data-v-c84dd164]{position:absolute;top:50%;transform:translateY(-50%);z-index:100;display:flex;flex-direction:column;align-items:center;gap:8px;padding:16px 12px;background:#0009;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1);border-radius:8px;color:#fff;cursor:pointer;transition:all .2s ease}.pagination-button[data-v-c84dd164]:hover:not(:disabled){background:#000c;border-color:#fff3;transform:translateY(-50%) scale(1.05)}.pagination-button[data-v-c84dd164]:disabled{opacity:.3;cursor:not-allowed}.pagination-button svg[data-v-c84dd164]{width:24px;height:24px;color:#fff}.page-indicator[data-v-c84dd164]{font-size:14px;font-weight:600;color:#fff;white-space:nowrap}.pagination-prev[data-v-c84dd164]{left:16px}.pagination-next[data-v-c84dd164]{right:16px}@media (max-width: 768px){.pagination-button[data-v-c84dd164]{padding:12px 8px;gap:4px}.pagination-button svg[data-v-c84dd164]{width:20px;height:20px}.page-indicator[data-v-c84dd164]{font-size:12px}.pagination-prev[data-v-c84dd164]{left:8px}.pagination-next[data-v-c84dd164]{right:8px}}.pagination-dots[data-v-c84dd164]{position:absolute;bottom:8px;left:50%;transform:translate(-50%);z-index:100;display:flex;gap:8px;align-items:center;justify-content:center;padding:8px 16px;background:#0003;backdrop-filter:blur(10px);border-radius:20px;border:1px solid rgba(255,255,255,.1)}.pagination-dot[data-v-c84dd164]{width:10px;height:10px;border-radius:50%;border:2px solid rgba(255,255,255,.6);background:transparent;cursor:pointer;transition:all .2s ease;padding:0}.pagination-dot[data-v-c84dd164]:hover{border-color:#ffffffe6;transform:scale(1.2)}.pagination-dot.active[data-v-c84dd164]{background:#fff;border-color:#fff}@media (max-width: 768px){.pagination-button[data-v-c84dd164]{display:none!important}.pagination-dots[data-v-c84dd164]{display:flex}}@media (min-width: 769px){.pagination-dots[data-v-c84dd164]{display:none!important}}.participants-list-container[data-v-4f9f128e]{display:flex;flex-direction:column;background:#fff;border-radius:12px;box-shadow:0 4px 6px #0000001a;width:100%;max-width:400px;max-height:500px;overflow:hidden}.participants-header[data-v-4f9f128e]{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #e5e7eb}.participants-title[data-v-4f9f128e]{margin:0;font-size:18px;font-weight:600;color:#1f2937}.close-button[data-v-4f9f128e]{background:none;border:none;font-size:20px;color:#6b7280;cursor:pointer;padding:4px;width:28px;height:28px;display:flex;align-items:center;justify-content:center;border-radius:4px;transition:all .2s}.close-button[data-v-4f9f128e]:hover{background:#f3f4f6;color:#1f2937}.participants-scroll-area[data-v-4f9f128e]{flex:1;overflow-y:auto;padding:8px 0}.participant-item[data-v-4f9f128e]{display:flex;align-items:center;padding:12px 20px;gap:6px;transition:background-color .2s}.participant-item[data-v-4f9f128e]:hover{background-color:#f9fafb}.participant-avatar[data-v-4f9f128e]{flex-shrink:0}.participant-info[data-v-4f9f128e]{flex:1;min-width:0}.participant-name[data-v-4f9f128e]{font-size:14px;font-weight:500;color:#1f2937;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.participant-role[data-v-4f9f128e]{font-size:12px;color:#6b7280;margin-top:2px}.participant-controls[data-v-4f9f128e]{display:flex;align-items:center;flex-shrink:0}.media-control[data-v-4f9f128e]{background:transparent;border:none;cursor:pointer;padding:8px;border-radius:8px;display:flex;align-items:center;justify-content:center;transition:all .2s;color:#000}.media-control[data-v-4f9f128e]:hover:not(:disabled){background:#f3f4f6}.media-control[data-v-4f9f128e]:disabled{cursor:default;opacity:.5}.media-control.active[data-v-4f9f128e],.media-control.muted[data-v-4f9f128e]{color:#000}.more-options[data-v-4f9f128e]{background:transparent;border:none;cursor:pointer;padding:8px;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6b7280;transition:all .2s}.more-options[data-v-4f9f128e]:hover{background:#f3f4f6;color:#1f2937}.search-container[data-v-4f9f128e]{position:relative;padding:12px 20px}.search-input[data-v-4f9f128e]{width:100%;padding:10px 40px 10px 12px;border:1px solid #d1d5db;border-radius:8px;font-size:14px;color:#1f2937;background:#f9fafb;transition:all .2s;box-sizing:border-box}.search-input[data-v-4f9f128e]:focus{outline:none;border-color:#3b82f6;background:#fff;box-shadow:0 0 0 3px #3b82f61a}.search-input[data-v-4f9f128e]::placeholder{color:#9ca3af}.search-icon[data-v-4f9f128e]{position:absolute;right:32px;top:50%;transform:translateY(-50%);color:#6b7280;pointer-events:none}.participants-footer[data-v-4f9f128e]{padding:16px 20px;border-top:1px solid #e5e7eb;display:flex;justify-content:flex-end;gap:12px;background:#fff;position:sticky;bottom:0;z-index:10}.action-button[data-v-4f9f128e]{padding:10px 20px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;display:flex;align-items:center;gap:8px}.action-button.mute-all[data-v-4f9f128e]{background:#3b82f6;color:#fff}.action-button.mute-all[data-v-4f9f128e]:hover{background:#2563eb}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar{width:6px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-track{background:#f9fafb;border-radius:3px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:3px}.participants-scroll-area[data-v-4f9f128e]::-webkit-scrollbar-thumb:hover{background:#9ca3af}.moderation-dropdown[data-v-4f9f128e]{background:#fff;border-radius:8px;box-shadow:0 4px 12px #00000026;border:1px solid #e5e7eb;padding:4px;min-width:200px;max-height:400px;overflow-y:auto}.dropdown-section[data-v-4f9f128e]{padding:4px 0}.dropdown-section[data-v-4f9f128e]:not(:last-child){border-bottom:1px solid #e5e7eb;margin-bottom:4px}.dropdown-item[data-v-4f9f128e]{display:flex;align-items:center;gap:8px;width:100%;padding:8px 12px;background:none;border:none;border-radius:4px;font-size:14px;color:#1f2937;cursor:pointer;transition:background-color .2s;text-align:left}.dropdown-item[data-v-4f9f128e]:hover{background-color:#f3f4f6}.dropdown-item.dropdown-item-danger[data-v-4f9f128e]{color:#dc2626}.dropdown-item.dropdown-item-danger[data-v-4f9f128e]:hover{background-color:#fee2e2}.dropdown-item svg[data-v-4f9f128e]{flex-shrink:0}.dropdown-backdrop[data-v-4f9f128e]{position:fixed;inset:0;z-index:9998;background:transparent}.participants-modal-overlay[data-v-a338f334]{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#00000080;display:flex;align-items:center;justify-content:center;z-index:1000;backdrop-filter:blur(2px)}.floating-reactions-container[data-v-90dfe2b5]{position:absolute;inset:0;pointer-events:none;overflow:hidden;z-index:100}.reaction-animate[data-v-90dfe2b5]{position:absolute;font-size:3em;will-change:transform;display:flex;flex-direction:column;align-items:center;gap:4px;bottom:20px}.emoji-text[data-v-90dfe2b5]{font-size:1em;line-height:1;filter:drop-shadow(0 2px 4px rgba(0,0,0,.3))}.reaction-name[data-v-90dfe2b5]{font-size:.25em;color:#fff;background:#000000b3;padding:4px 8px;border-radius:12px;white-space:nowrap;font-weight:500;box-shadow:0 2px 8px #0000004d;backdrop-filter:blur(8px);border:1px solid rgba(255,255,255,.1)}.reaction-animate[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-1[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle1-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-2[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle2-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle3-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}@keyframes floatUp-90dfe2b5{0%{transform:translateY(0) scale(.3)}10%{transform:translateY(-50px) scale(1)}to{transform:translateY(calc(-100vh - 100px)) scale(1.1)}}@keyframes fadeInOut-90dfe2b5{0%{opacity:0}10%{opacity:1}70%{opacity:1}to{opacity:0}}@keyframes wiggle1-90dfe2b5{0%,to{margin-left:0}20%{margin-left:-30px}40%{margin-left:20px}60%{margin-left:-20px}80%{margin-left:30px}}@keyframes wiggle2-90dfe2b5{0%,to{margin-left:0}20%{margin-left:20px}40%{margin-left:-30px}60%{margin-left:30px}80%{margin-left:-20px}}@keyframes wiggle3-90dfe2b5{0%,to{margin-left:0}25%{margin-left:-25px}50%{margin-left:25px}75%{margin-left:-15px}}.floating-reactions-container.position-bottom-right .reaction-animate[data-v-90dfe2b5]{right:20px;left:auto}.floating-reactions-container.position-top-left .reaction-animate[data-v-90dfe2b5]{top:20px;bottom:auto}.floating-reactions-container.position-top-left .reaction-animate[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.floating-reactions-container.position-top-left .reaction-animate.wiggle-1[data-v-90dfe2b5],.floating-reactions-container.position-top-left .reaction-animate.wiggle-2[data-v-90dfe2b5],.floating-reactions-container.position-top-left .reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,wiggle1-90dfe2b5 8s ease-in-out forwards,fadeInOut-90dfe2b5 8s ease-out forwards}.floating-reactions-container.position-top-right .reaction-animate[data-v-90dfe2b5]{inset:20px 20px auto auto}.floating-reactions-container.position-top-right .reaction-animate[data-v-90dfe2b5]{animation:floatDown-90dfe2b5 5s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 5s ease-out forwards}@keyframes floatDown-90dfe2b5{0%{transform:translateY(0) scale(.3)}10%{transform:translateY(50px) scale(1)}to{transform:translateY(calc(100vh + 100px)) scale(1.1)}}@media (max-width: 768px){.reaction-animate[data-v-90dfe2b5]{font-size:2.5em}.reaction-name[data-v-90dfe2b5]{font-size:.3em;padding:3px 6px}.reaction-animate.wiggle-1[data-v-90dfe2b5],.reaction-animate.wiggle-2[data-v-90dfe2b5],.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUp-90dfe2b5 8s cubic-bezier(.47,.48,.44,.86) forwards,fadeInOut-90dfe2b5 8s ease-out forwards}}@media (prefers-reduced-motion: reduce){.reaction-animate[data-v-90dfe2b5],.reaction-animate.wiggle-1[data-v-90dfe2b5],.reaction-animate.wiggle-2[data-v-90dfe2b5],.reaction-animate.wiggle-3[data-v-90dfe2b5]{animation:floatUpSimple-90dfe2b5 2s ease-out forwards,fadeInOut-90dfe2b5 2s ease-out forwards}@keyframes floatUpSimple-90dfe2b5{0%{transform:translateY(0)}to{transform:translateY(-100vh)}}}.participants-strip-container[data-v-4ceb413c]{flex-shrink:0;width:100%;display:flex;align-items:center;background:#000c;border-bottom:1px solid rgba(255,255,255,.1);position:relative}.nav-button[data-v-4ceb413c]{position:absolute;top:50%;transform:translateY(-50%);z-index:100;display:flex;flex-direction:row;align-items:center;gap:6px;padding:8px 10px;background:#0009;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1);border-radius:8px;color:#fff;cursor:pointer;transition:all .2s ease}.nav-button[data-v-4ceb413c]:hover{background:#000c;border-color:#fff3;transform:translateY(-50%) scale(1.05)}.nav-button svg[data-v-4ceb413c]{width:20px;height:20px;color:#fff;transition:transform .2s ease}.nav-button:hover svg[data-v-4ceb413c]{transform:scale(1.1)}.page-indicator[data-v-4ceb413c]{font-size:12px;font-weight:600;color:#fff;white-space:nowrap}.nav-button-prev[data-v-4ceb413c]{left:12px}.nav-button-next[data-v-4ceb413c]{right:12px}.participants-strip[data-v-4ceb413c]{flex:1;display:flex;align-items:center;justify-content:center;gap:var(--0c95dd62);padding:12px 16px;overflow-x:auto;overflow-y:hidden;-webkit-overflow-scrolling:touch;scroll-behavior:smooth;scrollbar-width:none;-ms-overflow-style:none}.participants-strip.centered[data-v-4ceb413c]{justify-content:center;flex-direction:row}.participants-strip[data-v-4ceb413c]::-webkit-scrollbar{display:none}.strip-participant-tile[data-v-4ceb413c]{flex-shrink:0;width:var(--2d633a9e);height:var(--134b219c);border-radius:8px;overflow:hidden;border:2px solid rgba(255,255,255,.2);transition:all .2s ease;cursor:pointer}.strip-participant-tile[data-v-4ceb413c]:hover{border-color:#ffffff80;transform:scale(1.05)}.strip-participant-tile[data-v-4ceb413c] .participant-tag{bottom:2px;left:2px}.strip-participant-tile[data-v-4ceb413c] .tag-content{max-width:calc(100% - 8px);font-size:10px}.strip-participant-tile[data-v-4ceb413c] .participant-name{font-size:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:calc(var(--2d633a9e) - 20px)}@media (max-width: 1024px) and (min-width: 769px){.participants-strip[data-v-4ceb413c]{padding:10px 14px}.nav-button[data-v-4ceb413c]{padding:6px 8px;gap:4px}.nav-button svg[data-v-4ceb413c]{width:16px;height:16px}.page-indicator[data-v-4ceb413c]{font-size:10px}.nav-button-prev[data-v-4ceb413c]{left:10px}.nav-button-next[data-v-4ceb413c]{right:10px}.strip-participant-tile[data-v-4ceb413c] .participant-name{max-width:calc(var(--2d633a9e) - 20px);font-size:9px}.strip-participant-tile[data-v-4ceb413c] .tag-content{font-size:9px}}@media (max-width: 768px){.participants-strip[data-v-4ceb413c]{padding:8px}.nav-button[data-v-4ceb413c]{padding:6px;gap:3px}.nav-button svg[data-v-4ceb413c]{width:14px;height:14px}.page-indicator[data-v-4ceb413c]{font-size:9px}.nav-button-prev[data-v-4ceb413c]{left:8px}.nav-button-next[data-v-4ceb413c]{right:8px}.strip-participant-tile[data-v-4ceb413c]:hover{transform:scale(1.02)}.strip-participant-tile[data-v-4ceb413c] .participant-name{max-width:calc(var(--2d633a9e) - 20px);font-size:9px}}.screenshare-view[data-v-ab40f479]{width:100%;height:100%;display:flex;flex-direction:column}.screenshare-container[data-v-ab40f479]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#000;padding:4px}.screenshare-tile[data-v-ab40f479]{width:calc(100% - 8px);height:calc(100% - 8px);border-radius:12px}.screenshare-tile[data-v-ab40f479] .tile-video{border-radius:8px;overflow:hidden}.screenshare-tile[data-v-ab40f479] video{object-fit:contain;background:#000}c .screenshare-tile[data-v-ab40f479] .tile-video{cursor:grab;touch-action:pan-x pan-y pinch-zoom}.screenshare-tile[data-v-ab40f479] .tile-video:active{cursor:grabbing}.screenshare-placeholder[data-v-ab40f479]{display:flex;align-items:center;justify-content:center;width:100%;height:200px;color:#fff;font-size:18px;background:#000c;border-radius:8px}@media (max-width: 768px){.screenshare-container[data-v-ab40f479]{overflow:auto;-webkit-overflow-scrolling:touch}.screenshare-tile[data-v-ab40f479]:after{content:"👆 Tap to interact";position:absolute;bottom:8px;right:8px;background:#000000b3;color:#fff;padding:4px 8px;border-radius:4px;font-size:12px;opacity:.7;pointer-events:none;animation:fade-in-out-ab40f479 3s ease-in-out}}@keyframes fade-in-out-ab40f479{0%,to{opacity:0}20%,80%{opacity:.7}}.speaker-view[data-v-bb29316c]{width:100%;height:100%;display:flex;flex-direction:column}.pinned-grid-container[data-v-bb29316c]{width:100%;height:100%}.speaker-container[data-v-bb29316c]{width:100%;height:100%;display:flex;align-items:center;justify-content:center;background:#000;padding:4px}.speaker-tile[data-v-bb29316c]{width:calc(100% - 8px);height:calc(100% - 8px);border-radius:12px}.speaker-tile[data-v-bb29316c] .tile-video{border-radius:8px;overflow:hidden}.speaker-tile[data-v-bb29316c] video{object-fit:cover;background:#000}.speaker-placeholder[data-v-bb29316c]{display:flex;align-items:center;justify-content:center;width:100%;height:200px;color:#fff;font-size:18px;background:#000c;border-radius:8px}@media (max-width: 768px){.speaker-container[data-v-bb29316c]{padding:2px}.speaker-tile[data-v-bb29316c]{width:calc(100% - 4px);height:calc(100% - 4px)}}.room-view[data-v-e895758f]{position:relative;width:100%;min-height:400px;background-color:var(--4241b326);color:#fff;border-radius:var(--4be3eda6);overflow:hidden}.room-container[data-v-e895758f]{width:100%;height:100%;border-radius:var(--4be3eda6);overflow:hidden;background-color:var(--4241b326);position:relative}.preview-container[data-v-e895758f]{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center}.preview-video[data-v-e895758f]{width:100%;height:100%;object-fit:var(--4bc47665);background-color:var(--4241b326)}.preview-placeholder[data-v-e895758f]{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background-color:var(--4241b326);gap:16px}.permission-button-overlay[data-v-e895758f]{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:15}.permission-prompt-container[data-v-e895758f]{display:flex;flex-direction:column;align-items:center;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#0000004d;border-radius:16px;backdrop-filter:blur(10px)}.permission-revoked-container[data-v-e895758f]{display:flex;flex-direction:column;align-items:flex-end;gap:24px;text-align:center;max-width:600px;padding:40px 32px;background:#fff;border-radius:16px;backdrop-filter:blur(10px)}.permission-prompt-text[data-v-e895758f]{color:#fff;font-size:20px;margin:0;line-height:1.4;text-shadow:0 1px 3px rgba(0,0,0,.5)}.permission-revoked-text[data-v-e895758f]{color:#000;font-size:20px;margin:0;line-height:1.4}@media (max-width: 768px){.permission-prompt-container[data-v-e895758f],.permission-revoked-container[data-v-e895758f]{max-width:90%;padding:32px 24px;gap:20px}.permission-prompt-text[data-v-e895758f],.permission-revoked-text[data-v-e895758f]{font-size:18px}}@media (max-width: 480px){.permission-prompt-container[data-v-e895758f],.permission-revoked-container[data-v-e895758f]{max-width:90%;padding:24px 16px;gap:16px}.permission-prompt-text[data-v-e895758f],.permission-revoked-text[data-v-e895758f]{font-size:16px}}.permission-button[data-v-e895758f],.permission-revoked-button[data-v-e895758f]{background:#1976d2;color:#fff;border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;cursor:pointer;display:flex;align-items:center;gap:8px;transition:all .2s ease;box-shadow:0 2px 8px #1976d24d}.permission-button[data-v-e895758f]:hover,.permission-revoked-button[data-v-e895758f]:hover{background:#1565c0;transform:translateY(-1px);box-shadow:0 4px 12px #1976d266}.permission-button svg[data-v-e895758f]{color:#ea4335}.room-content[data-v-e895758f]{width:100%;height:100%;position:relative;display:flex;flex-direction:column;overflow:hidden}.filmstrip-section[data-v-e895758f]{flex-shrink:0;width:100%;display:flex;justify-content:center;padding:8px 16px 0;box-sizing:border-box;max-width:100%;overflow:visible}.stage-section[data-v-e895758f]{flex:1;width:100%;min-height:0;display:flex;flex-direction:column;padding:8px;box-sizing:border-box;overflow:hidden}.stage-section.fullscreen-stage[data-v-e895758f]{padding:8px;height:100vh;max-height:100vh;background-color:#040404}.status-overlay[data-v-e895758f]{position:absolute;top:16px;right:16px;display:flex;flex-direction:column;gap:8px;z-index:10}.room-status[data-v-e895758f]{display:flex;align-items:center;gap:8px;background:#000000b3;padding:8px 12px;border-radius:20px;backdrop-filter:blur(4px)}.status-dot[data-v-e895758f]{width:8px;height:8px;border-radius:50%;background:#34a853;animation:pulse-e895758f 2s infinite}@keyframes pulse-e895758f{0%,to{opacity:1}50%{opacity:.5}}.status-text[data-v-e895758f]{font-size:12px;font-weight:500;color:#34a853}.participant-count[data-v-e895758f]{background:#000000b3;padding:6px 12px;border-radius:16px;backdrop-filter:blur(4px);font-size:12px;text-align:center;color:#ffffffe6}.loading-overlay[data-v-e895758f]{position:absolute;inset:0;background:#000000b3;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;z-index:20}.spinner[data-v-e895758f]{width:40px;height:40px;border:3px solid rgba(255,255,255,.2);border-radius:50%;border-top-color:#fff;animation:spin-e895758f 1s linear infinite}@keyframes spin-e895758f{to{transform:rotate(360deg)}}.connection-message[data-v-e895758f]{font-size:16px;font-weight:500;color:#fff;text-align:center;margin:0}.error-overlay[data-v-e895758f]{position:absolute;inset:0;background:#000c;display:flex;align-items:center;justify-content:center;z-index:30}.error-message[data-v-e895758f]{background:#ea4335e6;padding:24px;border-radius:12px;text-align:center;max-width:400px}.error-message h3[data-v-e895758f]{margin:0 0 8px;font-size:18px;color:#fff}.error-message p[data-v-e895758f]{margin:0;font-size:14px;color:#ffffffe6}@media (max-width: 768px){.status-overlay[data-v-e895758f]{top:12px;right:12px}.filmstrip-section[data-v-e895758f]{padding:8px 12px 0}}.permission-modal-overlay[data-v-e895758f]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.permission-modal[data-v-e895758f]{background:#fff;border-radius:12px;padding:24px;width:380px;max-width:90vw;box-shadow:0 10px 25px #0003;text-align:left;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}@media (max-width: 639px){.permission-modal[data-v-e895758f]{width:320px}}.permission-modal-message[data-v-e895758f]{font-size:16px;color:#101828;margin:0 0 24px;line-height:1.5;font-weight:500}.permission-modal-button[data-v-e895758f]{background:#155eef;color:#fff;border:none;border-radius:8px;padding:10px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s;float:right;min-width:60px}.permission-modal-button[data-v-e895758f]:hover{background:#2563eb}.permission-modal-button[data-v-e895758f]:active{background:#1d4ed8}.recording-consent-modal-overlay[data-v-e895758f]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.recording-consent-modal[data-v-e895758f]{background:#fff;border-radius:12px;padding:20px;width:434px;max-width:90vw;box-shadow:0 10px 25px #0003;text-align:left;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}@media (max-width: 639px){.recording-consent-modal[data-v-e895758f]{width:320px}}.recording-consent-header[data-v-e895758f]{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px}.recording-consent-title[data-v-e895758f]{font-size:18px;font-weight:600;color:#101828;margin:0;line-height:1.4;flex:1}.recording-consent-close[data-v-e895758f]{background:none;border:none;cursor:pointer;padding:4px;margin:-4px -4px 0 0;color:#667085;border-radius:4px;transition:all .2s;display:flex;align-items:center;justify-content:center}.recording-consent-close[data-v-e895758f]:hover{background:#f9fafb;color:#344054}.recording-consent-close[data-v-e895758f]:active{background:#f2f4f7}.recording-consent-message[data-v-e895758f]{font-size:14px;color:#475467;margin:0 0 20px;line-height:1.5}.recording-consent-footer[data-v-e895758f]{border-top:1px solid #e5e7eb;margin:0 -20px -20px;padding:16px 20px;background:#fafafa;border-radius:0 0 12px 12px}.recording-consent-buttons[data-v-e895758f]{display:flex;gap:12px;justify-content:flex-end}.recording-consent-button[data-v-e895758f]{border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s}.recording-consent-continue[data-v-e895758f]{background:#1d4981;color:#fff}.recording-consent-continue[data-v-e895758f]:hover{background:#1e3a72;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.recording-consent-continue[data-v-e895758f]:active{background:#162f5f;transform:translateY(0);box-shadow:0 2px 4px #1d498133}.recording-consent-leave[data-v-e895758f]{background:#fff;color:#1f2937;border:1px solid #d1d5db}.recording-consent-leave[data-v-e895758f]:hover{background:#f9fafb;border-color:#9ca3af}.recording-consent-leave[data-v-e895758f]:active{background:#f3f4f6}.connection-minutes-modal-overlay[data-v-e895758f]{position:fixed;inset:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;backdrop-filter:blur(2px)}.connection-minutes-modal[data-v-e895758f]{background:#fff;border-radius:12px;padding:24px;width:434px;max-width:90vw;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;text-align:center;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;position:relative}@media (max-width: 639px){.connection-minutes-modal[data-v-e895758f]{width:320px;padding:20px}}.connection-minutes-close[data-v-e895758f]{position:absolute;top:16px;right:16px;background:none;border:none;cursor:pointer;padding:4px;color:#667085;border-radius:4px;transition:all .2s;display:flex;align-items:center;justify-content:center}.connection-minutes-close[data-v-e895758f]:hover{background:#f9fafb;color:#344054}.connection-minutes-close[data-v-e895758f]:active{background:#f2f4f7}.connection-minutes-icon[data-v-e895758f]{margin:24px auto 16px;display:flex;justify-content:center;align-items:center;width:56px;height:56px;background-color:#d1e0ff;border-radius:50%}.connection-minutes-title[data-v-e895758f]{font-size:24px;font-weight:500;color:#101828;margin:0 0 8px;line-height:1.4}.connection-minutes-message[data-v-e895758f]{font-size:16px;color:#475467;margin:0;line-height:1.5}.connection-minutes-footer[data-v-e895758f]{border-top:1px solid #e5e7eb;margin:24px -24px -24px;padding:16px 24px}@media (max-width: 639px){.connection-minutes-footer[data-v-e895758f]{margin:24px -20px -20px;padding:16px 20px}}.connection-minutes-buttons[data-v-e895758f]{display:flex;gap:12px;justify-content:center}.connection-minutes-button[data-v-e895758f]{border:none;border-radius:8px;padding:12px 20px;font-size:14px;font-weight:500;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;cursor:pointer;transition:background-color .2s;font-size:16px;flex:1}.connection-minutes-close-btn[data-v-e895758f]{background:#fff;color:#344054;border:1px solid #d0d5dd}.connection-minutes-close-btn[data-v-e895758f]:hover{background:#f9fafb;border-color:#b0b7c3}.connection-minutes-close-btn[data-v-e895758f]:active{background:#f2f4f7}.connection-minutes-upgrade[data-v-e895758f]{background:#155eef;color:#fff}.connection-minutes-upgrade[data-v-e895758f]:hover{background:#2563eb}.connection-minutes-upgrade[data-v-e895758f]:active{background:#1d4ed8}.leave-session-modal-overlay[data-v-e895758f]{position:fixed;inset:0;background:#0009;display:flex;align-items:center;justify-content:center;z-index:2011;backdrop-filter:blur(4px)}.leave-session-modal[data-v-e895758f]{background:#fff;border-radius:12px;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;max-width:550px;width:90%;max-height:90vh;overflow:hidden;position:relative;font-family:Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif}.leave-session-header[data-v-e895758f]{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 0}.leave-session-title[data-v-e895758f]{font-size:18px;font-weight:600;color:#111827;margin:0}.leave-session-body[data-v-e895758f]{padding:16px 24px 24px}.leave-session-message[data-v-e895758f]{font-size:14px;line-height:1.5;color:#6b7280;margin:0}.leave-session-actions[data-v-e895758f]{display:flex;gap:12px;padding:0 24px 24px;justify-content:flex-end}.leave-session-button[data-v-e895758f]{padding:10px 16px;border-radius:8px;font-size:14px;font-weight:500;cursor:pointer;transition:all .2s;border:none;min-width:80px}.leave-session-button.cancel-button[data-v-e895758f]{background:#fff;color:#374151;border:1px solid #d1d5db}.leave-session-button.cancel-button[data-v-e895758f]:hover{background:#fff;border-color:#9ca3af;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.leave-session-button.confirm-button[data-v-e895758f]{background:#ef4444;color:#fff}.leave-session-button.confirm-button[data-v-e895758f]:hover{background:#dc2626;transform:translateY(-1px);box-shadow:0 4px 8px #1d49814d}.leave-session-button.confirm-button[data-v-e895758f]:active{background:#b91c1c;transform:translateY(0);box-shadow:0 2px 4px #1d498133}@media (max-width: 480px){.leave-session-modal[data-v-e895758f]{margin:16px;width:calc(100% - 32px)}.leave-session-header[data-v-e895758f]{padding:16px 20px 0}.leave-session-title[data-v-e895758f]{font-size:16px}.leave-session-body[data-v-e895758f]{padding:12px 20px 20px}.leave-session-actions[data-v-e895758f]{padding:0 20px 20px;flex-direction:column-reverse}.leave-session-button[data-v-e895758f]{width:100%;padding:12px 16px}}.reaction-picker[data-v-206cd94d]{position:fixed;z-index:1000;padding:8px;backdrop-filter:blur(10px);border:1px solid rgba(255,255,255,.1)}.picker-content[data-v-206cd94d]{display:flex;gap:4px;align-items:center}.emoji-button[data-v-206cd94d]{width:44px;height:44px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;border-radius:8px;cursor:pointer;transition:all .2s ease;position:relative}.emoji-button[data-v-206cd94d]:hover{background:#ffffff1a;transform:scale(1.1)}.emoji-button[data-v-206cd94d]:active{transform:scale(.95)}.emoji-text[data-v-206cd94d]{font-size:24px;line-height:1;user-select:none}.emoji-button:hover .emoji-text[data-v-206cd94d]{animation:wiggle-206cd94d .5s ease-in-out}@keyframes wiggle-206cd94d{0%,to{transform:rotate(0)}25%{transform:rotate(-10deg)}75%{transform:rotate(10deg)}}.picker-fade-enter-active[data-v-206cd94d],.picker-fade-leave-active[data-v-206cd94d]{transition:all .2s ease}.picker-fade-enter-from[data-v-206cd94d],.picker-fade-leave-to[data-v-206cd94d]{opacity:0;transform:translate(-50%) scale(.9)}@media (max-width: 480px){.emoji-button[data-v-206cd94d]{width:40px;height:40px}.emoji-text[data-v-206cd94d]{font-size:20px}}.control-bar[data-v-84c49836]{display:flex;justify-content:center;align-items:center;gap:var(--5bd6955b);padding:var(--89655ef2);background:var(--09ef85aa);border-radius:var(--cb59ddd8);box-sizing:border-box;width:fit-content;z-index:80;--control-size: var(--4c034c18);--icon-size: var(--68cb172e);--icon-color: var(--d010f932);--text-color: var(--a600699a);--active-color: var(--d010f932);font-size:var(--e37275f2);color:var(--a600699a)}.control-bar.position-bottom[data-v-84c49836]{position:absolute;bottom:var(--7acb81d0);left:50%;transform:translate(-50%)}.control-bar.position-top[data-v-84c49836]{position:absolute;top:var(--7acb81d0);left:50%;transform:translate(-50%)}.control-bar.position-left[data-v-84c49836]{position:absolute;left:var(--7acb81d0);top:50%;transform:translateY(-50%)}.control-bar.position-right[data-v-84c49836]{position:absolute;right:var(--7acb81d0);top:50%;transform:translateY(-50%)}.control-bar.vertical[data-v-84c49836]{flex-direction:column;width:fit-content}.control-bar.vertical .controls-group[data-v-84c49836]{flex-direction:column}.controls-group[data-v-84c49836]{display:flex;align-items:center;gap:var(--5bd6955b);transition:all .3s ease-in-out}.controls-end[data-v-84c49836]{display:flex;align-items:center;gap:var(--5bd6955b)}.control-item[data-v-84c49836]{flex:0 0 auto;width:var(--control-size);height:var(--control-size);display:flex;align-items:center;justify-content:center;box-sizing:border-box;position:relative}.permission-indicator[data-v-84c49836]{position:absolute;top:-5px;right:-5px;background:#fa7b16;color:#fff;border-radius:50%;width:16px;height:16px;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;z-index:10}.permission-denied[data-v-84c49836]{background-color:#ea4335;border:1px solid rgb(234,67,53);border-radius:10px}.permission-denied[data-v-84c49836]:hover{opacity:1;transform:scale(1.05)}.settings-container[data-v-84c49836],.reactions-container[data-v-84c49836]{position:relative}.settings-dropdown[data-v-84c49836]{position:absolute;background:var(--a273767e);border-radius:var(--adfa0904);box-shadow:0 4px 24px #0000004d;z-index:1000;width:var(--97b060c6);max-width:90vw;overflow:hidden;padding:6px;border:1px solid rgba(255,255,255,.1);color:var(--d010f932)}.dropdown-content[data-v-84c49836]{display:flex;flex-direction:column;gap:var(--3fa75898)}.device-select[data-v-84c49836]{display:flex;flex-direction:column}.select-wrapper[data-v-84c49836]{position:relative;display:flex;align-items:center;background:var(--92b44dca);border-radius:var(--adfa0904);padding:var(--4d7ebc80) var(--0e2c7640);border:1px solid rgba(255,255,255,.3)}.device-icon[data-v-84c49836]{width:var(--55d758fa);height:var(--55d758fa);margin-right:8px;opacity:.7;color:var(--d010f932)}.arrow-icon[data-v-84c49836]{position:absolute;right:10px;top:50%;transform:translateY(-50%);width:var(--55d758fa);height:var(--55d758fa);color:var(--d010f932);opacity:.7;pointer-events:none}.device-select select[data-v-84c49836]{background:transparent;border:none;color:var(--a600699a);font-size:var(--a4b45d38);appearance:none;width:100%;padding:var(--78647223) var(--68c8d14e) var(--78647223) 0;background-image:none;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;height:100%;flex:1}.device-select select[data-v-84c49836]:focus{outline:none}.device-select select option[data-v-84c49836]{background:var(--e899878c);color:var(--a600699a);padding:var(--78647223);font-size:var(--a4b45d38)}.control-bar.position-bottom .settings-dropdown[data-v-84c49836]{top:auto;bottom:100%;left:50%;transform:translate(-50%);margin-bottom:12px}.control-bar.position-top .settings-dropdown[data-v-84c49836]{bottom:auto;top:100%;left:50%;transform:translate(-50%);margin-top:12px}.control-bar.position-left .settings-dropdown[data-v-84c49836]{bottom:auto;top:50%;left:100%;transform:translateY(-50%);margin-left:12px}.control-bar.position-right .settings-dropdown[data-v-84c49836]{bottom:auto;top:50%;right:100%;transform:translateY(-50%);margin-right:12px}.control-bar.no-background[data-v-84c49836]{padding:0;background:transparent;backdrop-filter:none;border-radius:0;box-shadow:none}.controls-animation-enter-active[data-v-84c49836],.controls-animation-leave-active[data-v-84c49836]{transition:all .3s ease-in-out}.controls-animation-enter-from[data-v-84c49836],.controls-animation-leave-to[data-v-84c49836]{opacity:0;transform:scale(.8);width:0;height:0;margin-right:calc(-1 * var(--0da23ef2) + "px");margin-left:calc(-1 * var(--0da23ef2) + "px")}.mic-meter-wrapper[data-v-84c49836]{width:100%;padding:6px 0}.mic-disabled-message[data-v-84c49836]{width:100%;text-align:center;padding:4px 0 4px 6px;font-size:12px;opacity:.7;color:var(--a600699a)}@media (max-width: 480px){.settings-dropdown[data-v-84c49836]{position:fixed;left:50%;right:auto;bottom:auto;transform:translate(-50%,-50%)}.dropdown-content[data-v-84c49836]{max-height:80vh;overflow-y:auto}}.message-text-content[data-v-f1133e77]{line-height:1.5;font-size:16px;color:inherit;text-align:left;overflow-wrap:break-word;word-break:break-word;hyphens:auto}.message-text-content.preserve-whitespace[data-v-f1133e77]{white-space:pre-wrap}.message-link[data-v-f1133e77]{transition:all .2s ease;border-radius:2px;padding:0 1px}.message-link[data-v-f1133e77]:hover{opacity:.8;background-color:#0066cc1a}.message-link[data-v-f1133e77]:focus{outline:2px solid rgba(0,102,204,.5);outline-offset:1px}.message-text-content .message-link[data-v-f1133e77]:hover{background-color:#87ceeb33}.room-chat[data-v-22d3ee82]{display:flex;flex-direction:column;height:100%;background:#fefeff;color:#333;overflow:hidden;position:relative}.input-container.drag-over[data-v-22d3ee82]{background:#0084ff1a;border:3px dashed #0084ff;border-radius:12px;box-shadow:0 0 20px #0084ff4d;transform:scale(1.02);transition:all .2s ease;position:relative}.input-container.drag-over[data-v-22d3ee82]:before{content:"";position:absolute;inset:0;background:#0084ff0d;border-radius:10px;pointer-events:none}.room-chat.inside-player .input-container.drag-over[data-v-22d3ee82]{background:#0084ff26;border:3px dashed rgba(0,132,255,.9);box-shadow:0 0 25px #0084ff66;backdrop-filter:blur(8px)}.room-chat.inside-player .input-container.drag-over[data-v-22d3ee82]:before{background:#0084ff1a}.input-container.drag-invalid[data-v-22d3ee82]{background:#dc35451a;border:3px dashed #dc3545;box-shadow:0 0 20px #dc35454d}.input-container.drag-invalid[data-v-22d3ee82]:before{background:#dc35450d}.room-chat.inside-player .input-container.drag-invalid[data-v-22d3ee82]{background:#dc354526;border:3px dashed rgba(220,53,69,.9);box-shadow:0 0 25px #dc354566}.room-chat.inside-player .input-container.drag-invalid[data-v-22d3ee82]:before{background:#dc35451a}.input-container.drag-invalid .drag-overlay-content[data-v-22d3ee82]{color:#dc3545}.room-chat.inside-player .input-container.drag-invalid .drag-overlay-content[data-v-22d3ee82]{color:#ff6b7a}.drag-overlay[data-v-22d3ee82]{position:absolute;inset:0;background:#0084ff1a;border-radius:10px;display:flex;align-items:center;justify-content:center;z-index:10;pointer-events:none;backdrop-filter:blur(2px)}.drag-overlay-content[data-v-22d3ee82]{display:flex;flex-direction:column;align-items:center;gap:8px;color:#0084ff;text-align:center}.drag-icon[data-v-22d3ee82]{opacity:.8;animation:dragPulse-22d3ee82 1.5s ease-in-out infinite}.drag-text[data-v-22d3ee82]{font-size:16px;font-weight:600;text-shadow:0 1px 2px rgba(255,255,255,.8)}.room-chat.inside-player .drag-overlay[data-v-22d3ee82]{background:#0084ff26;backdrop-filter:blur(4px)}.room-chat.inside-player .drag-text[data-v-22d3ee82]{color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.5)}.room-chat.inside-player .drag-icon[data-v-22d3ee82]{color:#fff}@keyframes dragPulse-22d3ee82{0%,to{transform:scale(1);opacity:.8}50%{transform:scale(1.1);opacity:1}}.file-size-error-notification[data-v-22d3ee82]{padding:16px;animation:slideInFromBottom-22d3ee82 .3s ease-out}.error-content[data-v-22d3ee82]{background:gold;color:#8b4513;padding:12px 16px;border-radius:8px;display:flex;align-items:center;justify-content:space-between;box-shadow:0 4px 12px #00000026;border:1px solid #e6c200}.error-text[data-v-22d3ee82]{font-size:14px;font-weight:500;flex:1;margin-right:12px}.error-dismiss-button[data-v-22d3ee82]{background:none;border:none;color:#8b4513;font-size:18px;font-weight:700;cursor:pointer;padding:0;width:24px;height:24px;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:background-color .2s}.error-dismiss-button[data-v-22d3ee82]:hover{background-color:#8b45131a}@keyframes slideInFromBottom-22d3ee82{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.room-chat.inside-player[data-v-22d3ee82]{background:transparent;color:#fff}.message-list[data-v-22d3ee82]{flex:1;overflow-y:auto;padding:16px;display:flex;flex-direction:column;gap:12px;scrollbar-width:none;-ms-overflow-style:none}.message-list[data-v-22d3ee82]::-webkit-scrollbar{display:none}.message-spacer[data-v-22d3ee82]{flex:1;min-height:0}.empty-state[data-v-22d3ee82]{flex:1;display:flex;align-items:center;justify-content:center;padding:40px 20px;text-align:center}.empty-state-content[data-v-22d3ee82]{max-width:300px;animation:fadeIn-22d3ee82 .5s ease-out}.empty-state-icon[data-v-22d3ee82]{margin-bottom:16px;display:flex;justify-content:center}.empty-state-illustration[data-v-22d3ee82]{margin-bottom:16px;object-fit:contain;display:block;margin-left:auto;margin-right:auto;width:100px;height:100px;@media (min-width: 768px){width:120px;height:120px}@media (min-width: 1024px){width:160px;height:160px}@media (min-width: 1440px){width:180px;height:180px}}.icon-circle-outer[data-v-22d3ee82]{width:56px;height:56px;border-radius:50%;background-color:#f0f4ff;display:flex;align-items:center;justify-content:center}.icon-circle-inner[data-v-22d3ee82]{width:40px;height:40px;border-radius:50%;background-color:#e0e7ff;display:flex;align-items:center;justify-content:center;color:#2563eb}.empty-state-heading[data-v-22d3ee82]{font-size:18px;font-weight:600;color:#333;margin:0 0 8px;line-height:1.3}.empty-state-message[data-v-22d3ee82]{font-size:14px;color:#666;margin:0;line-height:1.4}.room-chat.inside-player .empty-state-heading[data-v-22d3ee82]{color:#fff;text-shadow:0 1px 2px rgba(0,0,0,.5)}.room-chat.inside-player .empty-state-message[data-v-22d3ee82]{color:#fffc;text-shadow:0 1px 2px rgba(0,0,0,.5)}.room-chat.inside-player .icon-circle-outer[data-v-22d3ee82]{background-color:#ffffff0d;backdrop-filter:blur(8px)}.room-chat.inside-player .icon-circle-inner[data-v-22d3ee82]{background-color:#ffffff1a;color:#fffc}.message-wrapper[data-v-22d3ee82]{display:flex;gap:8px;align-items:flex-start}.message-wrapper.own-message[data-v-22d3ee82]{flex-direction:row}.message-avatar[data-v-22d3ee82]{flex-shrink:0}.message-content[data-v-22d3ee82]{display:flex;flex-direction:column;gap:4px;max-width:95%;width:fit-content;min-width:0;align-items:flex-start}.own-message .message-content[data-v-22d3ee82]{align-items:flex-start}.message-sender[data-v-22d3ee82]{font-size:12px;font-weight:600;color:#666;display:flex;align-items:center;gap:6px}.room-chat.inside-player .message-sender[data-v-22d3ee82]{color:#fff}.host-tag[data-v-22d3ee82]{background:#5773ff;color:#fff;font-size:10px;font-weight:600;padding:2px 6px;border-radius:8px;text-transform:uppercase;letter-spacing:.5px}.room-chat.inside-player .host-tag[data-v-22d3ee82]{background:#5773ffe6;backdrop-filter:blur(4px)}.message-bubble[data-v-22d3ee82]{background:#f8f9fa;padding:8px 12px;overflow-wrap:break-word;word-break:break-word;hyphens:auto;width:fit-content;border:1px solid #e9ecef;border-radius:16px;box-shadow:0 1px 2px #0000000d}.own-message .message-bubble[data-v-22d3ee82]{background:#e3f2fd;border-color:#bbdefb}.room-chat.inside-player .message-bubble[data-v-22d3ee82]{background:#ffffff26;padding:8px 12px;border:2px solid rgba(255,255,255,.2);width:fit-content;min-width:60px}.room-chat.inside-player .own-message .message-bubble[data-v-22d3ee82]{background:#e3f2fd33;border-color:#ffffff4d}.bubble-rounded[data-v-22d3ee82]{border-radius:16px}.bubble-square[data-v-22d3ee82]{border-radius:4px}.bubble-minimal[data-v-22d3ee82]{border-radius:0;background:transparent;padding:4px 0}.message-text[data-v-22d3ee82]{margin:0;line-height:1.5;font-size:16px;color:#333;text-align:left;overflow-wrap:break-word;word-break:break-word;hyphens:auto}.message-text[data-v-22d3ee82] .message-link{color:#06c;text-decoration:underline;transition:all .2s ease;border-radius:2px;padding:0 1px}.message-text[data-v-22d3ee82] .message-link:hover{opacity:.8;background-color:#0066cc1a}.message-text[data-v-22d3ee82] .message-link:focus{outline:2px solid rgba(0,102,204,.5);outline-offset:1px}.message-attachment-container[data-v-22d3ee82]{margin:8px 0}.own-message .message-text[data-v-22d3ee82]{text-align:left}.room-chat.inside-player .message-text[data-v-22d3ee82]{color:#fff;text-align:left}.room-chat.inside-player .own-message .message-text[data-v-22d3ee82]{text-align:left}.room-chat.inside-player .message-text[data-v-22d3ee82] .message-link{color:#87ceeb;text-shadow:0 1px 2px rgba(0,0,0,.7)}.room-chat.inside-player .message-text[data-v-22d3ee82] .message-link:hover{background-color:#87ceeb33;opacity:.9}.message-timestamp[data-v-22d3ee82]{font-size:11px;opacity:.5;color:#666}.message-timestamp.inline[data-v-22d3ee82]{font-size:11px;opacity:.6;color:#999;font-weight:400}.room-chat.inside-player .message-timestamp[data-v-22d3ee82]{color:#fff}.room-chat.inside-player .message-timestamp.inline[data-v-22d3ee82]{color:#ffffffb3}.message-attachment-container[data-v-22d3ee82]{width:100%}.message-attachment[data-v-22d3ee82]{border-radius:8px;overflow:hidden}.image-attachment[data-v-22d3ee82]{cursor:pointer;max-width:300px}.attachment-preview-image[data-v-22d3ee82]{width:100%;height:auto;max-height:300px;object-fit:cover;display:block;border-radius:8px}.video-attachment[data-v-22d3ee82]{max-width:400px}.attachment-preview-video[data-v-22d3ee82]{width:100%;height:auto;max-height:300px;border-radius:8px;background:#000}.document-attachment[data-v-22d3ee82]{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:12px;background:#f8f9fa;border:1px solid #e5e5e5;border-radius:8px}.room-chat.inside-player .document-attachment[data-v-22d3ee82]{background:#ffffff1a;border-color:#fff3}.attachment-info[data-v-22d3ee82]{display:flex;align-items:center;gap:8px;flex:1;min-width:0}.attachment-details[data-v-22d3ee82]{display:flex;flex-direction:column;min-width:0;text-align:left}.own-message .attachment-details[data-v-22d3ee82]{text-align:left}.attachment-name[data-v-22d3ee82]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.room-chat.inside-player .attachment-name[data-v-22d3ee82]{color:#fff}.attachment-size[data-v-22d3ee82]{font-size:12px;color:#6c757d;margin-top:2px}.room-chat.inside-player .attachment-size[data-v-22d3ee82]{color:#ffffffb3}.room-chat.inside-player .attachment-details[data-v-22d3ee82],.room-chat.inside-player .own-message .attachment-details[data-v-22d3ee82]{text-align:left}.download-button[data-v-22d3ee82]{flex-shrink:0;width:36px;height:36px;background:#fff;border:1px solid #e5e5e5;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.download-button[data-v-22d3ee82]:hover{background:#f8f9fa;color:#495057;transform:scale(1.05)}.room-chat.inside-player .download-button[data-v-22d3ee82]{background:#ffffff1a;border-color:#ffffff4d;color:#fff}.room-chat.inside-player .download-button[data-v-22d3ee82]:hover{background:#fff3}.input-container[data-v-22d3ee82]{display:flex;flex-direction:column;gap:8px;padding:12px;background:#fff;border:1px solid #e5e5e5;border-radius:12px;margin:16px}.room-chat.inside-player .input-container[data-v-22d3ee82]{flex-direction:row;gap:8px;padding:12px;background:transparent;border:none;border-radius:0;margin:0;border-top:1px solid rgba(255,255,255,.1)}.input-wrapper[data-v-22d3ee82]{flex:1;display:flex;position:relative}.buttons-row[data-v-22d3ee82]{display:flex;justify-content:space-between;align-items:center}.icons-group[data-v-22d3ee82]{display:flex;align-items:center}.icons-group .attachment-button[data-v-22d3ee82],.icons-group .emoji-button[data-v-22d3ee82]{width:36px;height:36px}.message-input[data-v-22d3ee82]{flex:1;background:#f0f0f0;border:1px solid #d1d5db;transition:border-color .2s,box-shadow .2s;padding:0;color:#333;font-size:14px;outline:none;transition:all .2s}.message-input.standalone[data-v-22d3ee82]{width:100%;border:none;border-radius:12px;padding:12px 16px;min-height:44px;max-height:120px;box-sizing:border-box;resize:none;font-family:inherit;line-height:1.4;overflow-y:auto;scrollbar-width:thin;scrollbar-color:rgba(0,0,0,.2) transparent}.message-input.standalone[data-v-22d3ee82]::-webkit-scrollbar{width:4px}.message-input.standalone[data-v-22d3ee82]::-webkit-scrollbar-track{background:transparent}.message-input.standalone[data-v-22d3ee82]::-webkit-scrollbar-thumb{background:#0003;border-radius:2px}.message-input.standalone[data-v-22d3ee82]::-webkit-scrollbar-thumb:hover{background:#0000004d}.room-chat.inside-player .message-input[data-v-22d3ee82]{background:#ffffff1a;border:1px solid rgba(255,255,255);border-radius:8px;padding:8px 12px;color:#fff}.message-input[data-v-22d3ee82]:focus{outline:none}.message-input.standalone[data-v-22d3ee82]:focus{background:#f0f0f0}.room-chat.inside-player .message-input[data-v-22d3ee82]:focus{background:#ffffff26;border-color:#ffffff4d}.message-input[data-v-22d3ee82]::placeholder{color:#999}.room-chat.inside-player .message-input[data-v-22d3ee82]::placeholder{color:#fff}.message-input[data-v-22d3ee82]:disabled{opacity:.5;cursor:not-allowed}.attachment-button[data-v-22d3ee82],.emoji-button[data-v-22d3ee82],.send-button[data-v-22d3ee82]{background:transparent;border:none;color:#6c757d;cursor:pointer;padding:8px;border-radius:8px;transition:all .2s;display:flex;align-items:center;justify-content:center}.attachment-button[data-v-22d3ee82]:hover,.emoji-button[data-v-22d3ee82]:hover{background:#0000000d;color:#495057}.room-chat.inside-player .attachment-button[data-v-22d3ee82],.room-chat.inside-player .emoji-button[data-v-22d3ee82],.room-chat.inside-player .send-button[data-v-22d3ee82]{color:#fff}.room-chat.inside-player .attachment-button[data-v-22d3ee82]:hover,.room-chat.inside-player .emoji-button[data-v-22d3ee82]:hover,.room-chat.inside-player .send-button[data-v-22d3ee82]:hover:not(:disabled){background:#ffffff1a}.attachment-button[data-v-22d3ee82]:disabled,.emoji-button[data-v-22d3ee82]:disabled,.send-button[data-v-22d3ee82]:disabled{opacity:.5;cursor:not-allowed}.send-button[data-v-22d3ee82]{background:#5773ff;color:#fff;width:36px;height:36px;border-radius:12px}.send-button[data-v-22d3ee82]:hover:not(:disabled){background:#4361ee}.room-chat.inside-player .send-button[data-v-22d3ee82]{background:#0084ff;color:#fff;width:36px;height:36px}.room-chat.inside-player .send-button[data-v-22d3ee82]:hover:not(:disabled){background:#0073e6}.room-chat.inside-player .input-wrapper .attachment-button[data-v-22d3ee82]{position:static;margin-right:8px}.room-chat.inside-player[data-v-22d3ee82]{position:absolute;bottom:0;left:0;right:0;height:40%;max-height:400px;z-index:50}.room-chat.inside-player .message-list[data-v-22d3ee82]{background:transparent;padding:12px 16px;max-height:calc(100% - 60px);mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%);-webkit-mask:linear-gradient(to bottom,transparent 0%,black 10%,black 100%)}.room-chat.inside-player .message-wrapper.own-message[data-v-22d3ee82]{flex-direction:row}.room-chat.inside-player .own-message .message-content[data-v-22d3ee82]{align-items:flex-start}.room-chat.inside-player .message-content[data-v-22d3ee82]{width:auto}.file-preview[data-v-22d3ee82]{display:flex;align-items:center;gap:12px;background:#f0f2f5;border-radius:8px;width:100%;padding:12px;box-sizing:border-box}.file-icon[data-v-22d3ee82]{flex-shrink:0;width:40px;height:40px;background:#e9ecef;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#6c757d}.file-preview-thumbnail[data-v-22d3ee82]{flex-shrink:0;width:40px;height:40px;border-radius:8px;overflow:hidden}.file-preview-thumbnail img[data-v-22d3ee82]{width:100%;height:100%;object-fit:cover}.file-info[data-v-22d3ee82]{flex:1;min-width:0}.file-name[data-v-22d3ee82]{font-size:14px;font-weight:500;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-size[data-v-22d3ee82]{font-size:12px;color:#6c757d;margin-top:2px}.file-remove-button[data-v-22d3ee82]{flex-shrink:0;width:32px;height:32px;background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#6c757d;transition:all .2s}.file-remove-button[data-v-22d3ee82]:hover:not(:disabled){background:#0000000d;color:#dc3545}.file-remove-button[data-v-22d3ee82]:disabled{opacity:.5;cursor:not-allowed}.progress-ring[data-v-22d3ee82]{animation:rotate-22d3ee82 2s linear infinite}.progress-ring-circle[data-v-22d3ee82]{transition:stroke-dasharray .3s ease}@keyframes rotate-22d3ee82{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.loading-more-indicator[data-v-22d3ee82]{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px;margin-bottom:8px;animation:fadeInDown-22d3ee82 .3s ease-out}.loading-spinner[data-v-22d3ee82]{width:16px;height:16px;border:2px solid #e5e5e5;border-top:2px solid #5773ff;border-radius:50%;animation:spin-22d3ee82 1s linear infinite}.loading-text[data-v-22d3ee82]{font-size:12px;color:#666;font-weight:500}.room-chat.inside-player .loading-text[data-v-22d3ee82]{color:#fffc}.room-chat.inside-player .loading-spinner[data-v-22d3ee82]{border-color:#ffffff4d;border-top-color:#fff}.no-more-indicator[data-v-22d3ee82]{display:flex;align-items:center;justify-content:center;padding:12px;margin-bottom:8px;animation:fadeInDown-22d3ee82 .3s ease-out}.no-more-text[data-v-22d3ee82]{font-size:11px;color:#999;text-align:center}.room-chat.inside-player .no-more-text[data-v-22d3ee82]{color:#fff9}.initial-loading-bottom[data-v-22d3ee82]{padding:16px;animation:slideInFromBottom-22d3ee82 .4s ease-out;background:#00000003}.message-skeleton[data-v-22d3ee82]{display:flex;gap:8px;align-items:flex-start;margin-bottom:16px;animation:pulse-22d3ee82 1.5s ease-in-out infinite}.skeleton-avatar[data-v-22d3ee82]{width:32px;height:32px;border-radius:50%;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-22d3ee82 1.5s infinite}.skeleton-content[data-v-22d3ee82]{flex:1;display:flex;flex-direction:column;gap:6px;max-width:70%}.skeleton-name[data-v-22d3ee82]{width:80px;height:12px;border-radius:6px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-22d3ee82 1.5s infinite}.skeleton-text[data-v-22d3ee82]{height:14px;border-radius:7px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0,#f0f0f0 75%);background-size:200% 100%;animation:shimmer-22d3ee82 1.5s infinite}.skeleton-text[data-v-22d3ee82]:not(.short){width:100%}.skeleton-text.short[data-v-22d3ee82]{width:60%}.room-chat.inside-player .initial-loading-bottom[data-v-22d3ee82]{background:#ffffff0d;padding:8px 16px}.room-chat.inside-player .message-skeleton[data-v-22d3ee82]{margin-bottom:8px}.room-chat.inside-player .skeleton-avatar[data-v-22d3ee82],.room-chat.inside-player .skeleton-name[data-v-22d3ee82],.room-chat.inside-player .skeleton-text[data-v-22d3ee82]{background:linear-gradient(90deg,#ffffff1a 25%,#fff3,#ffffff1a 75%);background-size:200% 100%}.new-message-notification[data-v-22d3ee82]{position:absolute;bottom:180px;left:50%;transform:translate(-50%);background:#5773ff;color:#fff;border:none;border-radius:24px;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;padding:6px 10px;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10;min-width:120px}.new-message-notification[data-v-22d3ee82]:hover{transform:translate(-50%) translateY(-2px);box-shadow:0 6px 20px #5773ff66;background:#4361ee}.new-message-notification[data-v-22d3ee82]:active{transform:translate(-50%) translateY(0)}.new-message-text[data-v-22d3ee82]{font-size:13px;font-weight:500}.room-chat.inside-player .new-message-notification[data-v-22d3ee82]{background:#000c;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0006;bottom:80px}.room-chat.inside-player .new-message-notification[data-v-22d3ee82]:hover{background:#000000e6;box-shadow:0 6px 20px #00000080}.scroll-to-bottom-button[data-v-22d3ee82]{position:absolute;bottom:140px;right:16px;width:48px;height:48px;background:#5773ff;color:#fff;border:none;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px #5773ff4d;transition:all .3s cubic-bezier(.4,0,.2,1);z-index:10}.scroll-to-bottom-button[data-v-22d3ee82]:hover{transform:translateY(-2px);box-shadow:0 6px 20px #5773ff66}.scroll-to-bottom-button[data-v-22d3ee82]:active{transform:translateY(0)}.scroll-to-bottom-button.inside-player[data-v-22d3ee82]{background:#000000b3;backdrop-filter:blur(10px);box-shadow:0 4px 12px #0000004d}.scroll-to-bottom-button.inside-player[data-v-22d3ee82]:hover{background:#000c;box-shadow:0 6px 20px #0006}.scroll-button-enter-active[data-v-22d3ee82],.scroll-button-leave-active[data-v-22d3ee82]{transition:all .3s cubic-bezier(.4,0,.2,1)}.scroll-button-enter-from[data-v-22d3ee82],.scroll-button-leave-to[data-v-22d3ee82]{opacity:0;transform:translateY(20px) scale(.8)}.new-message-notification-enter-active[data-v-22d3ee82],.new-message-notification-leave-active[data-v-22d3ee82]{transition:all .3s cubic-bezier(.4,0,.2,1)}.new-message-notification-enter-from[data-v-22d3ee82],.new-message-notification-leave-to[data-v-22d3ee82]{opacity:0;transform:translate(-50%) translateY(20px) scale(.9)}@keyframes spin-22d3ee82{0%{transform:rotate(0)}to{transform:rotate(360deg)}}@keyframes shimmer-22d3ee82{0%{background-position:-200% 0}to{background-position:200% 0}}@keyframes fadeIn-22d3ee82{0%{opacity:0}to{opacity:1}}@keyframes fadeInDown-22d3ee82{0%{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}@keyframes pulse-22d3ee82{0%,to{opacity:1}50%{opacity:.7}}@keyframes bounce-22d3ee82{0%,20%,53%,80%,to{transform:translateZ(0)}40%,43%{transform:translate3d(0,-8px,0)}70%{transform:translate3d(0,-4px,0)}90%{transform:translate3d(0,-2px,0)}}@media (max-width: 768px){.message-list[data-v-22d3ee82]{padding:12px}.message-content[data-v-22d3ee82]{max-width:85%}.input-container[data-v-22d3ee82]{padding:8px}.room-chat.inside-player[data-v-22d3ee82]{height:50%;max-height:300px}.image-attachment[data-v-22d3ee82],.video-attachment[data-v-22d3ee82]{max-width:100%}.attachment-preview-image[data-v-22d3ee82],.attachment-preview-video[data-v-22d3ee82]{max-height:200px}.document-attachment[data-v-22d3ee82]{padding:10px}.attachment-name[data-v-22d3ee82]{font-size:13px}.scroll-to-bottom-button[data-v-22d3ee82]{width:44px;height:44px;bottom:70px;right:12px}.loading-more-indicator[data-v-22d3ee82],.initial-loading[data-v-22d3ee82]{padding:12px}}')),document.head.appendChild(e)}}catch(a){console.error("vite-plugin-css-injected-by-js",a)}})();
var za = Object.defineProperty, Ia = Object.defineProperties;
var $a = Object.getOwnPropertyDescriptors;
var oa = Object.getOwnPropertySymbols;
var La = Object.prototype.hasOwnProperty, Ba = Object.prototype.propertyIsEnumerable;
var sa = (A, v, c) => v in A ? za(A, v, { enumerable: !0, configurable: !0, writable: !0, value: c }) : A[v] = c, w = (A, v) => {
  for (var c in v || (v = {}))
    La.call(v, c) && sa(A, c, v[c]);
  if (oa)
    for (var c of oa(v))
      Ba.call(v, c) && sa(A, c, v[c]);
  return A;
}, bt = (A, v) => Ia(A, $a(v));
var me = (A, v, c) => new Promise((e, i) => {
  var k = (t) => {
    try {
      d(c.next(t));
    } catch (b) {
      i(b);
    }
  }, p = (t) => {
    try {
      d(c.throw(t));
    } catch (b) {
      i(b);
    }
  }, d = (t) => t.done ? e(t.value) : Promise.resolve(t.value).then(k, p);
  d((c = c.apply(A, v)).next());
});
import { ref as z, watchEffect as It, computed as n, onUnmounted as ut, inject as we, watch as Re, nextTick as $t, reactive as _a, readonly as Gt, defineComponent as Ue, provide as tt, onMounted as ht, createElementBlock as u, openBlock as o, renderSlot as Lt, mergeProps as Fa, normalizeStyle as I, createElementVNode as a, createBlock as Ce, createCommentVNode as D, toDisplayString as ce, withModifiers as je, normalizeClass as Be, createVNode as q, Teleport as Yt, Fragment as Le, renderList as Xe, unref as P, withDirectives as Jt, vModelText as Xt, useCssVars as ea, Transition as Qt, withCtx as ot, TransitionGroup as Da, createTextVNode as Ha, withKeys as ra } from "vue";
import { e as st, u as _t, C as ct, c as Ot, t as Na, v as Oa, f as Va, w as ja, h as Ua, O as Wa, a as Vt, s as ta, N as Nt, A as jt, j as Ga, x as Za, y as Ka, P as ma, k as mt, l as Ya, m as Ja, n as Xa, o as Qa, p as qa, q as en, r as tn } from "./useChatPagination-CkAvHsHC.js";
import { b as an, T as pe, c as la, d as nn, e as on, t as sn, R as at, P as Ft, S as rn, V as ca, C as Dt } from "./live-vendor-BylJtbi3.js";
import { a as ln, l as fa, M as $e, A as cn, L as Zt } from "./index-BKMcmhwk.js";
import { _ as We } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as ha } from "./useContainerObserver-vDxyyGDS.js";
import { h as ft, e as zt, i as qt, k as un, d as dn, _ as pn, a as Ht, l as vn, f as mn, b as Kt, g as ua, j as da } from "./SpeakerIcon.vue_vue_type_script_setup_true_lang-B7QhZ13r.js";
import { b as ya, T as ga, _ as fn, R as hn, c as yn, a as gn } from "./TripleDotIcon-CnE5eu_G.js";
const pa = /\b(?:(?:https?|ftp):\/\/(?:localhost|(?:[a-zA-Z0-9-]+\.)+[A-Za-z]{2,}|\d{1,3}(?:\.\d{1,3}){3}|\[[0-9a-fA-F:]+\])(?::\d+)?(?:\/[^\s]*)?|www\.(?:[a-zA-Z0-9-]+\.)+[A-Za-z]{2,}(?::\d+)?(?:\/[^\s]*)?|(?:[a-zA-Z0-9-]+\.)+[A-Za-z]{2,}(?::\d+)?(?:\/[^\s]*)?|localhost:\d+(?:\/[^\s]*)?)/g, kn = /[.,;!?'"»]+$/, Sn = (A) => {
  const v = { ")": "(", "]": "[", "}": "{" }, c = A[A.length - 1], e = v[c];
  if (!e) return A;
  const i = [...A].filter((p) => p === e).length;
  return [...A].filter((p) => p === c).length > i ? A.slice(0, -1) : A;
}, bn = (A) => {
  let v = A.trim();
  if (v = v.replace(kn, ""), v = Sn(v), /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return null;
  if (!/^(?:https?|ftp):\/\//i.test(v))
    if (/^(?:www\.|(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}|localhost|\d{1,3}(?:\.\d{1,3}){3}|\[[0-9a-fA-F:]+\])(?::\d+)?(?:\/|$)/.test(
      v
    ))
      v = "https://" + v;
    else
      return null;
  try {
    const e = new URL(v);
    return e.hostname && e.hostname.includes("_") ? null : e.toString();
  } catch (e) {
    return null;
  }
}, wn = (A) => {
  const v = [];
  let c = 0;
  pa.lastIndex = 0;
  let e;
  for (; (e = pa.exec(A)) !== null; ) {
    const i = e.index, k = e[0], p = i + k.length;
    i > c && v.push({ type: "text", content: A.slice(c, i) });
    const d = i > 0 ? A[i - 1] : "", t = p < A.length ? A[p] : "";
    if (d === "@") {
      v.push({ type: "text", content: k }), c = p;
      continue;
    }
    if (/[A-Za-z0-9_]/.test(t)) {
      v.push({ type: "text", content: k }), c = p;
      continue;
    }
    const b = A.slice(Math.max(0, i - 10), i), r = /([A-Za-z][A-Za-z0-9+.-]*):\/\/$/i.exec(b);
    if (r && !/^(?:https?|ftp)$/i.test(r[1])) {
      v.push({ type: "text", content: k }), c = p;
      continue;
    }
    const l = bn(k);
    l ? v.push({ type: "link", content: k, url: l }) : v.push({ type: "text", content: k }), c = p;
  }
  return c < A.length && v.push({ type: "text", content: A.slice(c) }), v;
};
function Cn(A) {
  if (!A) return [];
  const v = wn(A);
  return v.length === 0 ? [{ type: "text", content: A }] : v;
}
function Pn() {
  const A = st(), { connectionState: v } = _t(), c = z(), e = z({});
  let i;
  const k = (l) => {
    if (!l) return {};
    try {
      return JSON.parse(l);
    } catch (h) {
      return {};
    }
  };
  It((l) => {
    const h = A.value, N = v.value === ct.Connected;
    if (!h || !N) {
      c.value = void 0, e.value = {};
      return;
    }
    i = an(h).subscribe({
      next: ({ metadata: m }) => {
        c.value = m, e.value = k(m);
      },
      error: (m) => {
      }
    }), l(() => {
      i && (i.unsubscribe(), i = void 0);
    });
  });
  const p = n(() => e.value.recording === !0), d = n(() => e.value.connectionMinutes), t = n(() => {
    const l = d.value;
    return l ? Math.max(0, l.maxEntity - l.entity) : 0;
  }), b = n(() => {
    const l = d.value;
    return !l || l.maxEntity === 0 ? 0 : Math.max(0, (l.maxEntity - l.entity) / l.maxEntity * 100);
  }), r = () => {
    const l = A.value;
    l && v.value === ct.Connected && (c.value = l.metadata, e.value = k(l.metadata));
  };
  return ut(() => {
    i && (i.unsubscribe(), i = void 0);
  }), {
    rawMetadata: c,
    metadata: e,
    isRecording: p,
    connectionMinutes: d,
    remainingMinutes: t,
    remainingPercentage: b,
    refreshMetadata: r
  };
}
function Rn(A, v, c) {
  const { remoteParticipants: e } = Ot(), i = st(), k = v || we("speechDetection"), p = c || we("raiseHand"), d = z("grid"), t = z([]), b = z(null), r = z(/* @__PURE__ */ new Map()), l = z([]), h = z([]), N = z(!1), m = z(Date.now()), H = z(/* @__PURE__ */ new Set()), x = z(/* @__PURE__ */ new Set()), U = z(/* @__PURE__ */ new Set()), R = n(() => {
    if (typeof window == "undefined") return "desktop";
    const L = window.innerWidth;
    return L < 768 ? "mobile" : L < 1024 ? "tablet" : "desktop";
  }), f = n(() => {
    switch (R.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 10;
      case "desktop":
        return 16;
      default:
        return 10;
    }
  }), y = n(() => {
    switch (R.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 12;
      case "desktop":
        return 16;
      default:
        return 16;
    }
  }), _ = n(() => {
    switch (R.value) {
      case "mobile":
        return 6;
      case "tablet":
        return 12;
      case "desktop":
        return 16;
      default:
        return 16;
    }
  }), E = n(() => {
    switch (R.value) {
      case "mobile":
        return 2;
      case "tablet":
        return 4;
      case "desktop":
        return 6;
      default:
        return 6;
    }
  }), j = n(() => {
    var Y;
    const L = [], O = (Y = i.value) == null ? void 0 : Y.localParticipant;
    return O && L.push(O), e.value && L.push(
      ...e.value
    ), L;
  }), ee = (L) => {
    const O = new Set(l.value);
    return L.some(
      (G) => !O.has(G)
    );
  }, V = (L, O) => {
    !O.some(
      (G) => !H.value.has(G)
    ) && L === "active-speakers-changed" || ee(O) && (h.value = [...O], l.value = [...O], N.value = !0, m.value = Date.now(), $t(() => {
      N.value = !1, h.value = [];
    }));
  }, ie = (L) => {
    x.value = new Set(L), Pe();
  }, te = (L) => {
    U.value = new Set(L), Pe();
  }, Pe = () => {
    const L = /* @__PURE__ */ new Set();
    x.value.forEach((O) => L.add(O)), U.value.forEach((O) => L.add(O)), H.value = L;
  }, Se = (L, O = {}) => {
    const { excludePinned: Y = !1 } = O, G = new Set(
      L.filter((ue) => ue.type === "screen-share").map((ue) => {
        var re;
        return (re = ue.screenShare) == null ? void 0 : re.participant.identity;
      }).filter(Boolean)
    ), ne = (ue) => {
      var Ve, Ie;
      if (ue.type === "screen-share")
        return (Ie = (Ve = ue.screenShare) == null ? void 0 : Ve.participant) != null && Ie.identity, 0;
      if (ue.type !== "participant" || !ue.participant) return 999;
      const re = ue.participant.identity;
      if (!re) return 999;
      const ge = i.value, He = (ge == null ? void 0 : ge.localParticipant.identity) === re ? ge.localParticipant : ge == null ? void 0 : ge.remoteParticipants.get(re), Oe = G.has(re), le = Ae(ue);
      return le && Q.value.length === 0 ? Oe ? 0.5 : 1 : (le && Q.value.length > 0, h.value.includes(re) ? Oe ? 1.5 : 2 : (p == null ? void 0 : p.getParticipantHandState(re)) || !1 ? Oe ? 2.5 : 3 : He != null && He.lastSpokeAt && Date.now() - He.lastSpokeAt.getTime() < 1e4 ? Oe ? 3.5 : 4 : He != null && He.isCameraEnabled ? Oe ? 4.5 : 5 : Oe ? 5.5 : 6);
    };
    let ve = L;
    if (Y) {
      const ue = new Set(t.value.map((re) => re.id));
      ve = L.filter((re) => !ue.has(re.id));
    }
    return ve.sort((ue, re) => {
      var Ve, Ie, Ke, qe;
      const ge = i.value, He = ((Ve = ue.participant) == null ? void 0 : Ve.identity) === (ge == null ? void 0 : ge.localParticipant.identity), Oe = ((Ie = re.participant) == null ? void 0 : Ie.identity) === (ge == null ? void 0 : ge.localParticipant.identity);
      if (He && !Oe) return -1;
      if (!He && Oe) return 1;
      const le = ne(ue), Ne = ne(re);
      if (le !== Ne)
        return le - Ne;
      const it = ((Ke = ue.participant) == null ? void 0 : Ke.identity) || ue.id, Ze = ((qe = re.participant) == null ? void 0 : qe.identity) || re.id;
      return it.localeCompare(Ze);
    });
  };
  k.onActiveSpeakersChange((L) => {
    V("active-speakers-changed", L);
  });
  const Ye = n(() => {
    const L = k.getInstantActiveSpeaker();
    return L && j.value.find((O) => O.identity === L) || null;
  }), Fe = Na(Ye, 150), Qe = n(() => {
    if (Fe.value)
      return Fe.value;
    const L = i.value;
    if (L) {
      const Y = Date.now();
      let G = null, ne = 0;
      if (j.value.forEach((ve) => {
        const ue = L.localParticipant.identity === ve.identity ? L.localParticipant : L.remoteParticipants.get(ve.identity);
        if (ue != null && ue.lastSpokeAt) {
          const re = ue.lastSpokeAt.getTime();
          Y - re < 1e4 && re > ne && (G = ve, ne = re);
        }
      }), G)
        return G;
    }
    const O = j.value.find((Y) => Y.isLocal);
    return O || j.value[0] || null;
  }), Q = z([]), be = () => {
    const L = [], O = A.trackReferences.value;
    j.value.forEach((Y) => {
      O.filter(
        (ne) => ne.participant.identity === Y.identity && ne.source === pe.Source.ScreenShare
      ).forEach((ne, ve) => {
        var ue, re;
        if ((ue = ne.publication) != null && ue.track && ((re = ne.publication) == null ? void 0 : re.isSubscribed) !== !1) {
          const ge = `${Y.identity}-screenshare`;
          r.value.has(ge) || r.value.set(ge, Date.now()), L.push({
            id: ge,
            type: "screen-share",
            screenShare: {
              participant: Y,
              track: {
                trackSid: ne.publication.trackSid,
                trackName: ne.publication.trackName || "Screen Share",
                source: pe.Source.ScreenShare
              },
              startTime: r.value.get(ge) || Date.now()
            }
          });
        }
      });
    }), L.sort((Y, G) => {
      var ue, re;
      const ne = ((ue = Y.screenShare) == null ? void 0 : ue.startTime) || 0, ve = ((re = G.screenShare) == null ? void 0 : re.startTime) || 0;
      return ne - ve;
    }), Q.value = L;
  };
  be();
  const he = () => {
    be();
  }, ye = n(() => {
    const L = [];
    return j.value.forEach((O) => {
      L.push({
        id: O.identity,
        type: "participant",
        participant: O
      });
    }), L.push(...Q.value), L.forEach((O) => {
      O.type === "participant" || O.type;
    }), L;
  });
  Re(
    [d, j],
    ([L, O], [Y, G]) => {
    }
  );
  const xe = () => {
    const L = t.value.length;
    if (Q.value.length > 0)
      return {
        entities: [
          Q.value[Q.value.length - 1]
        ],
        // Latest screenshare
        mode: "fullscreen"
      };
    if (L === 1)
      return {
        entities: [t.value[0]],
        mode: "fullscreen"
      };
    if (L >= 2)
      return {
        entities: t.value,
        mode: "grid"
      };
    switch (d.value) {
      case "speaker":
        return s();
      case "grid":
        return S();
      case "auto":
        return F();
      default:
        return { entities: [], mode: "empty" };
    }
  }, Te = n(() => xe()), Je = (L, O, Y) => {
    const G = L.filter(
      (re) => !O.has(re.identity)
    ), ne = i.value, ve = ne == null ? void 0 : ne.localParticipant;
    return G.sort((re, ge) => {
      const He = re.identity === (ve == null ? void 0 : ve.identity), Oe = ge.identity === (ve == null ? void 0 : ve.identity);
      if (He && !Oe) return -1;
      if (!He && Oe) return 1;
      const le = (Ze) => {
        const Ve = Ze.identity;
        if (!Ve) return 999;
        const Ie = (ne == null ? void 0 : ne.localParticipant.identity) === Ve ? ne.localParticipant : ne == null ? void 0 : ne.remoteParticipants.get(Ve);
        return h.value.includes(Ve) ? 1 : (p == null ? void 0 : p.getParticipantHandState(Ve)) || !1 ? 2 : Ie != null && Ie.lastSpokeAt && Date.now() - Ie.lastSpokeAt.getTime() < 1e4 ? 3 : Ie != null && Ie.isCameraEnabled ? 4 : 5;
      }, Ne = le(re), it = le(ge);
      return Ne !== it ? Ne - it : re.identity.localeCompare(ge.identity);
    });
  }, Ge = (L, O, Y) => Je(
    L,
    O
  ), s = () => {
    if (Q.value.length > 0)
      return {
        entities: [
          Q.value[Q.value.length - 1]
        ],
        // Latest share
        mode: "fullscreen"
      };
    if (t.value.length > 0)
      return {
        entities: t.value,
        mode: t.value.length === 1 ? "fullscreen" : "grid"
      };
    const L = k.getInstantActiveSpeaker();
    if (L) {
      const G = ye.value.find(
        (ne) => {
          var ve;
          return ne.type === "participant" && ((ve = ne.participant) == null ? void 0 : ve.identity) === L;
        }
      );
      if (G)
        return {
          entities: [G],
          mode: "fullscreen"
        };
    }
    if (Fe.value) {
      const G = ye.value.find(
        (ne) => {
          var ve, ue;
          return ne.type === "participant" && ((ve = ne.participant) == null ? void 0 : ve.identity) === ((ue = Fe.value) == null ? void 0 : ue.identity);
        }
      );
      if (G)
        return {
          entities: [G],
          mode: "fullscreen"
        };
    }
    const O = ye.value.filter(
      (G) => G.type === "participant"
    );
    for (const G of O)
      if (G.participant && k.getRecentSpeakerStatus(
        G.participant.identity
      ))
        return {
          entities: [G],
          mode: "fullscreen"
        };
    const Y = Se(
      O,
      {
        excludePinned: !1
      }
    );
    return Y.length > 0 ? {
      entities: [Y[0]],
      mode: "fullscreen"
    } : { entities: [], mode: "empty" };
  }, S = () => {
    if (Q.value.length > 0)
      return {
        entities: [
          Q.value[Q.value.length - 1]
        ],
        mode: "fullscreen"
      };
    const L = ye.value.filter(
      (Y) => Y.type === "participant"
    );
    return {
      entities: Se(
        L,
        {
          excludePinned: !1
        }
      ),
      mode: "grid"
    };
  }, F = () => {
    if (Q.value.length > 0)
      return {
        entities: [
          Q.value[Q.value.length - 1]
        ],
        mode: "fullscreen"
      };
    const L = ye.value.filter(
      (Y) => Y.type === "participant"
    ), O = Se(
      L,
      {
        excludePinned: !1
      }
    );
    return O.length > 0 ? {
      entities: O,
      // Send ALL, no slicing
      mode: "grid"
    } : { entities: [], mode: "empty" };
  }, Z = n(() => {
    if (!W())
      return {
        entities: [],
        visible: !1,
        capacity: f.value
      };
    const O = Te.value.entities.map((ve) => ve.id), Y = ye.value.filter(
      (ve) => !O.includes(ve.id)
    );
    return Y.forEach((ve) => {
      ve.type === "participant" || ve.type;
    }), {
      entities: Se(
        Y,
        {
          excludePinned: !0
        }
      ).slice(0, f.value),
      visible: !0,
      capacity: f.value
    };
  }), W = () => d.value === "grid" ? Q.value.length > 0 ? !0 : t.value.length > 0 : d.value === "speaker" ? !0 : d.value === "auto" ? Q.value.length > 0 ? !0 : t.value.length > 0 ? ye.value.filter(
    (G) => G.type === "participant"
  ).length - t.value.length > 0 : ye.value.filter(
    (O) => O.type === "participant"
  ).length > y.value : !0, Me = (L) => {
    d.value = L, L !== "auto" && (b.value = null);
  }, _e = () => {
    t.value = [];
  }, ze = (L) => {
    const O = t.value.findIndex((Y) => Y.id === L.id);
    if (O > -1)
      t.value.splice(O, 1);
    else {
      const Y = _.value;
      t.value.length >= Y && t.value.shift(), t.value.push(L);
    }
  }, oe = (L) => {
    const O = ye.value.find(
      (Y) => {
        var G;
        return Y.type === "participant" && ((G = Y.participant) == null ? void 0 : G.identity) === L.identity;
      }
    );
    O && ze(O);
  }, Ae = (L) => t.value.some((O) => O.id === L.id), nt = (L) => {
    const O = ye.value.find(
      (Y) => {
        var G;
        return Y.type === "participant" && ((G = Y.participant) == null ? void 0 : G.identity) === L.identity;
      }
    );
    return O ? t.value.some((Y) => Y.id === O.id) : !1;
  }, J = () => {
    d.value = "auto", t.value = [], b.value = null, r.value.clear();
  }, De = (L) => {
    const O = t.value.length;
    t.value = t.value.filter((Y) => {
      var G, ne;
      return Y.type === "participant" ? ((G = Y.participant) == null ? void 0 : G.identity) !== L : Y.type === "screen-share" ? ((ne = Y.screenShare) == null ? void 0 : ne.participant.identity) !== L : !0;
    }), O - t.value.length;
  };
  return Re(Q, (L, O) => {
    if (O && O.length > 0) {
      const Y = new Set(L.map((G) => G.id));
      O.forEach((G) => {
        Y.has(G.id) || r.value.delete(G.id);
      });
    }
    d.value === "auto" && L.length === 0 && O && O.length > 0 && (b.value = null);
  }), {
    // Core State
    layoutMode: d,
    pinnedEntities: t,
    deviceType: R,
    // Computed Zones
    stageZone: Te,
    filmstripZone: Z,
    // Entity Collections
    allParticipants: j,
    allEntities: ye,
    activeSpeaker: Fe,
    speakerModeParticipant: Qe,
    screenShareEntities: Q,
    // Methods
    setLayoutMode: Me,
    toggleEntityPin: ze,
    toggleParticipantPin: oe,
    // Legacy
    isPinned: Ae,
    isParticipantPinned: nt,
    // Legacy
    clearAllPins: _e,
    resetLayout: J,
    removePinByParticipantId: De,
    // Screenshare updates
    triggerScreenShareUpdate: he,
    // Priority system (shared between Stage and Filmstrip)
    prioritizeEntitiesByActivity: Se,
    // 🌟 NEW: Controlled strip participants for ParticipantStrip.vue (PHASE 5)
    getControlledStripParticipants: Ge,
    // Capacity
    filmstripCapacity: f,
    autoModeGridCapacity: y,
    // 🌟 SIMPLE APPROACH: Basic info
    stageCapacity: _,
    stripCapacity: E,
    hasNewActiveSpeakers: ee,
    // 🌟 NEW: Controlled priority recalculation (PHASE 4)
    triggerPriorityRecalculation: V,
    shouldRecalculatePriority: n(() => N.value),
    lastPriorityUpdate: n(() => m.value),
    // ✅ SIMPLE: Update visible participants from components (separate to avoid race conditions)
    updateStageVisibleParticipants: ie,
    updateStripVisibleParticipants: te
  };
}
function va(A, v) {
  const c = z(v);
  return It((e) => {
    if (!A) {
      c.value = v;
      return;
    }
    const i = A.subscribe({
      next: (k) => {
        c.value = k;
      },
      error: (k) => {
      }
    });
    e(() => {
      i.unsubscribe();
    });
  }), c;
}
function Tn() {
  const A = st(), v = z(/* @__PURE__ */ new Map()), c = z(/* @__PURE__ */ new Map()), e = /* @__PURE__ */ new Map(), i = va(
    n(() => {
      const R = A.value;
      if (R) {
        const f = la(R);
        return f.subscribe({
          next: (y) => {
          },
          error: (y) => {
          }
        }), f;
      }
    }).value,
    []
  ), k = va(
    n(() => {
      const R = A.value;
      if (R)
        return la(R).pipe(
          nn(500)
          // 500ms debounce
        );
    }).value,
    []
  );
  let p = null;
  const d = (R) => {
    p = R;
  };
  Re(k, (R) => {
    if (p) {
      const f = R.map((y) => y.identity);
      p(f);
    }
  });
  const t = (R) => {
    const f = R.identity;
    if (e.has(f))
      return;
    A.value, R.getTrackPublication(
      pe.Source.Microphone
    );
    const _ = on(R).subscribe({
      next: (ie) => {
        v.value.set(f, ie), R.getTrackPublication(
          pe.Source.Microphone
        );
      },
      error: (ie) => {
      }
    });
    let E = null;
    const j = () => {
      E = setInterval(() => {
        c.value.set(f, R.audioLevel);
      }, 200);
    }, ee = () => {
      E && (clearInterval(E), E = null);
    };
    j();
    const V = {
      unsubscribe: ee
    };
    e.set(f, {
      speakingSubscription: _,
      audioLevelSubscription: V
    }), v.value.set(f, R.isSpeaking), c.value.set(f, R.audioLevel);
  }, b = (R) => {
    const f = e.get(R);
    f && (f.speakingSubscription.unsubscribe(), f.audioLevelSubscription.unsubscribe(), e.delete(R), v.value.delete(R), c.value.delete(R));
  }, r = (R) => {
    const f = v.value.get(R) || !1, y = x(R);
    return y == null || y.getTrackPublication(
      pe.Source.Microphone
    ), f;
  }, l = (R) => c.value.get(R) || 0, h = () => {
    var R;
    return ((R = i.value[0]) == null ? void 0 : R.identity) || null;
  }, N = (R) => v.value.get(R) || !1, m = (R) => {
    const f = x(R);
    return f != null && f.lastSpokeAt ? Date.now() - f.lastSpokeAt.getTime() < 1e4 : !1;
  }, H = () => {
    var R;
    return ((R = i.value[0]) == null ? void 0 : R.identity) || null;
  }, x = (R) => {
    const f = A.value;
    return f ? f.localParticipant.identity === R ? f.localParticipant : f.remoteParticipants.get(R) || null : null;
  }, U = () => {
    e.forEach((R, f) => {
      R.speakingSubscription.unsubscribe(), R.audioLevelSubscription.unsubscribe();
    }), e.clear(), v.value.clear(), c.value.clear();
  };
  return ut(() => {
    U();
  }), {
    // Main API methods
    getParticipantSpeakingStatus: r,
    getParticipantAudioLevel: l,
    getFirstActiveSpeaker: h,
    // Additional API methods (for useRoomLayout compatibility)
    getActiveSpeakerStatus: N,
    getRecentSpeakerStatus: m,
    getInstantActiveSpeaker: H,
    // Lifecycle management
    setupRemoteAudioAnalysis: t,
    cleanupAudioAnalysis: b,
    cleanup: U,
    // Reactive state for debugging/monitoring
    activeSpeakers: n(() => i.value),
    participantSpeakingStates: n(() => v.value),
    // 🌟 NEW: Debounced active speakers for layout updates (PHASE 3)
    debouncedActiveSpeakers: n(
      () => k.value.map((R) => R.identity)
    ),
    onActiveSpeakersChange: d
  };
}
function Mn() {
  const A = z([]), v = z(null), c = (t) => {
    v.value && (v.value.unsubscribe(), v.value = null);
    const b = sn(
      t,
      [pe.Source.Camera, pe.Source.Microphone, pe.Source.ScreenShare],
      {
        onlySubscribed: !1,
        // Get all tracks (subscribed and unsubscribed)
        additionalRoomEvents: [
          at.TrackMuted,
          at.TrackUnmuted,
          at.TrackPublished,
          at.TrackUnpublished,
          at.TrackSubscribed,
          at.TrackUnsubscribed
        ]
      }
    ).subscribe({
      next: ({ trackReferences: r }) => {
        A.value = r;
      },
      error: (r) => {
      }
    });
    v.value = b;
  }, e = (t, b) => A.value.filter(
    (r) => r.participant.identity === t && b.includes(r.source)
  );
  return {
    // State
    trackReferences: A,
    // Methods
    setupTrackObservable: c,
    getParticipantTrackReferences: e,
    hasVideoTrack: (t) => e(t, [
      pe.Source.Camera
    ]).some(
      (r) => {
        var l, h, N;
        return ((l = r.publication) == null ? void 0 : l.track) && ((h = r.publication) == null ? void 0 : h.isSubscribed) !== !1 && !((N = r.publication) != null && N.isMuted);
      }
    ),
    hasAudioTrack: (t) => e(t, [
      pe.Source.Microphone
    ]).some(
      (r) => {
        var l, h, N;
        return ((l = r.publication) == null ? void 0 : l.track) && ((h = r.publication) == null ? void 0 : h.isSubscribed) !== !1 && !((N = r.publication) != null && N.isMuted);
      }
    ),
    hasScreenShare: (t) => e(t, [
      pe.Source.ScreenShare
    ]).some(
      (r) => {
        var l, h;
        return ((l = r.publication) == null ? void 0 : l.track) && ((h = r.publication) == null ? void 0 : h.isSubscribed) !== !1;
      }
    ),
    cleanup: () => {
      v.value && (v.value.unsubscribe(), v.value = null), A.value = [];
    }
  };
}
function An() {
  const A = st(), { participants: v } = Ot(), c = z(!1), e = z(null), i = _a(/* @__PURE__ */ new Map()), k = (y) => {
    try {
      if (!y) return null;
      let _;
      return typeof y == "string" ? _ = JSON.parse(y) : _ = y, _.handRaised !== void 0 ? {
        handRaised: !!_.handRaised,
        timestamp: typeof _.handRaisedTimestamp == "number" ? _.handRaisedTimestamp : void 0
      } : null;
    } catch (_) {
      return null;
    }
  }, p = (y) => {
    const _ = A.value;
    if (!_) return JSON.stringify({ handRaised: y });
    let E = {};
    try {
      const V = _.localParticipant.metadata;
      V && (E = typeof V == "string" ? JSON.parse(V) : V);
    } catch (V) {
    }
    const j = y ? Date.now() : void 0, ee = bt(w({}, E), {
      handRaised: y,
      handRaisedTimestamp: j
    });
    return JSON.stringify(ee);
  }, d = (y) => i.get(y) || !1, t = (y) => {
    const _ = k(y.metadata);
    return (_ == null ? void 0 : _.handRaised) || !1;
  }, b = () => {
    const y = A.value;
    if (!y) return [];
    const _ = [];
    return t(y.localParticipant) && _.push(y.localParticipant), y.remoteParticipants.forEach((E) => {
      t(E) && _.push(E);
    }), _;
  }, r = n(() => b()), l = n(() => r.value.length), h = () => me(this, null, function* () {
    const y = A.value;
    if (y)
      try {
        const _ = !c.value, E = p(_);
        e.value = E, c.value = _, i.set(y.localParticipant.identity, _), yield y.localParticipant.setMetadata(E), setTimeout(() => {
          e.value === E && (e.value = null);
        }, 500);
      } catch (_) {
        const E = k(y.localParticipant.metadata);
        throw c.value = (E == null ? void 0 : E.handRaised) || !1, i.set(
          y.localParticipant.identity,
          c.value
        ), e.value = null, _;
      }
  }), N = () => me(this, null, function* () {
    c.value || (yield h());
  }), m = () => me(this, null, function* () {
    c.value && (yield h());
  });
  Re(
    () => {
      var y;
      return (y = A.value) == null ? void 0 : y.localParticipant.metadata;
    },
    (y) => {
      if (y !== void 0) {
        if (e.value && y === e.value)
          return;
        const _ = k(y), E = (_ == null ? void 0 : _.handRaised) || !1;
        if (E !== c.value) {
          c.value = E;
          const j = A.value;
          j != null && j.localParticipant.identity && i.set(
            j.localParticipant.identity,
            E
          );
        }
      }
    },
    { immediate: !0 }
  );
  const H = (y) => {
    if (!y.identity) return;
    const _ = k(y.metadata), E = (_ == null ? void 0 : _.handRaised) || !1;
    i.set(y.identity, E);
  }, x = (y) => {
    y.localParticipant && H(y.localParticipant), y.remoteParticipants.forEach((_) => {
      H(_);
    });
  }, U = (y) => {
    if (!y) return;
    const _ = (V, ie) => {
      const te = ie.metadata, Pe = k(te), Se = (Pe == null ? void 0 : Pe.handRaised) || !1;
      i.set(ie.identity, Se), ie.isLocal && (c.value = Se);
    }, E = /* @__PURE__ */ new Map(), j = (V) => {
      H(V);
      const ie = (te) => {
        const Pe = k(V.metadata), Se = (Pe == null ? void 0 : Pe.handRaised) || !1;
        i.set(V.identity, Se);
      };
      E.set(V.identity, ie), V.on(Ft.ParticipantMetadataChanged, ie);
    }, ee = (V) => {
      i.delete(V.identity);
      const ie = E.get(V.identity);
      ie && (V.off(Ft.ParticipantMetadataChanged, ie), E.delete(V.identity));
    };
    return x(y), y.on(at.ParticipantMetadataChanged, _), y.on(at.ParticipantConnected, j), y.on(at.ParticipantDisconnected, ee), y.remoteParticipants.forEach((V) => {
      const ie = (te) => {
        const Pe = k(V.metadata), Se = (Pe == null ? void 0 : Pe.handRaised) || !1;
        i.set(V.identity, Se);
      };
      E.set(V.identity, ie), V.on(Ft.ParticipantMetadataChanged, ie);
    }), () => {
      y.off(at.ParticipantMetadataChanged, _), y.off(at.ParticipantConnected, j), y.off(at.ParticipantDisconnected, ee), y.remoteParticipants.forEach((V) => {
        const ie = E.get(V.identity);
        ie && V.off(Ft.ParticipantMetadataChanged, ie);
      }), E.clear();
    };
  };
  let R = null;
  It(() => {
    const y = A.value;
    if (R && (R(), R = null), y && y.state === "connected")
      R = U(y);
    else if (y) {
      const _ = () => {
        R && R(), R = U(y);
      };
      y.once(at.Connected, _), R = () => {
        y.off(at.Connected, _);
      };
    }
  }), Re(
    () => v.value,
    (y) => {
      y.forEach((_) => {
        i.has(_.identity) || H(_);
      });
    },
    { immediate: !0, deep: !1 }
  );
  const f = () => {
    R && (R(), R = null), i.clear();
  };
  return {
    // Local state
    isHandRaised: Gt(c),
    toggleRaiseHand: h,
    raiseHand: N,
    lowerHand: m,
    // Global state
    getParticipantHandState: d,
    getRaisedHandParticipants: b,
    isParticipantHandRaised: t,
    // Reactive state
    raisedHandCount: Gt(l),
    raisedHandParticipants: Gt(r),
    // Cleanup
    cleanup: f
  };
}
const En = ["👍", "❤️", "😂", "👏", "🎉", "😮"];
function xn(A = {}) {
  const {
    maxReactions: v = 20,
    reactionDuration: c = 5200,
    // Slightly longer than CSS animation (5000ms) to ensure cleanup after animation
    topic: e = "reactions"
  } = A, i = st(), k = z([]), p = /* @__PURE__ */ new Map(), d = Oa({
    onDataReceived: (m) => {
      if (m.topic === e)
        try {
          const H = new TextDecoder().decode(m.data), x = JSON.parse(H);
          if (x.type !== "reaction") return;
          const U = m.participant;
          if (!U) return;
          const R = {
            id: `reaction-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
            emoji: x.emoji,
            participantId: U.identity,
            participantName: U.name || U.identity,
            timestamp: m.timestamp,
            x: Math.random() * 100
            // Random position 0-100% (component will add padding)
          };
          t(R);
        } catch (H) {
        }
    }
  }), t = (m) => {
    if (k.value.push(m), k.value.length > v) {
      const x = k.value.shift();
      x && r(x.id);
    }
    const H = setTimeout(() => {
      b(m.id);
    }, c);
    p.set(m.id, H);
  }, b = (m) => {
    const H = k.value.findIndex((x) => x.id === m);
    H !== -1 && (k.value.splice(H, 1), r(m));
  }, r = (m) => {
    const H = p.get(m);
    H && (clearTimeout(H), p.delete(m));
  }, l = (m) => me(this, null, function* () {
    const H = i.value;
    if (!H)
      return;
    const x = H.localParticipant;
    if (x)
      try {
        yield d.sendJSON(
          {
            type: "reaction",
            emoji: m
          },
          { topic: e, reliable: !1 }
          // Use unreliable for reactions (faster, ok to drop)
        );
        const U = {
          id: `reaction-${Date.now()}-${Math.random().toString(36).substring(2, 6)}`,
          emoji: m,
          participantId: x.identity,
          participantName: x.name || "You",
          timestamp: Date.now(),
          x: Math.random() * 100
          // Random position 0-100% (component will add padding)
        };
        t(U);
      } catch (U) {
        throw U;
      }
  }), h = () => {
    p.forEach((m) => clearTimeout(m)), p.clear(), k.value = [];
  }, N = () => {
    h(), d.clearMessages();
  };
  return ut(() => {
    N();
  }), {
    reactions: k,
    availableEmojis: En,
    sendReaction: l,
    clearReactions: h,
    cleanup: N
  };
}
const zn = { class: "room-provider" }, In = /* @__PURE__ */ Ue({
  __name: "RoomProvider",
  props: {
    role: { default: "attendee" },
    title: { default: "" },
    description: { default: "" },
    token: {},
    platform: {}
  },
  setup(A) {
    const v = A;
    Va({
      roomOptions: {
        adaptiveStream: {
          pixelDensity: "screen"
        },
        dynacast: !0,
        // Enhanced audio capture defaults
        audioCaptureDefaults: Wa,
        videoCaptureDefaults: {
          resolution: ca.h1080.resolution
        },
        publishDefaults: {
          simulcast: !0,
          dtx: !0,
          red: !0,
          videoEncoding: ca.h1080.encoding,
          screenShareEncoding: rn.h1080fps15.encoding
        }
      }
    });
    const c = ja(v.role), e = Ua({ skipMediaPermissions: !1 });
    tt("roomControls", e);
    const i = Ot();
    tt("participants", i);
    const k = Tn();
    tt("speechDetection", k);
    const p = Mn();
    tt("trackReferences", p);
    const d = An();
    tt("raiseHand", d);
    const t = xn({
      maxReactions: 20,
      reactionDuration: 4e3,
      topic: "reactions"
    });
    tt("reactions", t);
    const b = Rn(p, k, d);
    tt("roomLayout", b);
    const r = st(), { connectionState: l } = _t(), h = n(() => l.value === "connected"), N = n(() => r.value && h.value && r.value.name || "");
    tt("assetId", N), tt(
      "platform",
      n(() => v.platform)
    );
    const m = z(""), H = (x) => {
      m.value = x;
    };
    return tt("sessionToken", m), tt("setSessionToken", H), It(() => {
      r.value && h.value && p.setupTrackObservable(r.value);
    }), Re(
      () => p.trackReferences.value,
      () => {
        b.triggerScreenShareUpdate();
      },
      { immediate: !1 }
      // Don't trigger on initial setup
    ), Re(
      () => v.token,
      (x) => {
        x && ln(x);
      },
      { immediate: !0 }
      // Run immediately to handle initial token if present
    ), ht(() => {
      (v.title || v.description) && c.setRoomInfo(v.title, v.description);
    }), ut(() => {
      k.cleanup(), p.cleanup(), d.cleanup(), t.cleanup();
    }), (x, U) => (o(), u("div", zn, [
      Lt(x.$slots, "default", {}, void 0, !0)
    ]));
  }
}), Ts = /* @__PURE__ */ We(In, [["__scopeId", "data-v-465d16de"]]), $n = ["muted"], Ln = /* @__PURE__ */ Ue({
  inheritAttrs: !1,
  __name: "ParticipantVideo",
  props: {
    participant: {},
    videoRefHandler: {},
    muted: { type: Boolean, default: !1 },
    videoClass: { default: "participant-video" },
    trackSource: { default: pe.Source.Camera }
  },
  setup(A) {
    const v = A;
    return (c, e) => (o(), u("video", Fa({
      ref: (i) => c.videoRefHandler(c.participant.identity, i, v.trackSource),
      autoplay: "",
      playsinline: "",
      muted: c.muted,
      class: c.videoClass
    }, c.$attrs), null, 16, $n));
  }
}), Bn = /* @__PURE__ */ We(Ln, [["__scopeId", "data-v-487bad4f"]]);
function _n() {
  const A = st(), { remoteParticipants: v } = Ot(), c = z(/* @__PURE__ */ new Map()), e = z(/* @__PURE__ */ new Map());
  return {
    // State
    participantVideoRefs: c,
    attachedTracks: e,
    // Methods
    setParticipantVideoRef: (t, b, r = pe.Source.Camera) => {
      var N, m;
      const l = `${t}-${r}`, h = c.value.get(l);
      if (h !== b)
        if (b && b instanceof HTMLVideoElement) {
          const H = e.value.get(l);
          if (H && h)
            try {
              H.detach(h), e.value.delete(l);
            } catch (y) {
            }
          c.value.set(l, b);
          const x = (N = v.value) == null ? void 0 : N.find(
            (y) => y.identity === t
          ), U = (m = A.value) == null ? void 0 : m.localParticipant, R = (U == null ? void 0 : U.identity) === t, f = x || (R ? U : null);
          if (f) {
            const y = Array.from(
              f.videoTrackPublications.values()
            ).find((_) => {
              const E = _.source === r;
              return x ? _.track && _.kind === "video" && _.isSubscribed && E : _.track && _.kind === "video" && E;
            });
            if (y != null && y.track && !e.value.has(l))
              try {
                y.track.attach(b), e.value.set(l, y.track);
              } catch (_) {
              }
            else y != null && y.track;
          }
        } else {
          const H = e.value.get(l);
          if (H && h)
            try {
              H.detach(h);
            } catch (x) {
            }
          c.value.delete(l), e.value.delete(l);
        }
    },
    updateParticipantVideoTrack: (t, b) => {
      const r = c.value.get(t);
      if (!r)
        return;
      const l = e.value.get(t);
      if (l)
        try {
          l.detach(r);
        } catch (h) {
        }
      try {
        b.attach(r), e.value.set(t, b);
      } catch (h) {
      }
    },
    clearParticipantVideo: (t, b) => {
      const r = c.value.get(t), l = e.value.get(t);
      b && r ? (b.detach(r), e.value.delete(t)) : l && r ? (l.detach(r), e.value.delete(t)) : r && (r.srcObject = null);
    },
    cleanup: () => {
      e.value.forEach((t, b) => {
        const r = c.value.get(b);
        if (r)
          try {
            t.detach(r);
          } catch (l) {
          }
      }), e.value.clear(), c.value.clear();
    }
  };
}
function Fn() {
  return {
    updateParticipantAudioTrack: (e, i, k) => {
      try {
        const p = i.attach();
        p.setAttribute("data-participant", e.identity), p.autoplay = !0, p.setAttribute("playsinline", "true"), document.body.appendChild(p);
      } catch (p) {
      }
    },
    clearParticipantAudio: (e, i) => {
      i ? i.detach() : document.querySelectorAll(
        `[data-participant="${e}"]`
      ).forEach((p) => p.remove());
    },
    cleanupAllAudioTracks: () => {
      document.querySelectorAll("[data-participant]").forEach((i) => i.remove());
    }
  };
}
function Ut() {
  const A = st(), v = Vt(), { isConnected: c } = _t(), e = n(() => c());
  return {
    // State
    inRoomMode: e,
    // Participant helpers
    getLocalParticipant: () => {
      if (e.value)
        try {
          return v;
        } catch (m) {
          return null;
        }
      return null;
    },
    isLocalParticipant: (m) => {
      var x;
      const H = (x = A.value) == null ? void 0 : x.localParticipant;
      return H ? m.identity === H.identity : !1;
    },
    getParticipantRole: (m) => {
      try {
        return m.metadata && JSON.parse(m.metadata).role || "attendee";
      } catch (H) {
        return "attendee";
      }
    },
    getParticipantDisplayName: (m) => m.name || m.identity,
    hasAnyVideoTrack: (m) => m.videoTrackPublications.size > 0,
    hasAnyAudioTrack: (m) => m.audioTrackPublications.size > 0,
    getParticipantConnectionQuality: (m) => {
      switch (m.connectionQuality) {
        case Dt.Unknown:
          return "unknown";
        case Dt.Poor:
          return "poor";
        case Dt.Good:
          return "good";
        case Dt.Excellent:
          return "excellent";
        default:
          return "unknown";
      }
    },
    // Room helpers
    formatParticipantCount: (m) => m === 1 ? "1 participant" : `${m} participants`,
    hasActiveSpeakers: (m) => m.some((H) => H.isSpeaking),
    getSpeakingParticipants: (m) => m.filter((H) => H.isSpeaking)
  };
}
const Dn = /* @__PURE__ */ Ue({
  __name: "ParticipantTag",
  props: {
    participant: {},
    isPinned: { type: Boolean },
    isMicrophoneEnabled: { type: Boolean, default: !0 },
    fontSize: { default: 12 },
    iconSize: { default: 12 },
    maxWidth: { default: "calc(100% - 16px)" },
    bottomOffset: { default: 8 },
    leftOffset: { default: 8 },
    padding: {},
    borderRadius: { default: 16 },
    trackSource: { default: pe.Source.Camera }
  },
  setup(A) {
    const v = A, { getParticipantRole: c } = Ut(), e = n(() => {
      var p;
      return (p = v == null ? void 0 : v.participant) != null && p.isLocal ? "You" : c(v == null ? void 0 : v.participant) === "host" ? "Host" : null;
    }), i = n(() => {
      const k = v.participant.name || v.participant.identity;
      return v.trackSource === pe.Source.ScreenShare ? `${k}'s screen` : k;
    });
    return (k, p) => (o(), u("div", {
      class: "participant-tag",
      style: I({
        bottom: `${k.bottomOffset}px`,
        left: `${k.leftOffset}px`
      })
    }, [
      a("div", {
        class: "tag-content",
        style: I({
          maxWidth: k.maxWidth,
          padding: k.padding,
          borderRadius: `${k.borderRadius}px`
        })
      }, [
        k.isMicrophoneEnabled ? D("", !0) : (o(), Ce(ft, {
          key: 0,
          size: k.iconSize,
          variant: "mute",
          class: "mic-icon"
        }, null, 8, ["size"])),
        k.isPinned ? (o(), Ce(ya, {
          key: 1,
          size: k.iconSize,
          class: "pin-icon"
        }, null, 8, ["size"])) : D("", !0),
        a("span", {
          class: "participant-name",
          style: I({
            fontSize: `${k.fontSize}px`
          })
        }, ce(i.value) + ce(e.value ? ` (${e.value})` : ""), 5)
      ], 4)
    ], 4));
  }
}), Hn = /* @__PURE__ */ We(Dn, [["__scopeId", "data-v-bc836abf"]]), Nn = ["data-size"], On = {
  key: 1,
  class: "tile-avatar"
}, Vn = ["title"], jn = 500, Un = 300, Wn = /* @__PURE__ */ Ue({
  __name: "ParticipantTile",
  props: {
    participant: {},
    participantMetadata: {},
    videoRefHandler: {},
    size: { default: "medium" },
    avatarSize: { default: "medium" },
    showRole: { type: Boolean, default: !0 },
    showStatus: { type: Boolean, default: !0 },
    isPinned: { type: Boolean, default: !1 },
    isLocal: { type: Boolean, default: !1 },
    clickAction: { default: "pin" },
    hasVideoTrack: { type: Boolean, default: !1 },
    hasAudioTrack: { type: Boolean, default: !1 },
    hasScreenShare: { type: Boolean, default: !1 },
    trackSource: { default: pe.Source.Camera },
    isSpeaking: { type: Boolean, default: void 0 },
    audioLevel: { default: void 0 },
    tagFontSize: { default: 14 },
    tagIconSize: { default: 14 }
  },
  emits: ["tile-click", "pin-click"],
  setup(A, { emit: v }) {
    const c = new fa(), e = ta(), i = A, k = v, p = Vt(), d = we("raiseHand"), t = we("speechDetection"), b = st(), r = Ut(), l = we("sessionToken", z("")), h = n(() => {
      var S;
      const s = (S = b.value) == null ? void 0 : S.localParticipant;
      return s ? r.getParticipantRole(s) === "host" : !1;
    }), N = n(() => {
      var s;
      return ((s = b.value) == null ? void 0 : s.name) || "";
    }), m = z(!1), H = z({ top: 0, left: 0 }), x = z(!1), U = n(() => i.isSpeaking !== void 0 ? i.isSpeaking : t.getParticipantSpeakingStatus(
      i.participant.identity
    )), R = n(() => i.audioLevel !== void 0 ? i.audioLevel : t.getParticipantAudioLevel(i.participant.identity)), f = n(() => U.value), y = n(() => (d == null ? void 0 : d.getParticipantHandState(i.participant.identity)) || !1);
    Re(y, (s, S) => {
      s == !0 && S == !1 && e.playSound(Nt.HAND_RAISED);
    });
    const _ = n(() => {
      var s;
      return i.isLocal ? p.isMicrophoneEnabled.value : (s = i.hasAudioTrack) != null ? s : !0;
    }), E = n(() => i.isLocal ? p.isCameraEnabled.value : i.hasVideoTrack), j = n(() => i.trackSource === pe.Source.ScreenShare ? !0 : E.value), ee = z(!1), V = z(!1);
    let ie = null, te = null;
    const Pe = () => {
      ee.value = !0, ie && (clearTimeout(ie), ie = null), ie = setTimeout(() => {
        ee.value && (V.value = !0);
      }, Un);
    }, Se = () => {
      ee.value = !1, ie && (clearTimeout(ie), ie = null), m.value || (V.value = !1);
    }, Ye = (s) => {
      if (i.clickAction === "none") return;
      te && clearTimeout(te);
      const S = s.currentTarget;
      S && (te = setTimeout(() => {
        const F = S.getBoundingClientRect(), Z = F.left + F.width / 2, W = F.top + F.height / 2;
        H.value = {
          top: W,
          left: Z
        }, x.value = !0, m.value = !0;
      }, jn));
    }, Fe = () => {
      te && (clearTimeout(te), te = null);
    }, Qe = () => {
      te && (clearTimeout(te), te = null);
    }, Q = () => {
      i.clickAction !== "none" && k("tile-click", {
        participant: i.participant,
        action: i.clickAction
      });
    }, be = (s) => {
      s.stopPropagation();
      const F = s.currentTarget.getBoundingClientRect();
      H.value = {
        top: F.bottom + 8,
        left: F.right
        // Position at button's right edge, CSS will align from right
      }, x.value = !1, m.value = !0;
    }, he = () => {
      m.value = !1, V.value = !1;
    }, ye = () => me(this, null, function* () {
      const s = N.value, S = l.value;
      if (!(!s || !S))
        try {
          (yield c.moderateParticipants(
            s,
            S,
            {
              action: $e.MUTE_MIC,
              participantIdentities: [i.participant.identity]
            }
          )).status;
        } catch (F) {
        } finally {
          m.value = !1, V.value = !1;
        }
    }), xe = () => {
      k("pin-click", {
        participant: i.participant,
        isPinned: i.isPinned,
        trackSource: i.trackSource
      }), m.value = !1, V.value = !1;
    }, Te = () => me(this, null, function* () {
      const s = N.value, S = l.value;
      if (!(!s || !S))
        try {
          (yield c.moderateParticipants(
            s,
            S,
            {
              action: $e.KICK,
              participantIdentities: [i.participant.identity]
            }
          )).status;
        } catch (F) {
        } finally {
          m.value = !1, V.value = !1;
        }
    }), Je = n(() => {
      switch (i.size) {
        case "small":
          return 12;
        case "medium":
          return 16;
        case "large":
          return 18;
        case "fullscreen":
          return 20;
        default:
          return 16;
      }
    }), Ge = n(() => {
      const s = i.participant.name || i.participant.identity;
      function S(ze) {
        let oe = 0;
        for (let Ae = 0; Ae < ze.length; Ae++)
          oe = ze.charCodeAt(Ae) + ((oe << 5) - oe);
        return oe;
      }
      function F(ze) {
        const oe = Math.abs(S(ze)), Ae = oe % 360, nt = 15 + oe % 15, J = 25 + oe % 15;
        return { hue: Ae, sat: nt, light: J };
      }
      const { hue: Z, sat: W, light: Me } = F(s);
      return {
        gradient: `radial-gradient(circle at 50% 40%,
    hsl(${Z}, ${W}%, ${Me + 8}%) 0%,
    hsl(${Z}, ${W}%, ${Me - 5}%) 100%)`,
        hue: Z,
        sat: W,
        light: Me,
        // 🎨 AVATAR: Slightly darker version for depth
        avatarColor: `hsl(${Z}, ${Math.min(W + 5, 35)}%, ${Math.max(
          Me - 8,
          15
        )}%)`,
        // 🎨 TEXT: Always white for dark backgrounds
        textColor: "#ffffff",
        // 🎨 SPEAKING: More vibrant but still elegant for speaking effects
        speakingColor: `hsl(${Z}, ${Math.min(W + 25, 60)}%, ${Math.min(
          Me + 20,
          55
        )}%)`,
        speakingColorRgba: `hsla(${Z}, ${Math.min(W + 25, 60)}%, ${Math.min(
          Me + 20,
          55
        )}%, 0.4)`
      };
    });
    return ut(() => {
      ie && (clearTimeout(ie), ie = null), te && (clearTimeout(te), te = null);
    }), (s, S) => {
      var F;
      return o(), u("div", {
        class: Be(["participant-tile", {
          speaking: f.value,
          muted: !_.value,
          "camera-off": !E.value,
          local: s.isLocal
        }]),
        "data-size": s.size,
        style: I({ background: Ge.value.gradient }),
        onClick: Q,
        onMouseenter: Pe,
        onMouseleave: Se,
        onMousedown: Ye,
        onMouseup: Fe,
        onTouchstart: Ye,
        onTouchend: Fe,
        onTouchcancel: Qe,
        onContextmenu: S[1] || (S[1] = je(() => {
        }, ["prevent"]))
      }, [
        j.value ? (o(), Ce(Bn, {
          key: 0,
          participant: s.participant,
          "video-ref-handler": s.videoRefHandler,
          "track-source": i.trackSource,
          muted: s.isLocal,
          class: "tile-video"
        }, null, 8, ["participant", "video-ref-handler", "track-source", "muted"])) : (o(), u("div", On, [
          q(jt, {
            name: s.participant.name || s.participant.identity,
            image: (F = s.participantMetadata) == null ? void 0 : F.avatar,
            size: s.avatarSize,
            "is-speaking": U.value,
            "audio-level": R.value,
            "background-color": Ge.value.avatarColor,
            "text-color": Ge.value.textColor,
            "speaking-ring-color": Ge.value.speakingColor
          }, null, 8, ["name", "image", "size", "is-speaking", "audio-level", "background-color", "text-color", "speaking-ring-color"])
        ])),
        V.value && s.clickAction === "pin" ? (o(), u("button", {
          key: 2,
          class: Be(["menu-button", { "menu-animate-in": V.value }]),
          title: "Options",
          onClick: je(be, ["stop"])
        }, [
          q(ga, {
            size: Je.value,
            color: "#ffffff",
            align: "vertical"
          }, null, 8, ["size"])
        ], 2)) : D("", !0),
        y.value ? (o(), u("div", {
          key: 3,
          class: "hand-raised-indicator",
          title: `${s.participant.name || s.participant.identity} has raised their hand`
        }, S[2] || (S[2] = [
          a("span", { class: "hand-emoji" }, "✋", -1)
        ]), 8, Vn)) : D("", !0),
        q(Hn, {
          participant: s.participant,
          "is-pinned": s.isPinned,
          "is-microphone-enabled": _.value,
          "font-size": s.tagFontSize,
          "icon-size": s.tagIconSize,
          "bottom-offset": 4,
          "left-offset": 10,
          "track-source": i.trackSource
        }, null, 8, ["participant", "is-pinned", "is-microphone-enabled", "font-size", "icon-size", "track-source"]),
        (o(), Ce(Yt, { to: "body" }, [
          m.value ? (o(), u("div", {
            key: 0,
            class: Be(["tile-moderation-dropdown", [
              `dropdown-size-${s.size}`,
              { "dropdown-centered": x.value }
            ]]),
            style: I({
              position: "fixed",
              top: `${H.value.top}px`,
              left: `${H.value.left}px`,
              zIndex: 9999
            }),
            onClick: S[0] || (S[0] = je(() => {
            }, ["stop"]))
          }, [
            h.value && !s.isLocal ? (o(), u("button", {
              key: 0,
              class: "dropdown-item",
              onClick: ye
            }, [
              q(ft, {
                variant: "mute",
                size: 14
              }),
              S[3] || (S[3] = a("span", null, "Mute", -1))
            ])) : D("", !0),
            a("button", {
              class: "dropdown-item",
              onClick: xe
            }, [
              q(ya, {
                variant: s.isPinned ? "on" : "off",
                size: 14
              }, null, 8, ["variant"]),
              a("span", null, ce(s.isPinned ? "Unpin" : "Pin"), 1)
            ]),
            h.value && !s.isLocal ? (o(), u("button", {
              key: 1,
              class: "dropdown-item dropdown-item-danger",
              onClick: Te
            }, S[4] || (S[4] = [
              a("svg", {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "currentColor"
              }, [
                a("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })
              ], -1),
              a("span", null, "Remove", -1)
            ]))) : D("", !0)
          ], 6)) : D("", !0)
        ])),
        m.value ? (o(), u("div", {
          key: 4,
          class: "dropdown-backdrop",
          onClick: he
        })) : D("", !0)
      ], 46, Nn);
    };
  }
}), Bt = /* @__PURE__ */ We(Wn, [["__scopeId", "data-v-c60d6f8f"]]), Gn = /* @__PURE__ */ Ue({
  __name: "StageGrid",
  props: {
    entities: {},
    pinnedItems: {},
    deviceType: {},
    maxTiles: {},
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    hasScreenShare: { type: Function },
    getSpeakingStatus: { type: Function }
  },
  emits: ["tile-click", "pin-click"],
  setup(A) {
    let v = null;
    const c = A, e = z(null), i = st(), k = we("participants"), { getParticipantMetadata: p } = k, { width: d, height: t } = ha(e), b = (x) => {
      var R;
      const U = (R = i.value) == null ? void 0 : R.localParticipant;
      return U ? x.identity === U.identity : !1;
    }, r = (x) => {
      var U;
      if (x.type === "participant" && x.participant)
        return x.participant;
      if (x.type === "screen-share" && ((U = x.screenShare) != null && U.participant))
        return x.screenShare.participant;
      throw new Error(`Invalid entity: ${x.id}`);
    }, l = (x) => p(r(x).identity), h = (x) => x.type === "screen-share" ? pe.Source.ScreenShare : pe.Source.Camera, N = n(() => c.entities.slice(0, c.maxTiles)), m = () => me(this, null, function* () {
      if (e.value)
        try {
          const { default: x } = yield import("./opentok-layout-BuF3SIj8.js").then((U) => U.o);
          v = x(e.value, {
            maxRatio: 3 / 2,
            // Maximum aspect ratio
            minRatio: 9 / 16,
            // Minimum aspect ratio (portrait)
            fixedRatio: !1,
            // Allow flexible ratios
            alignItems: "center",
            bigClass: "stage-tile-big",
            bigPercentage: 0.8,
            // 80% for main tiles in focus mode
            bigFixedRatio: !1,
            bigMaxRatio: 3 / 2,
            bigMinRatio: 9 / 16,
            bigFirst: !0,
            // Big elements first
            animate: !0,
            // Smooth transitions
            scaleLastRow: !0,
            // Scale the last row to fit
            ignoreClass: "stage-tile-ignore"
          });
        } catch (x) {
        }
    }), H = () => {
      !v || !e.value || $t(() => {
        try {
          v.layout();
        } catch (x) {
        }
      });
    };
    return Re(
      N,
      () => {
        H();
      },
      { deep: !0 }
    ), Re([d, t], ([x, U]) => {
      (x > 0 || U > 0) && setTimeout(() => {
        H();
      }, 100);
    }), ht(() => me(this, null, function* () {
      yield m(), H();
    })), ut(() => {
      v && (v = null);
    }), (x, U) => (o(), u("div", {
      ref_key: "stageContainer",
      ref: e,
      class: "stage-grid"
    }, [
      (o(!0), u(Le, null, Xe(N.value, (R) => (o(), Ce(Bt, {
        key: R.id,
        participant: r(R),
        "participant-metadata": l(R),
        "video-ref-handler": x.videoRefHandler,
        size: "medium",
        "avatar-size": "medium",
        "click-action": "pin",
        "is-pinned": x.pinnedItems.some((f) => (f == null ? void 0 : f.id) === R.id),
        "is-local": b(r(R)),
        "has-video-track": x.hasVideoTrack(r(R).identity),
        "has-audio-track": x.hasAudioTrack(r(R).identity),
        "has-screen-share": x.hasScreenShare(r(R).identity),
        "is-speaking": x.getSpeakingStatus(r(R).identity),
        "track-source": h(R),
        class: "stage-tile",
        onTileClick: U[0] || (U[0] = (f) => x.$emit("tile-click", f)),
        onPinClick: U[1] || (U[1] = (f) => x.$emit("pin-click", f))
      }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "is-pinned", "is-local", "has-video-track", "has-audio-track", "has-screen-share", "is-speaking", "track-source"]))), 128))
    ], 512));
  }
}), ka = /* @__PURE__ */ We(Gn, [["__scopeId", "data-v-18e03a2a"]]), Zn = { class: "page-indicator" }, Kn = { class: "page-indicator" }, Yn = {
  key: 2,
  class: "pagination-dots"
}, Jn = ["aria-label", "onClick"], Xn = 50, Qn = /* @__PURE__ */ Ue({
  __name: "StageArea",
  props: {
    stageZone: {},
    pinnedItems: {},
    deviceType: {},
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    hasScreenShare: { type: Function },
    getSpeakingStatus: { type: Function },
    getAudioLevel: { type: Function }
  },
  emits: ["tile-click", "pin-click"],
  setup(A, { emit: v }) {
    const c = we("roomLayout"), e = A, i = v, k = z(1), p = z(0), d = z(0), t = z(0), b = z(0), r = n(() => {
      switch (e.deviceType) {
        case "mobile":
          return 6;
        case "tablet":
          return 12;
        case "desktop":
          return 16;
        default:
          return 16;
      }
    }), l = n(() => Math.ceil(e.stageZone.entities.length / r.value)), h = n(() => {
      const E = (k.value - 1) * r.value, j = E + r.value;
      return e.stageZone.entities.slice(E, j);
    }), N = () => {
      k.value < l.value && k.value++;
    }, m = () => {
      k.value > 1 && k.value--;
    }, H = (E) => {
      E >= 1 && E <= l.value && (k.value = E);
    }, x = (E) => {
      l.value <= 1 || (p.value = E.touches[0].clientX, d.value = E.touches[0].clientY, t.value = p.value, b.value = d.value);
    }, U = (E) => {
      l.value <= 1 || (t.value = E.touches[0].clientX, b.value = E.touches[0].clientY);
    }, R = () => {
      if (l.value <= 1) return;
      const E = t.value - p.value, j = b.value - d.value;
      Math.abs(E) > Math.abs(j) && Math.abs(E) > Xn && (E > 0 ? m() : N()), p.value = 0, d.value = 0, t.value = 0, b.value = 0;
    };
    Re(
      () => e.stageZone.entities.length,
      () => {
        k.value > l.value && l.value > 0 && (k.value = l.value);
      }
    );
    const f = (E) => {
      l.value <= 1 || (E.key === "ArrowLeft" ? (E.preventDefault(), m()) : E.key === "ArrowRight" && (E.preventDefault(), N()));
    };
    ht(() => {
      window.addEventListener("keydown", f);
    }), ut(() => {
      window.removeEventListener("keydown", f);
    }), Re(
      h,
      (E) => {
        const j = E.map((ee) => {
          var V;
          return (V = ee.participant) == null ? void 0 : V.identity;
        }).filter((ee) => !!ee);
        c.updateStageVisibleParticipants(j);
      },
      { immediate: !0 }
    );
    const y = (E) => {
      const j = e.pinnedItems.includes(E.participant);
      i("tile-click", {
        participant: E.participant,
        action: j ? "unpin" : "pin"
      });
    }, _ = (E) => {
      i("pin-click", E);
    };
    return (E, j) => (o(), u("div", {
      class: Be(["stage-area", `stage-mode-${E.stageZone.mode}`]),
      onTouchstart: x,
      onTouchmove: U,
      onTouchend: R
    }, [
      l.value > 1 && k.value > 1 ? (o(), u("button", {
        key: 0,
        class: "pagination-button pagination-prev",
        "aria-label": "Previous page",
        onClick: m
      }, [
        j[0] || (j[0] = a("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          a("path", {
            d: "M15 18l-6-6 6-6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        a("span", Zn, ce(k.value - 1) + "/" + ce(l.value), 1)
      ])) : D("", !0),
      q(ka, {
        entities: h.value,
        "pinned-items": E.pinnedItems,
        "device-type": E.deviceType,
        "max-tiles": r.value,
        "stage-mode": E.stageZone.mode,
        "video-ref-handler": E.videoRefHandler,
        "has-video-track": E.hasVideoTrack,
        "has-audio-track": E.hasAudioTrack,
        "has-screen-share": E.hasScreenShare,
        "get-speaking-status": E.getSpeakingStatus,
        "get-audio-level": E.getAudioLevel,
        onTileClick: y,
        onPinClick: _
      }, null, 8, ["entities", "pinned-items", "device-type", "max-tiles", "stage-mode", "video-ref-handler", "has-video-track", "has-audio-track", "has-screen-share", "get-speaking-status", "get-audio-level"]),
      l.value > 1 && k.value < l.value ? (o(), u("button", {
        key: 1,
        class: "pagination-button pagination-next",
        "aria-label": "Next page",
        onClick: N
      }, [
        j[1] || (j[1] = a("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none"
        }, [
          a("path", {
            d: "M9 18l6-6-6-6",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        a("span", Kn, ce(k.value + 1) + "/" + ce(l.value), 1)
      ])) : D("", !0),
      l.value > 1 ? (o(), u("div", Yn, [
        (o(!0), u(Le, null, Xe(l.value, (ee) => (o(), u("button", {
          key: ee,
          class: Be(["pagination-dot", { active: k.value === ee }]),
          "aria-label": `Go to page ${ee}`,
          onClick: (V) => H(ee)
        }, null, 10, Jn))), 128))
      ])) : D("", !0)
    ], 34));
  }
}), qn = /* @__PURE__ */ We(Qn, [["__scopeId", "data-v-c84dd164"]]), ei = {
  key: 1,
  class: "search-container"
}, ti = ["onClick", "onMouseenter", "onMouseleave"], ai = ["disabled", "onClick"], ni = ["disabled", "onClick"], ii = ["onClick"], oi = { class: "dropdown-section" }, si = { class: "dropdown-section" }, ri = { class: "dropdown-section" }, li = { class: "dropdown-section" }, ci = /* @__PURE__ */ Ue({
  __name: "ParticipantsList",
  props: {
    title: {},
    hideHeader: { type: Boolean, default: !1 },
    showCloseButton: { type: Boolean, default: !1 },
    showRoles: { type: Boolean, default: !0 },
    showMoreOptions: { type: Boolean, default: !1 },
    showFooterActions: { type: Boolean, default: !1 },
    showMuteAllButton: { type: Boolean, default: !0 },
    showSearch: { type: Boolean, default: !0 },
    enableMediaControls: { type: Boolean, default: !1 },
    sortBy: { default: "role" },
    avatarSize: { default: "small" },
    iconSize: { default: 20 },
    containerStyle: {},
    headerStyle: {},
    titleStyle: {},
    closeButtonStyle: {},
    scrollAreaStyle: {},
    itemStyle: {},
    avatarContainerStyle: {},
    avatarBackgroundColor: {},
    avatarTextColor: {},
    avatarBorderColor: {},
    infoContainerStyle: {},
    nameStyle: {},
    roleStyle: {},
    controlsContainerStyle: {},
    audioButtonStyle: {},
    videoButtonStyle: {},
    moreOptionsButtonStyle: {},
    footerStyle: {},
    muteAllButtonStyle: {},
    getMediaButtonStyle: {}
  },
  emits: ["close", "participant-click", "participant-audio-toggle", "participant-video-toggle", "participant-more-options", "participant-muted", "participant-kicked"],
  setup(A, { emit: v }) {
    const c = new fa(), e = A, i = v, k = st(), p = Ut(), d = we("trackReferences"), t = we("speechDetection"), b = we("participants"), r = we("sessionToken", z("")), { participantCount: l, remoteParticipants: h, getParticipantMetadata: N } = b, m = n(() => {
      var S;
      const s = (S = k.value) == null ? void 0 : S.localParticipant;
      return s ? p.getParticipantRole(s) === "host" : !1;
    }), H = n(() => {
      var s;
      return ((s = k.value) == null ? void 0 : s.name) || "";
    }), x = n(() => {
      var F;
      const s = [], S = (F = k.value) == null ? void 0 : F.localParticipant;
      return S && s.push(S), h.value && s.push(...h.value), s;
    }), U = n(() => {
      const s = [...x.value];
      switch (e.sortBy) {
        case "name":
          return s.sort((S, F) => {
            const Z = V(S).toLowerCase(), W = V(F).toLowerCase();
            return Z.localeCompare(W);
          });
        case "role":
          return s.sort((S, F) => {
            const Z = ie(S), W = ie(F);
            return Z === "host" && W !== "host" ? -1 : Z !== "host" && W === "host" ? 1 : 0;
          });
        case "speaking":
          return s.sort((S, F) => {
            const Z = Se(S.identity), W = Se(F.identity);
            return Z && !W ? -1 : !Z && W ? 1 : 0;
          });
        case "joinTime":
        default:
          return s;
      }
    }), R = z(""), f = (s) => {
      const F = ".*" + s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").split("").join(".*") + ".*";
      return new RegExp(F, "i");
    }, y = (s, S) => S.trim() ? f(S.trim()).test(s) : !0, _ = n(() => R.value.trim() ? U.value.filter((s) => {
      const S = V(s);
      return y(S, R.value);
    }) : U.value), E = z(null), j = z(null), ee = z({ top: 0, left: 0 }), V = (s) => p.getParticipantDisplayName(s), ie = (s) => {
      const S = p.getParticipantRole(s);
      return s.isLocal ? S === "host" ? "Host (You)" : "You" : S === "host" ? "Host" : "";
    }, te = (s) => d.hasVideoTrack(s), Pe = (s) => d.hasAudioTrack(s), Se = (s) => (t == null ? void 0 : t.getParticipantSpeakingStatus(s)) || !1, Ye = (s, S) => S ? e.audioButtonStyle : bt(w({}, e.audioButtonStyle), { opacity: 0.5 }), Fe = e.getMediaButtonStyle || Ye, Qe = (s) => {
      i("participant-click", s);
    }, Q = (s) => {
      e.enableMediaControls && !s.isLocal && i("participant-audio-toggle", s);
    }, be = (s) => {
      e.enableMediaControls && !s.isLocal && i("participant-video-toggle", s);
    }, he = (s, S) => {
      if (S.stopPropagation(), j.value === s.identity)
        j.value = null;
      else {
        j.value = s.identity;
        const Z = S.currentTarget.getBoundingClientRect(), W = 200;
        ee.value = {
          top: Z.bottom + 5,
          left: Z.right - W
          // Right-align dropdown with button
        };
      }
    }, ye = (s) => {
      m.value && (E.value = s);
    }, xe = (s) => {
      E.value === s && (E.value = null);
    }, Te = (s, S) => me(this, null, function* () {
      const F = H.value, Z = r.value;
      if (!(!F || !Z))
        try {
          const W = yield c.moderateParticipants(
            F,
            Z,
            {
              action: S,
              participantIdentities: [s.identity]
            }
          );
          if (W.status === "success") {
            const Me = V(s);
            switch (S) {
              case $e.KICK:
                i("participant-kicked", s);
                break;
              case $e.MUTE_MIC:
                i("participant-muted", s);
                break;
              case $e.TURN_OFF_VIDEO:
                i("participant-muted", s);
                break;
              case $e.ALLOW_AUDIO:
                break;
              case $e.DISABLE_AUDIO:
                break;
              case $e.ALLOW_VIDEO:
                break;
              case $e.DISABLE_VIDEO:
                break;
              case $e.ALLOW_SCREEN_SHARE:
                break;
              case $e.DISABLE_SCREEN_SHARE:
                break;
            }
          } else W.status;
        } catch (W) {
        } finally {
          j.value = null;
        }
    }), Je = () => {
      j.value = null;
    }, Ge = () => me(this, null, function* () {
      const s = H.value, S = r.value;
      if (!(!s || !S))
        try {
          const F = yield c.moderateParticipants(
            s,
            S,
            {
              action: $e.MUTE_MIC,
              participantIdentities: ["*"]
              // '*' means apply to all participants
            }
          );
          F.status === "success" ? i("participant-muted", null) : F.status;
        } catch (F) {
        }
    });
    return (s, S) => (o(), u("div", {
      class: "participants-list-container",
      style: I(s.containerStyle)
    }, [
      s.hideHeader ? D("", !0) : (o(), u("div", {
        key: 0,
        class: "participants-header",
        style: I(s.headerStyle)
      }, [
        a("h3", {
          class: "participants-title",
          style: I(s.titleStyle)
        }, ce(s.title || `Participants (${P(l)})`), 5),
        s.showCloseButton ? (o(), u("button", {
          key: 0,
          class: "close-button",
          style: I(s.closeButtonStyle),
          onClick: S[0] || (S[0] = (F) => s.$emit("close"))
        }, " ✕ ", 4)) : D("", !0)
      ], 4)),
      s.showSearch ? (o(), u("div", ei, [
        Jt(a("input", {
          "onUpdate:modelValue": S[1] || (S[1] = (F) => R.value = F),
          type: "text",
          class: "search-input",
          placeholder: "Search participants..."
        }, null, 512), [
          [Xt, R.value]
        ]),
        S[12] || (S[12] = a("div", { class: "search-icon" }, [
          a("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2"
          }, [
            a("circle", {
              cx: "11",
              cy: "11",
              r: "8"
            }),
            a("path", { d: "m21 21-4.35-4.35" })
          ])
        ], -1))
      ])) : D("", !0),
      a("div", {
        class: "participants-scroll-area",
        style: I(s.scrollAreaStyle)
      }, [
        (o(!0), u(Le, null, Xe(_.value, (F) => {
          var Z;
          return o(), u("div", {
            key: F.identity,
            class: "participant-item",
            style: I(s.itemStyle),
            onClick: (W) => Qe(F),
            onMouseenter: (W) => ye(F.identity),
            onMouseleave: (W) => xe(F.identity)
          }, [
            a("div", {
              class: "participant-avatar",
              style: I(s.avatarContainerStyle)
            }, [
              q(jt, {
                name: V(F),
                image: (Z = P(N)(F.identity)) == null ? void 0 : Z.avatar,
                size: s.avatarSize,
                "is-speaking": Se(F.identity),
                "background-color": s.avatarBackgroundColor || "#6b7280",
                "text-color": s.avatarTextColor || "#ffffff",
                "border-color": s.avatarBorderColor || "",
                "show-speaking-animation": !1
              }, null, 8, ["name", "image", "size", "is-speaking", "background-color", "text-color", "border-color"])
            ], 4),
            a("div", {
              class: "participant-info",
              style: I(s.infoContainerStyle)
            }, [
              a("div", {
                class: "participant-name",
                style: I(s.nameStyle)
              }, ce(V(F)), 5),
              s.showRoles && ie(F) ? (o(), u("div", {
                key: 0,
                class: "participant-role",
                style: I(s.roleStyle)
              }, ce(ie(F)), 5)) : D("", !0)
            ], 4),
            a("div", {
              class: "participant-controls",
              style: I(s.controlsContainerStyle)
            }, [
              a("button", {
                class: Be(["media-control", {
                  active: Pe(F.identity),
                  muted: !Pe(F.identity)
                }]),
                style: I(
                  P(Fe)("audio", Pe(F.identity))
                ),
                disabled: !s.enableMediaControls || F.isLocal,
                onClick: je((W) => Q(F), ["stop"])
              }, [
                q(ft, {
                  variant: Pe(F.identity) ? "on" : "mute",
                  size: s.iconSize
                }, null, 8, ["variant", "size"])
              ], 14, ai),
              a("button", {
                class: Be(["media-control", {
                  active: te(F.identity),
                  disabled: !te(F.identity)
                }]),
                style: I(
                  P(Fe)("video", te(F.identity))
                ),
                disabled: !s.enableMediaControls || F.isLocal,
                onClick: je((W) => be(F), ["stop"])
              }, [
                q(zt, {
                  variant: te(F.identity) ? "on" : "mute",
                  size: s.iconSize
                }, null, 8, ["variant", "size"])
              ], 14, ni),
              m.value && !F.isLocal ? (o(), u("button", {
                key: 0,
                class: "more-options",
                style: I(s.moreOptionsButtonStyle),
                onClick: je((W) => he(F, W), ["stop"])
              }, [
                q(ga, {
                  size: s.iconSize,
                  color: "#6b7280",
                  align: "vertical"
                }, null, 8, ["size"])
              ], 12, ii)) : D("", !0)
            ], 4)
          ], 44, ti);
        }), 128))
      ], 4),
      s.showMuteAllButton && m.value || s.$slots["footer-actions"] ? (o(), u("div", {
        key: 2,
        class: "participants-footer",
        style: I(s.footerStyle)
      }, [
        s.showMuteAllButton && m.value ? (o(), u("button", {
          key: 0,
          class: "action-button mute-all",
          style: I(s.muteAllButtonStyle),
          onClick: Ge
        }, [
          q(ft, {
            variant: "mute",
            size: 16
          }),
          S[13] || (S[13] = a("span", null, "Mute All", -1))
        ], 4)) : D("", !0),
        Lt(s.$slots, "footer-actions", {}, void 0, !0)
      ], 4)) : D("", !0),
      j.value ? (o(), u("div", {
        key: 3,
        class: "dropdown-backdrop",
        onClick: Je
      })) : D("", !0),
      j.value ? (o(), u("div", {
        key: 4,
        class: "moderation-dropdown",
        style: I({
          position: "fixed",
          top: `${ee.value.top}px`,
          left: `${ee.value.left}px`,
          zIndex: 9999
        }),
        onClick: S[11] || (S[11] = je(() => {
        }, ["stop"]))
      }, [
        a("div", oi, [
          a("button", {
            class: "dropdown-item",
            onClick: S[2] || (S[2] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).MUTE_MIC
            ))
          }, [
            q(ft, {
              variant: "mute",
              size: 16
            }),
            S[14] || (S[14] = a("span", null, "Mute Microphone", -1))
          ]),
          a("button", {
            class: "dropdown-item",
            onClick: S[3] || (S[3] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).DISABLE_AUDIO
            ))
          }, [
            q(ft, {
              variant: "mute",
              size: 16
            }),
            S[15] || (S[15] = a("span", null, "Revoke Microphone", -1))
          ]),
          a("button", {
            class: "dropdown-item",
            onClick: S[4] || (S[4] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).ALLOW_AUDIO
            ))
          }, [
            q(ft, {
              variant: "on",
              size: 16
            }),
            S[16] || (S[16] = a("span", null, "Grant Microphone", -1))
          ])
        ]),
        a("div", si, [
          a("button", {
            class: "dropdown-item",
            onClick: S[5] || (S[5] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).TURN_OFF_VIDEO
            ))
          }, [
            q(zt, {
              variant: "mute",
              size: 16
            }),
            S[17] || (S[17] = a("span", null, "Turn Off Camera", -1))
          ]),
          a("button", {
            class: "dropdown-item",
            onClick: S[6] || (S[6] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).DISABLE_VIDEO
            ))
          }, [
            q(zt, {
              variant: "mute",
              size: 16
            }),
            S[18] || (S[18] = a("span", null, "Revoke Camera", -1))
          ]),
          a("button", {
            class: "dropdown-item",
            onClick: S[7] || (S[7] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).ALLOW_VIDEO
            ))
          }, [
            q(zt, {
              variant: "on",
              size: 16
            }),
            S[19] || (S[19] = a("span", null, "Grant Camera", -1))
          ])
        ]),
        a("div", ri, [
          a("button", {
            class: "dropdown-item",
            onClick: S[8] || (S[8] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).DISABLE_SCREEN_SHARE
            ))
          }, [
            q(qt, {
              variant: "off",
              size: 16
            }),
            S[20] || (S[20] = a("span", null, "Revoke Screen Share", -1))
          ]),
          a("button", {
            class: "dropdown-item",
            onClick: S[9] || (S[9] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).ALLOW_SCREEN_SHARE
            ))
          }, [
            q(qt, {
              variant: "on",
              size: 16
            }),
            S[21] || (S[21] = a("span", null, "Grant Screen Share", -1))
          ])
        ]),
        a("div", li, [
          a("button", {
            class: "dropdown-item dropdown-item-danger",
            onClick: S[10] || (S[10] = (F) => Te(
              x.value.find((Z) => Z.identity === j.value),
              P($e).KICK
            ))
          }, S[22] || (S[22] = [
            a("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              a("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" })
            ], -1),
            a("span", null, "Remove", -1)
          ]))
        ])
      ], 4)) : D("", !0)
    ], 4));
  }
}), ui = /* @__PURE__ */ We(ci, [["__scopeId", "data-v-4f9f128e"]]), di = /* @__PURE__ */ Ue({
  __name: "ParticipantsModal",
  props: {
    visible: { type: Boolean }
  },
  emits: ["close"],
  setup(A, { emit: v }) {
    const c = A, e = v, i = z(window.innerWidth), k = () => {
      i.value = window.innerWidth;
    };
    ht(() => {
      window.addEventListener("resize", k);
    }), ut(() => {
      window.removeEventListener("resize", k);
    });
    const p = n(() => (i.value < 480 || i.value < 768, "small")), d = n(() => i.value < 480 ? 14 : i.value < 768 ? 15 : 16), t = n(() => ({
      // Let the default styles from ParticipantsList show through
      // Only override size/positioning
      width: "clamp(320px, 90%, 450px)",
      maxWidth: "90%",
      maxHeight: "80vh"
    })), b = n(() => ({})), r = n(() => ({})), l = n(() => ({})), h = () => {
      e("close");
    };
    return (N, m) => c.visible ? (o(), u("div", {
      key: 0,
      class: "participants-modal-overlay",
      onClick: h
    }, [
      q(ui, {
        "show-close-button": !0,
        "container-style": t.value,
        "header-style": b.value,
        "scroll-area-style": r.value,
        "item-style": l.value,
        "avatar-size": p.value,
        "icon-size": d.value,
        onClose: h,
        onClick: m[0] || (m[0] = je(() => {
        }, ["stop"]))
      }, null, 8, ["container-style", "header-style", "scroll-area-style", "item-style", "avatar-size", "icon-size"])
    ])) : D("", !0);
  }
}), pi = /* @__PURE__ */ We(di, [["__scopeId", "data-v-a338f334"]]), vi = { class: "emoji-text" }, mi = {
  key: 0,
  class: "reaction-name"
}, fi = /* @__PURE__ */ Ue({
  __name: "FloatingReactions",
  props: {
    position: { default: "bottom-left" },
    showNames: { type: Boolean, default: !0 }
  },
  setup(A) {
    const v = A, c = we("reactions");
    if (!c)
      throw new Error(
        "FloatingReactions must be used within a provider that provides reactions"
      );
    const { reactions: e } = c, i = (p) => p.id.split("").reduce((t, b) => t + b.charCodeAt(0), 0) % 3 + 1, k = (p) => {
      const d = {}, t = 15 + (p.x || 10) * 0.7;
      v.position.includes("left") ? d.left = `${t}%` : d.right = `${t}%`;
      const b = -15 + Math.random() * 30;
      return d.transform = `rotate(${b}deg)`, d;
    };
    return (p, d) => (o(), u("div", {
      class: Be(["floating-reactions-container", `position-${p.position}`])
    }, [
      (o(!0), u(Le, null, Xe(P(e), (t) => (o(), u("div", {
        key: t.id,
        class: Be([
          "reaction-animate",
          `wiggle-${i(t)}`,
          { "with-name": p.showNames }
        ]),
        style: I(k(t))
      }, [
        a("span", vi, ce(t.emoji), 1),
        p.showNames ? (o(), u("span", mi, ce(t.participantName), 1)) : D("", !0)
      ], 6))), 128))
    ], 2));
  }
}), hi = /* @__PURE__ */ We(fi, [["__scopeId", "data-v-90dfe2b5"]]), yi = {
  key: 0,
  class: "participants-strip-container"
}, gi = { class: "page-indicator" }, ki = { class: "page-indicator" }, Si = /* @__PURE__ */ Ue({
  __name: "ParticipantStrip",
  props: {
    videoRefHandler: {},
    hasVideoTrack: {},
    hasAudioTrack: {},
    getSpeakingStatus: {},
    getParticipantMetadata: {},
    maxParticipants: { default: Number.MAX_SAFE_INTEGER }
  },
  emits: ["pin-click"],
  setup(A, { expose: v }) {
    ea((Q) => ({
      "0c95dd62": `${y.value.gap}px`,
      "2d633a9e": `${y.value.tileWidth}px`,
      "134b219c": `${y.value.tileHeight}px`
    }));
    const c = A, e = we("trackReferences"), i = we("participants"), { remoteParticipants: k } = i, p = we("roomLayout"), d = st(), t = n(() => e.trackReferences.value.filter(
      (he) => {
        var ye, xe;
        return he.source === pe.Source.ScreenShare && ((ye = he.publication) == null ? void 0 : ye.track) && ((xe = he.publication) == null ? void 0 : xe.isSubscribed) !== !1;
      }
    )), b = n(() => t.value.length > 0), r = n(() => p.layoutMode.value === "speaker"), l = n(() => p.speakerModeParticipant.value), h = n(() => p.activeSpeaker.value), N = n(() => {
      const Q = b.value, be = r.value && !!l.value, he = p.pinnedEntities.value.length > 0, ye = p.layoutMode.value === "grid" || p.layoutMode.value === "auto";
      return Q || be || he && ye;
    }), m = n(() => {
      var xe;
      if (!N.value) return [];
      const Q = (xe = d.value) == null ? void 0 : xe.localParticipant, be = [
        ...Q ? [Q] : [],
        ...k.value || []
      ], he = /* @__PURE__ */ new Set();
      b.value || p.pinnedEntities.value.forEach((Te) => {
        Te.type === "participant" && Te.participant && he.add(Te.participant.identity);
      }), !b.value && r.value && l.value && p.pinnedEntities.value.length === 0 && he.add(l.value.identity);
      const ye = p.getControlledStripParticipants(
        be,
        he,
        c.maxParticipants
      );
      return b.value || r.value, ye;
    }), H = z(null), x = z(!1), U = z(!1), R = z(!1), f = () => {
      const Q = window.innerWidth;
      return Q <= 768 ? {
        type: "mobile",
        maxVisible: 2,
        tileWidth: 110,
        tileHeight: 62,
        gap: 5
      } : Q <= 1024 ? {
        type: "tablet",
        maxVisible: 4,
        tileWidth: 140,
        tileHeight: 79,
        gap: 8
      } : {
        type: "desktop",
        maxVisible: 6,
        tileWidth: 160,
        tileHeight: 90,
        gap: 10
      };
    }, y = z(f()), _ = () => {
      y.value = f(), x.value = y.value.type === "mobile";
    }, E = n(() => m.value.length > y.value.maxVisible), j = n(() => m.value.length <= y.value.maxVisible), ee = z(1), V = n(() => Math.ceil(m.value.length / y.value.maxVisible)), ie = n(() => {
      const Q = (ee.value - 1) * y.value.maxVisible, be = Q + y.value.maxVisible;
      return m.value.slice(Q, be);
    }), te = () => {
      U.value = ee.value > 1, R.value = ee.value < V.value;
    }, Pe = () => {
      te();
    }, Se = () => {
      ee.value > 1 && ee.value--, te();
    }, Ye = () => {
      ee.value < V.value && ee.value++, te();
    };
    ht(() => {
      _(), te(), window.addEventListener("resize", _), setTimeout(te, 100);
    }), ut(() => {
      window.removeEventListener("resize", _);
    }), Re(
      ie,
      (Q) => {
        const be = Q.map((he) => he.identity);
        p.updateStripVisibleParticipants(be);
      },
      { immediate: !0 }
    );
    const Fe = n(() => {
      switch (y.value.type) {
        case "mobile":
          return 8;
        case "tablet":
          return 9;
        case "desktop":
        default:
          return 10;
      }
    }), Qe = n(() => {
      switch (y.value.type) {
        case "mobile":
          return 8;
        case "tablet":
          return 9;
        case "desktop":
        default:
          return 10;
      }
    });
    return Re(
      m,
      () => {
        ee.value > V.value && V.value > 0 && (ee.value = V.value), te();
      },
      { flush: "post" }
    ), v({
      hasActiveScreenShare: b,
      isSpeakerMode: r,
      activeSpeaker: h,
      speakerModeParticipant: l,
      shouldShowStrip: N,
      pipParticipants: m,
      maxParticipants: c.maxParticipants
    }), (Q, be) => N.value && m.value.length > 0 ? (o(), u("div", yi, [
      E.value && ee.value > 1 ? (o(), u("button", {
        key: 0,
        class: "nav-button nav-button-prev",
        "aria-label": "Previous participants",
        onClick: Se
      }, [
        be[1] || (be[1] = a("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          a("path", {
            d: "M12 15L7 10L12 5",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)),
        a("span", gi, ce(ee.value - 1) + "/" + ce(V.value), 1)
      ])) : D("", !0),
      a("div", {
        ref_key: "stripContainer",
        ref: H,
        class: Be(["participants-strip", { centered: j.value }]),
        onScroll: Pe
      }, [
        (o(!0), u(Le, null, Xe(ie.value, (he) => (o(), Ce(Bt, {
          key: he.identity,
          participant: he,
          "participant-metadata": Q.getParticipantMetadata(he.identity),
          "video-ref-handler": Q.videoRefHandler,
          size: "small",
          "avatar-size": "small",
          "track-source": P(pe).Source.Camera,
          "has-video-track": Q.hasVideoTrack(he.identity),
          "has-audio-track": Q.hasAudioTrack(he.identity),
          "has-screen-share": !1,
          "is-speaking": Q.getSpeakingStatus(he.identity),
          "is-local": !!he.isLocal,
          "is-pinned": P(p).pinnedEntities.value.some(
            (ye) => {
              var xe;
              return ye.type === "participant" && ((xe = ye.participant) == null ? void 0 : xe.identity) === he.identity;
            }
          ),
          "click-action": "pin",
          "tag-font-size": Fe.value,
          "tag-icon-size": Qe.value,
          class: "strip-participant-tile",
          onPinClick: be[0] || (be[0] = (ye) => Q.$emit("pin-click", ye))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local", "is-pinned", "tag-font-size", "tag-icon-size"]))), 128))
      ], 34),
      E.value && ee.value < V.value ? (o(), u("button", {
        key: 1,
        class: "nav-button nav-button-next",
        "aria-label": "Next participants",
        onClick: Ye
      }, [
        a("span", ki, ce(ee.value + 1) + "/" + ce(V.value), 1),
        be[2] || (be[2] = a("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          a("path", {
            d: "M8 5L13 10L8 15",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1))
      ])) : D("", !0)
    ])) : D("", !0);
  }
}), bi = /* @__PURE__ */ We(Si, [["__scopeId", "data-v-4ceb413c"]]), wi = { class: "screenshare-view" }, Ci = {
  key: 0,
  class: "screenshare-container"
}, Pi = {
  key: 0,
  class: "screenshare-placeholder"
}, Ri = /* @__PURE__ */ Ue({
  __name: "ScreenshareView",
  props: {
    videoRefHandler: { type: Function },
    hasAudioTrack: { type: Function },
    getSpeakingStatus: { type: Function },
    getParticipantMetadata: { type: Function }
  },
  emits: ["pin-click"],
  setup(A, { expose: v }) {
    const c = we("trackReferences"), e = n(() => c.trackReferences.value.filter(
      (d) => {
        var t, b;
        return d.source === pe.Source.ScreenShare && ((t = d.publication) == null ? void 0 : t.track) && ((b = d.publication) == null ? void 0 : b.isSubscribed) !== !1;
      }
    )), i = n(() => e.value.length > 0);
    return v({
      hasActiveScreenShare: i,
      activeScreenShareRefs: e
    }), (k, p) => (o(), u("div", wi, [
      i.value ? (o(), u("div", Ci, [
        (o(!0), u(Le, null, Xe(e.value, (d) => (o(), Ce(Bt, {
          key: d.participant.identity,
          participant: d.participant,
          "participant-metadata": k.getParticipantMetadata(d.participant.identity),
          "video-ref-handler": k.videoRefHandler,
          size: "fullscreen",
          "track-source": P(pe).Source.ScreenShare,
          "has-video-track": !0,
          "has-audio-track": k.hasAudioTrack(d.participant.identity),
          "has-screen-share": !0,
          "is-speaking": k.getSpeakingStatus(d.participant.identity),
          "is-local": d.participant.isLocal,
          "click-action": "none",
          class: "screenshare-tile",
          onPinClick: p[0] || (p[0] = (t) => k.$emit("pin-click", t))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-audio-track", "is-speaking", "is-local"]))), 128)),
        e.value.length === 0 ? (o(), u("div", Pi, " 🖥️ Screenshare loading... ")) : D("", !0)
      ])) : D("", !0)
    ]));
  }
}), Ti = /* @__PURE__ */ We(Ri, [["__scopeId", "data-v-ab40f479"]]), Mi = { class: "speaker-view" }, Ai = {
  key: 1,
  class: "speaker-container"
}, Ei = {
  key: 2,
  class: "speaker-container"
}, xi = {
  key: 3,
  class: "speaker-placeholder"
}, zi = /* @__PURE__ */ Ue({
  __name: "SpeakerView",
  props: {
    videoRefHandler: { type: Function },
    hasVideoTrack: { type: Function },
    hasAudioTrack: { type: Function },
    getSpeakingStatus: { type: Function },
    getParticipantMetadata: { type: Function }
  },
  emits: ["pin-click"],
  setup(A, { expose: v, emit: c }) {
    const e = c, i = we("roomLayout"), k = n(() => i.pinnedEntities.value.length > 0), p = n(() => i.pinnedEntities.value.filter(
      (h) => h.type === "participant" && h.participant
    )), d = n(() => p.value.map((h) => h.participant)), t = z(i.speakerModeParticipant.value), b = (h) => {
      e("pin-click", bt(w({}, h), {
        trackSource: pe.Source.Camera
        // Pinned participants are always camera source
      }));
    };
    Re(
      () => i.speakerModeParticipant.value,
      (h) => {
        var N;
        if (!k.value) {
          if (!h) {
            t.value = null;
            return;
          }
          if (t.value) {
            const m = t.value.identity;
            if (((N = i.activeSpeaker.value) == null ? void 0 : N.identity) === m)
              return;
          }
          t.value = h;
        }
      },
      { immediate: !0 }
    );
    const r = n(() => i.layoutMode.value === "speaker"), l = n(() => {
      const h = !!t.value, N = r.value;
      return h && N;
    });
    return v({
      speakerToShow: t,
      isSpeakerMode: r,
      hasSpeakerToShow: l
    }), (h, N) => (o(), u("div", Mi, [
      k.value && d.value.length > 1 ? (o(), Ce(ka, {
        key: 0,
        entities: p.value,
        "pinned-items": p.value,
        "device-type": "desktop",
        "max-tiles": 16,
        "video-ref-handler": h.videoRefHandler,
        "has-video-track": h.hasVideoTrack,
        "has-audio-track": h.hasAudioTrack,
        "has-screen-share": () => !1,
        "get-speaking-status": h.getSpeakingStatus,
        class: "pinned-grid-container",
        onPinClick: b
      }, null, 8, ["entities", "pinned-items", "video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status"])) : k.value && d.value.length === 1 ? (o(), u("div", Ai, [
        (o(), Ce(Bt, {
          key: d.value[0].identity,
          participant: d.value[0],
          "participant-metadata": h.getParticipantMetadata(d.value[0].identity),
          "video-ref-handler": h.videoRefHandler,
          size: "fullscreen",
          "track-source": P(pe).Source.Camera,
          "has-video-track": h.hasVideoTrack(d.value[0].identity),
          "has-audio-track": h.hasAudioTrack(d.value[0].identity),
          "has-screen-share": !1,
          "is-speaking": h.getSpeakingStatus(d.value[0].identity),
          "is-local": !!d.value[0].isLocal,
          "is-pinned": !0,
          "click-action": "pin",
          class: "speaker-tile",
          onPinClick: N[0] || (N[0] = (m) => h.$emit("pin-click", m))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local"]))
      ])) : t.value ? (o(), u("div", Ei, [
        (o(), Ce(Bt, {
          key: t.value.identity,
          participant: t.value,
          "participant-metadata": h.getParticipantMetadata(t.value.identity),
          "video-ref-handler": h.videoRefHandler,
          size: "fullscreen",
          "track-source": P(pe).Source.Camera,
          "has-video-track": h.hasVideoTrack(t.value.identity),
          "has-audio-track": h.hasAudioTrack(t.value.identity),
          "has-screen-share": !1,
          "is-speaking": h.getSpeakingStatus(t.value.identity),
          "is-local": !!t.value.isLocal,
          "is-pinned": !1,
          "click-action": "pin",
          class: "speaker-tile",
          onPinClick: N[1] || (N[1] = (m) => h.$emit("pin-click", m))
        }, null, 8, ["participant", "participant-metadata", "video-ref-handler", "track-source", "has-video-track", "has-audio-track", "is-speaking", "is-local"]))
      ])) : (o(), u("div", xi, " 🎤 Waiting for participants to join... "))
    ]));
  }
}), Ii = /* @__PURE__ */ We(zi, [["__scopeId", "data-v-bb29316c"]]), $i = { class: "room-container" }, Li = {
  key: 0,
  class: "preview-container"
}, Bi = {
  key: 0,
  class: "preview-placeholder"
}, _i = {
  key: 1,
  class: "permission-button-overlay"
}, Fi = { class: "permission-prompt-container" }, Di = { class: "permission-prompt-text" }, Hi = {
  key: 3,
  class: "loading-overlay"
}, Ni = {
  key: 0,
  class: "spinner"
}, Oi = { class: "connection-message" }, Vi = {
  key: 1,
  class: "room-content"
}, ji = {
  key: 0,
  class: "loading-overlay"
}, Ui = {
  key: 0,
  class: "spinner"
}, Wi = { class: "connection-message" }, Gi = {
  key: 1,
  class: "permission-button-overlay"
}, Zi = { class: "permission-revoked-container" }, Ki = { class: "permission-revoked-text" }, Yi = {
  key: 2,
  class: "error-overlay"
}, Ji = { class: "error-message" }, Xi = {
  key: 0,
  class: "recording-consent-modal-overlay"
}, Qi = { class: "leave-session-header" }, qi = { class: "leave-session-title" }, eo = { class: "leave-session-body" }, to = { class: "leave-session-message" }, ao = { class: "leave-session-actions" }, no = /* @__PURE__ */ Ue({
  __name: "RoomView",
  props: {
    participantId: {},
    participantName: {},
    participantAvatar: {},
    role: {},
    licenseId: {},
    videoFit: { default: "cover" },
    backgroundColor: { default: "#000" },
    borderRadius: {},
    connectionMessage: {},
    enableScreenShareSound: { type: Boolean, default: !1 },
    enableParticipantJoinedSound: { type: Boolean, default: !1 },
    enableHandRaiseSound: { type: Boolean, default: !1 }
  },
  emits: ["room-ready", "participant-joined", "participant-left", "session-started", "session-ended", "connection-state-changed", "session-started-at", "recording-available", "drop-out-of-room", "recording-started", "error"],
  setup(A, { expose: v, emit: c }) {
    ea((g) => ({
      "4241b326": e.backgroundColor,
      "4be3eda6": e.borderRadius,
      "4bc47665": e.videoFit
    })), tt("isInsideRoomViewSlot", !0);
    const e = A, i = c, k = z(null), p = z(null), d = z(e.connectionMessage), t = z("idle"), b = z(""), r = z(null), l = z(!1), h = z(null), N = z(!1), m = z(!1), H = z(!1), x = z(!1), U = z(""), R = n(() => {
      const g = W.cameraPermission.value.state === "denied" || W.cameraPermission.value.state === "prompt", B = W.microphonePermission.value.state === "denied" || W.microphonePermission.value.state === "prompt";
      return g || B;
    }), f = n(() => {
      const g = W.cameraPermission.value.state === "denied" || W.cameraPermission.value.state === "prompt", B = W.microphonePermission.value.state === "denied" || W.microphonePermission.value.state === "prompt";
      return g && B ? "Allow camera and microphone" : g ? "Allow camera" : B ? "Allow microphone" : "Allow media access";
    }), y = n(() => {
      const g = W.cameraPermission.value.state === "denied" || W.cameraPermission.value.state === "prompt", B = W.microphonePermission.value.state === "denied" || W.microphonePermission.value.state === "prompt";
      return g && B ? "Do you want people to see and hear you in the session?" : g ? "Do you want people to see you in the session?" : B ? "Do you want people to hear you in the session?" : "Do you want to enable media access?";
    }), _ = z(!1), E = z(!1), j = z(!1), ee = z(!1);
    Za("permission-denied").on((g) => {
      const B = {
        camera: "Host disabled participant camera",
        microphone: "Host disabled participant microphone",
        screenshare: "Host disabled participant screen sharing"
      };
      U.value = B[g.type], x.value = !0;
    });
    const ie = (g) => {
      H.value = g;
    }, te = () => `recording-consent-${e.licenseId}-${e.participantId}`, Pe = () => {
      const g = te(), B = localStorage.getItem(g);
      if (!B) return !1;
      try {
        const K = JSON.parse(B), fe = K.timestamp, lt = (Date.now() - fe) / (1e3 * 60 * 60);
        return K.agreed === !0 && lt < 24;
      } catch (K) {
        return B === "true";
      }
    }, Se = () => {
      const g = te(), B = {
        agreed: !0,
        timestamp: Date.now(),
        licenseId: e.licenseId,
        participantId: e.participantId
      };
      localStorage.setItem(g, JSON.stringify(B)), Ye();
    }, Ye = () => {
      const g = "recording-consent-", B = [];
      for (let K = 0; K < localStorage.length; K++) {
        const fe = localStorage.key(K);
        if (fe && fe.startsWith(g))
          try {
            const ae = localStorage.getItem(fe);
            if (ae) {
              const lt = JSON.parse(ae);
              (Date.now() - lt.timestamp) / (1e3 * 60 * 60) > 24 && B.push(fe);
            }
          } catch (ae) {
            B.push(fe);
          }
      }
      B.forEach((K) => localStorage.removeItem(K));
    }, Fe = () => {
      Se(), _.value = !1, E.value = !0;
    }, Qe = () => {
      _.value = !1, E.value = !0, $();
    }, Q = () => {
      ee.value = !0;
    }, be = () => {
      ee.value = !1;
    }, he = () => {
      be();
    }, ye = () => me(this, null, function* () {
      ee.value = !1, yield $();
    }), xe = (g) => {
      if (i("recording-started"), !E.value) {
        if (Pe()) {
          E.value = !0;
          return;
        }
        _.value = !0, E.value = !0;
      }
    }, {
      connect: Te,
      disconnect: Je,
      connectionState: Ge,
      error: s,
      transferLocalMediaToRoom: S
    } = _t(), F = Ka(), Z = Vt(), W = Ga(), Me = st(), _e = we("trackReferences"), ze = _n(), oe = we("roomLayout"), Ae = we("speechDetection"), nt = Fn(), J = Ut(), De = we("participants"), {
      participantCount: L,
      remoteParticipants: O,
      onTrackSubscribed: Y,
      onTrackUnsubscribed: G,
      getParticipantMetadata: ne
    } = De, { isRecording: ve } = Pn(), ue = ta(), re = n(() => Ge.value === "connected"), ge = n(() => J.inRoomMode.value ? Z.isCameraEnabled.value : W.isCameraEnabled.value), He = n(() => {
      var K;
      const g = (K = Me.value) == null ? void 0 : K.localParticipant;
      return g ? Ae.getParticipantSpeakingStatus(
        g.identity
      ) : !1;
    }), Oe = n(() => {
      var K;
      const g = (K = Me.value) == null ? void 0 : K.localParticipant;
      return g ? Ae.getParticipantAudioLevel(
        g.identity
      ) : 0;
    }), le = n(() => e.role), Ne = z(null), it = z(
      null
    ), Ze = n(() => _e.trackReferences.value.filter(
      (K) => {
        var fe, ae;
        return K.source === pe.Source.ScreenShare && ((fe = K.publication) == null ? void 0 : fe.track) && ((ae = K.publication) == null ? void 0 : ae.isSubscribed) !== !1;
      }
    ).length > 0), Ve = n(() => {
      const g = _e.trackReferences.value;
      return (g != null ? g : []).filter(
        (K) => {
          var fe, ae;
          return K.source === pe.Source.ScreenShare && ((fe = K.publication) == null ? void 0 : fe.track) && ((ae = K.publication) == null ? void 0 : ae.isSubscribed) !== !1;
        }
      ).length;
    });
    Re(
      Ve,
      (g, B) => me(this, null, function* () {
        if (g > B && e.enableScreenShareSound)
          try {
            yield ue.playSound(
              Nt.SCREEN_SHARE_STARTED
            );
          } catch (K) {
          }
      }),
      { immediate: !0 }
    );
    const Ie = n(() => {
      const g = oe.layoutMode.value === "speaker", B = !!oe.speakerModeParticipant.value;
      return g && B;
    }), Ke = n(() => Ze.value ? "screenshare" : Ie.value ? "speaker" : "normal"), qe = ze.setParticipantVideoRef, rt = () => {
      var g, B;
      if (p.value) {
        if (!ge.value) {
          p.value.srcObject && (p.value.srcObject = null);
          return;
        }
        try {
          let K = null;
          if (J.inRoomMode.value) {
            const fe = J.getLocalParticipant();
            if ((B = (g = fe == null ? void 0 : fe.cameraTrack) == null ? void 0 : g.value) != null && B.track) {
              const ae = fe.cameraTrack.value.track;
              K = new MediaStream(), "mediaStreamTrack" in ae ? K.addTrack(ae.mediaStreamTrack) : "id" in ae && "kind" in ae && K.addTrack(ae);
            }
          } else
            K = W.cameraStream.value;
          K && K.getTracks().length > 0 && (p.value.srcObject = K, p.value.onloadedmetadata = () => {
            var fe;
            (fe = p.value) == null || fe.play().catch(
              (ae) => {
              }
            );
          });
        } catch (K) {
        }
      }
    }, gt = (g, B, K) => {
      ze.updateParticipantVideoTrack(g.identity, B);
    }, kt = nt.updateParticipantAudioTrack, wt = ze.clearParticipantVideo, pt = nt.clearParticipantAudio, Ct = () => {
      Me.value && Me.value.remoteParticipants.forEach((g) => {
        const B = g.getTrackPublication(pe.Source.Microphone);
        B != null && B.track && kt(g, B.track, B);
        const K = g.getTrackPublication(pe.Source.Camera);
        K != null && K.track && gt(g, K.track);
      });
    }, dt = (g) => {
      if (g.trackSource === pe.Source.ScreenShare) {
        const B = {
          id: `${g.participant.identity}-screenshare`,
          type: "screen-share",
          screenShare: {
            participant: g.participant,
            track: {
              trackSid: "unknown",
              // Not needed for pinning
              trackName: "Screen Share",
              source: pe.Source.ScreenShare
            },
            startTime: Date.now()
            // Not needed for pinning
          }
        };
        oe.toggleEntityPin(B);
      } else
        oe.toggleParticipantPin(
          g.participant
        );
    }, St = () => {
      N.value = !0;
    };
    tt("showParticipantsModal", St);
    const Pt = we("setSessionToken"), Rt = we("platform");
    It(() => {
      Pt && b.value && Pt(b.value);
    });
    const Tt = () => {
      var fe;
      const g = (fe = Me.value) == null ? void 0 : fe.localParticipant;
      return [
        ...O.value || [],
        ...g ? [g] : []
      ].some((ae) => {
        const lt = J.getParticipantRole(ae);
        return g == null || g.identity, ae.identity, lt === "host";
      });
    }, Mt = (g, B) => me(this, null, function* () {
      var K;
      b.value = B;
      try {
        d.value = "Connecting to room...", t.value = "connecting", l.value = !0;
        const fe = {
          licenseId: g,
          participantToken: b.value,
          skipMediaTransfer: !1,
          connectOptions: {
            autoSubscribe: !0
            // Ensures we automatically subscribe to remote tracks
          }
        }, ae = yield Te(fe);
        return ae.startedAt && i("session-started-at", ae.startedAt), ae.recordingAvailable && i("recording-available", ae.recordingAvailable), ae.canJoin ? (d.value = ae.message || "Connecting to room...", yield S(), F.setRole(e.role), i("connection-state-changed", "connected"), i("session-started"), i("room-ready", {
          hasCamera: ge.value,
          hasMicrophone: Z.isMicrophoneEnabled.value,
          participantCount: L.value
        }), rt(), Ct(), (K = Me.value) != null && K.localParticipant && Ae.setupRemoteAudioAnalysis(
          Me.value.localParticipant
        ), e.role === "host" || e.role === "attendee" && Tt() ? (t.value = "connected", l.value = !1, d.value = "") : (t.value = "waiting-for-host", l.value = !0, d.value = "Waiting for host...", ke()), ae) : (d.value = ae.message || "Cannot join the room.", ae.retryInSeconds ? (l.value = !0, setTimeout(() => {
          Mt(g, b.value);
        }, ae.retryInSeconds * 1e3)) : (e.role, l.value = !1), ae);
      } catch (fe) {
        t.value = "idle", l.value = !1;
        const ae = fe instanceof Error ? fe : new Error("Failed to join room");
        i("error", ae);
      }
    }), $ = () => me(this, null, function* () {
      try {
        m.value = !0, t.value = "leaving", d.value = "Dropping out...", l.value = !0, yield Je({
          licenseId: e.licenseId,
          participantToken: b.value
        }), e.role === "host" ? (t.value = "ended", d.value = "This session has ended.", l.value = !1, i("session-ended")) : (t.value = "ended", d.value = "You left the session.", l.value = !1), b.value = "", i("drop-out-of-room"), i("connection-state-changed", "completed"), Ee();
      } catch (g) {
        const B = g instanceof Error ? g : new Error("Failed to leave room");
        i("error", B);
      }
    }), ke = () => {
      r.value && (clearInterval(r.value), r.value = null);
      const g = () => me(this, null, function* () {
        if (t.value === "kicked") {
          Ee();
          return;
        }
        try {
          const { state: B, recordingEnabled: K } = yield cn.getLiveSessionState(e.licenseId);
          if (B === Zt.COMPLETED) {
            t.value = "ended";
            try {
              b.value && (yield Je({
                licenseId: e.licenseId,
                participantToken: b.value
              }));
            } catch (fe) {
            }
            d.value = K ? "This session has ended. A recording will be available soon." : "This session has ended.", l.value = !1, i("connection-state-changed", "completed"), i("session-ended"), Ee();
          } else B === Zt.DISCONNECTED ? e.role === "attendee" && (t.value = "waiting-for-host", d.value = "The host is reconnecting. Please wait...", l.value = !0) : B === Zt.SCHEDULED && e.role === "attendee" && (t.value = "waiting-for-host", d.value = "Waiting for host to start...", l.value = !0);
        } catch (B) {
        }
      });
      g(), r.value = window.setInterval(g, 5e3);
    }, Ee = () => {
      r.value && (clearInterval(r.value), r.value = null);
    }, vt = () => {
      se(), h.value = window.setTimeout(() => {
        yt();
      }, 1 * 60 * 1e3);
    }, se = () => {
      h.value && (clearTimeout(h.value), h.value = null);
    }, yt = () => me(this, null, function* () {
      try {
        yield Je({
          licenseId: e.licenseId,
          participantToken: b.value
        }), t.value = "ended", d.value = "Connection lost. Please refresh to rejoin.", l.value = !1, i("connection-state-changed", "timeout"), i("session-ended"), i("error", new Error("Reconnection timeout"));
      } catch (g) {
      }
    });
    return Re(ve, (g) => {
      !j.value && t.value === "connected" && (j.value = !0), g && xe();
    }), Re(
      [
        () => Z.isCameraEnabled.value,
        () => Z.cameraTrack.value
      ],
      () => {
        rt();
      }
    ), Re(
      [() => ge.value, () => W.cameraStream.value],
      () => {
        rt();
      }
    ), Re(
      O,
      (g, B) => {
        const K = new Set((B || []).map((ae) => ae.identity)), fe = new Set((g || []).map((ae) => ae.identity));
        g == null || g.forEach((ae) => me(this, null, function* () {
          var lt;
          if (!K.has(ae.identity)) {
            i("participant-joined", { participantCount: g.length });
            const At = (lt = Me.value) == null ? void 0 : lt.localParticipant, Wt = (At == null ? void 0 : At.identity) === ae.identity;
            if (e.enableParticipantJoinedSound && !Wt)
              try {
                yield ue.playSound(
                  Nt.PARTICIPANT_JOINED
                );
              } catch (aa) {
              }
            Ae.setupRemoteAudioAnalysis(ae);
          }
        })), B == null || B.forEach((ae) => {
          fe.has(ae.identity) || (i("participant-left", { participantCount: g.length }), pt(ae.identity), oe.removePinByParticipantId(ae.identity));
        });
      },
      { deep: !0 }
    ), Re(
      () => Ge.value,
      (g, B) => {
        g === ct.Reconnecting || g === ct.SignalReconnecting ? (t.value = "reconnecting", d.value = "Reconnecting...", l.value = !0, vt()) : (B === ct.Reconnecting || B === ct.SignalReconnecting) && g === ct.Connected ? (se(), t.value = "connected", d.value = "", l.value = !1) : g === ct.Disconnected && B === ct.Connected && !m.value && t.value !== "leaving" && t.value !== "ended" && (t.value = "kicked", d.value = "You've been disconnected from the session.", l.value = !1, se(), Ee(), i("connection-state-changed", "kicked"), i("session-ended")), g === ct.Disconnected && (m.value = !1), i("connection-state-changed", g);
      }
    ), Re(
      () => Z.isCameraEnabled.value,
      (g) => {
        setTimeout(() => {
          rt();
        }, 500);
      }
    ), Re(Y, (g) => {
      g && (g.trackKind === pe.Kind.Video ? gt(
        g.participant,
        g.track,
        g.publication
      ) : g.trackKind === pe.Kind.Audio && (kt(
        g.participant,
        g.track,
        g.publication
      ), Ae.setupRemoteAudioAnalysis(g.participant)));
    }), Re(G, (g) => {
      g && (g.trackKind === pe.Kind.Video ? wt(g.participant.identity, g.track) : g.trackKind === pe.Kind.Audio && (pt(g.participant.identity, g.track), Ae.cleanupAudioAnalysis(g.participant.identity)));
    }), It(() => me(this, null, function* () {
      if (e.role !== "attendee" || !re.value) return;
      const g = Tt();
      g ? g && (Ee(), t.value === "waiting-for-host" && (t.value = "connected", d.value = "", l.value = !1)) : (r.value && (clearInterval(r.value), r.value = null), ke(), l.value = !0, d.value = "Waiting for host...", t.value = "waiting-for-host");
    })), ht(() => me(this, null, function* () {
      rt(), Me.value && (Me.value.remoteParticipants.forEach((g) => {
        Ae.setupRemoteAudioAnalysis(g);
      }), Me.value.localParticipant && Ae.setupRemoteAudioAnalysis(
        Me.value.localParticipant
      ));
    })), ut(() => {
      var g;
      Ee(), se(), ze.cleanup(), nt.cleanupAllAudioTracks(), re.value && Je({
        licenseId: "",
        participantToken: ""
      }).catch(console.error), (g = p.value) != null && g.srcObject && (p.value.srcObject = null);
      try {
        W.cleanup();
      } catch (B) {
      }
    }), v({
      joinRoom: Mt,
      leaveRoom: Q,
      toggleShowPermissionModal: ie,
      isConnected: re,
      participantCount: L,
      role: le,
      // Enhanced session state
      roomConnectionState: t,
      connectionMessage: d,
      sessionToken: b,
      // Layout controls
      setLayoutMode: oe.setLayoutMode,
      toggleParticipantPin: oe.toggleParticipantPin,
      layoutMode: oe.layoutMode,
      pinnedItems: oe.pinnedEntities,
      // Use new property name
      // Modal controls
      showParticipantsModal: St
    }), (g, B) => (o(), u("div", {
      ref_key: "roomViewRef",
      ref: k,
      class: "room-view"
    }, [
      a("div", $i, [
        re.value ? (o(), u("div", Vi, [
          t.value === "connecting" || t.value === "waiting-for-host" || t.value === "reconnecting" || t.value === "ended" || t.value === "kicked" ? (o(), u("div", ji, [
            l.value ? (o(), u("div", Ui)) : D("", !0),
            a("p", Wi, ce(d.value), 1)
          ])) : D("", !0),
          t.value === "connected" ? (o(), Ce(hi, {
            key: 1,
            position: "bottom-left",
            "show-names": !0
          })) : D("", !0),
          t.value === "connected" ? (o(), u(Le, { key: 2 }, [
            q(bi, {
              "video-ref-handler": P(qe),
              "has-video-track": P(_e).hasVideoTrack,
              "has-audio-track": P(_e).hasAudioTrack,
              "get-speaking-status": P(Ae).getParticipantSpeakingStatus,
              "get-participant-metadata": P(ne),
              onPinClick: dt
            }, null, 8, ["video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status", "get-participant-metadata"]),
            a("div", {
              class: Be(["stage-section", { "fullscreen-stage": Ke.value !== "normal" }])
            }, [
              Ke.value === "screenshare" ? (o(), Ce(Ti, {
                key: 0,
                ref_key: "screenshareViewRef",
                ref: Ne,
                "video-ref-handler": P(qe),
                "has-audio-track": P(_e).hasAudioTrack,
                "get-speaking-status": P(Ae).getParticipantSpeakingStatus,
                "get-participant-metadata": P(ne),
                onPinClick: dt
              }, null, 8, ["video-ref-handler", "has-audio-track", "get-speaking-status", "get-participant-metadata"])) : Ke.value === "speaker" ? (o(), Ce(Ii, {
                key: 1,
                ref_key: "speakerViewRef",
                ref: it,
                "video-ref-handler": P(qe),
                "has-video-track": P(_e).hasVideoTrack,
                "has-audio-track": P(_e).hasAudioTrack,
                "get-speaking-status": P(Ae).getParticipantSpeakingStatus,
                "get-participant-metadata": P(ne),
                onPinClick: dt
              }, null, 8, ["video-ref-handler", "has-video-track", "has-audio-track", "get-speaking-status", "get-participant-metadata"])) : (o(), Ce(qn, {
                key: 2,
                "stage-zone": P(oe).stageZone.value,
                "pinned-items": P(oe).pinnedEntities.value,
                "device-type": P(oe).deviceType.value,
                "video-ref-handler": P(qe),
                "has-video-track": P(_e).hasVideoTrack,
                "has-audio-track": P(_e).hasAudioTrack,
                "has-screen-share": P(_e).hasScreenShare,
                "get-speaking-status": P(Ae).getParticipantSpeakingStatus,
                "get-audio-level": P(Ae).getParticipantAudioLevel,
                onPinClick: dt
              }, null, 8, ["stage-zone", "pinned-items", "device-type", "video-ref-handler", "has-video-track", "has-audio-track", "has-screen-share", "get-speaking-status", "get-audio-level"]))
            ], 2),
            N.value ? (o(), Ce(pi, {
              key: 0,
              visible: N.value,
              onClose: B[2] || (B[2] = (K) => N.value = !1)
            }, null, 8, ["visible"])) : D("", !0),
            x.value ? (o(), u("div", Gi, [
              a("div", Zi, [
                a("p", Ki, ce(U.value), 1),
                a("button", {
                  class: "permission-revoked-button",
                  onClick: B[3] || (B[3] = (K) => x.value = !1)
                }, B[6] || (B[6] = [
                  a("span", null, "Ok", -1)
                ]))
              ])
            ])) : D("", !0)
          ], 64)) : D("", !0)
        ])) : (o(), u("div", Li, [
          a("video", {
            ref_key: "previewVideo",
            ref: p,
            autoplay: "",
            muted: "",
            playsinline: "",
            class: "preview-video"
          }, null, 512),
          ge.value ? D("", !0) : (o(), u("div", Bi, [
            q(jt, {
              name: g.participantName,
              image: g.participantAvatar,
              size: "medium",
              "is-speaking": He.value,
              "audio-level": Oe.value
            }, null, 8, ["name", "image", "is-speaking", "audio-level"])
          ])),
          !re.value && R.value ? (o(), u("div", _i, [
            a("div", Fi, [
              a("p", Di, ce(y.value), 1),
              a("button", {
                class: "permission-button",
                onClick: B[0] || (B[0] = (K) => H.value = !0)
              }, [
                a("span", null, ce(f.value), 1)
              ])
            ])
          ])) : D("", !0),
          H.value ? (o(), Ce(ma, {
            key: 2,
            "camera-permission": P(W).cameraPermission.value,
            "microphone-permission": P(W).microphonePermission.value,
            platform: P(Rt),
            onClose: B[1] || (B[1] = (K) => H.value = !1)
          }, null, 8, ["camera-permission", "microphone-permission", "platform"])) : D("", !0),
          t.value !== "connected" && t.value !== "idle" ? (o(), u("div", Hi, [
            l.value ? (o(), u("div", Ni)) : D("", !0),
            a("p", Oi, ce(d.value), 1)
          ])) : D("", !0)
        ])),
        Lt(g.$slots, "controls", {}, void 0, !0),
        Lt(g.$slots, "chat", {}, void 0, !0),
        P(s) ? (o(), u("div", Yi, [
          a("div", Ji, [
            B[7] || (B[7] = a("h3", null, "Connection Error", -1)),
            a("p", null, ce(P(s).message), 1)
          ])
        ])) : D("", !0)
      ]),
      (o(), Ce(Yt, { to: "body" }, [
        _.value ? (o(), u("div", Xi, [
          a("div", {
            class: "recording-consent-modal",
            onClick: B[4] || (B[4] = je(() => {
            }, ["stop"]))
          }, [
            a("div", { class: "recording-consent-header" }, [
              B[9] || (B[9] = a("h3", { class: "recording-consent-title" }, "This meeting is recorded", -1)),
              a("button", {
                class: "recording-consent-close",
                "aria-label": "Close",
                onClick: Qe
              }, B[8] || (B[8] = [
                a("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  a("path", {
                    d: "M15 5L5 15M5 5L15 15",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))
            ]),
            B[10] || (B[10] = a("p", { class: "recording-consent-message" }, " By continuing to be in the meeting, you are consenting to be recorded ", -1)),
            a("div", { class: "recording-consent-footer" }, [
              a("div", { class: "recording-consent-buttons" }, [
                a("button", {
                  class: "recording-consent-button recording-consent-leave",
                  onClick: Qe
                }, " Leave "),
                a("button", {
                  class: "recording-consent-button recording-consent-continue",
                  onClick: Fe
                }, " Continue ")
              ])
            ])
          ])
        ])) : D("", !0)
      ])),
      (o(), Ce(Yt, { to: "body" }, [
        ee.value ? (o(), u("div", {
          key: 0,
          class: "leave-session-modal-overlay",
          onClick: he
        }, [
          a("div", {
            class: "leave-session-modal",
            onClick: B[5] || (B[5] = je(() => {
            }, ["stop"]))
          }, [
            a("div", Qi, [
              a("h3", qi, ce(le.value === "host" ? "End session" : "Leave session"), 1)
            ]),
            a("div", eo, [
              a("p", to, ce(le.value === "host" ? "Are you sure you want to end this session for everyone?" : "Are you sure you want to leave this session?"), 1)
            ]),
            a("div", ao, [
              a("button", {
                class: "leave-session-button cancel-button",
                onClick: be
              }, " Cancel "),
              a("button", {
                class: "leave-session-button confirm-button",
                onClick: ye
              }, ce(le.value === "host" ? "End session" : "Leave session"), 1)
            ])
          ])
        ])) : D("", !0)
      ]))
    ], 512));
  }
}), Ms = /* @__PURE__ */ We(no, [["__scopeId", "data-v-e895758f"]]), io = { class: "picker-content" }, oo = ["onClick"], so = { class: "emoji-text" }, ro = /* @__PURE__ */ Ue({
  __name: "ReactionPicker",
  props: {
    visible: { type: Boolean },
    emojis: { default: () => ["👍", "❤️", "😂", "👏", "🎉", "😮"] },
    anchorEl: {},
    position: { default: "top" },
    pickerStyle: {},
    emojiButtonStyle: {},
    backgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    borderRadius: { default: "12px" },
    boxShadow: { default: "0 4px 24px rgba(0, 0, 0, 0.3)" }
  },
  emits: ["select", "close"],
  setup(A, { emit: v }) {
    const c = A, e = v, i = z(), k = n(() => {
      const r = w({
        backgroundColor: c.backgroundColor,
        borderRadius: c.borderRadius,
        boxShadow: c.boxShadow
      }, c.pickerStyle);
      if (c.anchorEl && i.value) {
        const l = c.anchorEl.getBoundingClientRect(), h = 8;
        switch (c.position) {
          case "top":
            r.bottom = `${window.innerHeight - l.top + h}px`, r.left = `${l.left + l.width / 2}px`, r.transform = "translateX(-50%)";
            break;
          case "bottom":
            r.top = `${l.bottom + h}px`, r.left = `${l.left + l.width / 2}px`, r.transform = "translateX(-50%)";
            break;
          case "left":
            r.right = `${window.innerWidth - l.left + h}px`, r.top = `${l.top + l.height / 2}px`, r.transform = "translateY(-50%)";
            break;
          case "right":
            r.left = `${l.right + h}px`, r.top = `${l.top + l.height / 2}px`, r.transform = "translateY(-50%)";
            break;
        }
      }
      return r;
    }), p = n(() => w({}, c.emojiButtonStyle)), d = (r) => {
      e("select", r), e("close");
    }, t = (r) => {
      i.value && !i.value.contains(r.target) && c.anchorEl && !c.anchorEl.contains(r.target) && e("close");
    }, b = (r) => {
      r.key === "Escape" && e("close");
    };
    return ht(() => {
      c.visible && (document.addEventListener("click", t), document.addEventListener("keydown", b));
    }), ut(() => {
      document.removeEventListener("click", t), document.removeEventListener("keydown", b);
    }), Re(
      () => c.visible,
      (r) => {
        r ? setTimeout(() => {
          document.addEventListener("click", t), document.addEventListener("keydown", b);
        }, 100) : (document.removeEventListener("click", t), document.removeEventListener("keydown", b));
      }
    ), (r, l) => (o(), Ce(Qt, { name: "picker-fade" }, {
      default: ot(() => [
        r.visible ? (o(), u("div", {
          key: 0,
          ref_key: "pickerRef",
          ref: i,
          class: "reaction-picker",
          style: I(k.value)
        }, [
          a("div", io, [
            (o(!0), u(Le, null, Xe(r.emojis, (h) => (o(), u("button", {
              key: h,
              type: "button",
              class: "emoji-button",
              style: I(p.value),
              onClick: (N) => d(h)
            }, [
              a("span", so, ce(h), 1)
            ], 12, oo))), 128))
          ])
        ], 4)) : D("", !0)
      ]),
      _: 1
    }));
  }
}), lo = /* @__PURE__ */ We(ro, [["__scopeId", "data-v-206cd94d"]]), co = ["data-control-size", "data-gap-size", "data-dropdown-width", "data-edge-offset"], uo = {
  key: 0,
  class: "permission-indicator",
  title: "Camera access denied"
}, po = {
  key: 0,
  class: "permission-indicator",
  title: "Microphone access denied"
}, vo = {
  key: 0,
  class: "permission-indicator",
  title: "Screen sharing access denied"
}, mo = {
  key: 3,
  class: "settings-container control-item"
}, fo = {
  key: 0,
  class: "controls-end"
}, ho = { class: "dropdown-content" }, yo = { class: "select-wrapper" }, go = ["value"], ko = ["value"], So = { class: "select-wrapper" }, bo = ["value"], wo = ["value"], Co = { class: "select-wrapper" }, Po = ["value"], Ro = ["value"], To = {
  key: 0,
  class: "mic-meter-wrapper"
}, Mo = { class: "select-wrapper" }, Ao = ["value"], Eo = ["value"], xo = /* @__PURE__ */ Ue({
  __name: "RoomControlBar",
  props: {
    embeddedPosition: { default: "bottom" },
    containerStyle: {},
    barBackgroundColor: { default: "none" },
    buttonStyle: {},
    activeButtonStyle: {},
    hoverButtonStyle: {},
    disabledButtonStyle: {},
    iconStyle: {},
    iconColor: { default: "white" },
    activeIconColor: { default: "#4285f4" },
    dropdownStyle: {},
    dropdownItemStyle: {},
    dropdownItemHoverStyle: {},
    dropdownBackgroundColor: { default: "rgba(32, 33, 36, 0.98)" },
    textStyle: {},
    textColor: { default: "white" },
    fontFamily: {},
    borderRadius: { default: "12px" },
    padding: {},
    boxShadow: {},
    backdropFilter: {},
    controls: { default: () => [] }
  },
  emits: ["camera", "microphone", "screen-share", "camera-flip", "device", "layout-change", "raise-hand", "error"],
  setup(A, { expose: v, emit: c }) {
    ea(($) => ({
      "5bd6955b": _e.value + "px",
      "89655ef2": De.value ? ze.value + "px" : "0",
      "09ef85aa": De.value ? J.barBackgroundColor : "transparent",
      cb59ddd8: De.value ? ze.value * 0.6 + "px" : "0",
      "4c034c18": Me.value + "px",
      "68cb172e": oe.value + "px",
      d010f932: J.iconColor,
      a600699a: J.textColor,
      e37275f2: W.value + "px",
      "7acb81d0": nt.value + "px",
      a273767e: J.dropdownBackgroundColor,
      adfa0904: ze.value * 0.6 + "px",
      "97b060c6": Ae.value + "px",
      "3fa75898": _e.value * 0.7 + "px",
      "92b44dca": J.dropdownBackgroundColor === "none" ? "transparent" : J.dropdownBackgroundColor,
      "4d7ebc80": ze.value * 0.4 + "px",
      "0e2c7640": ze.value + "px",
      "55d758fa": oe.value * 0.75 + "px",
      a4b45d38: W.value * 0.7 + "px",
      78647223: ze.value * 0.25 + "px",
      "68c8d14e": oe.value + "px",
      e899878c: J.dropdownBackgroundColor === "none" ? "rgba(32, 33, 36, 0.95)" : J.dropdownBackgroundColor,
      "0da23ef2": _e.value
    }));
    const e = z(!0), i = () => {
      e.value = !e.value;
    }, k = n(() => !e.value || J.controls.length <= 3 ? J.controls : J.controls.slice(0, 3)), p = we("roomControls");
    if (!p)
      throw new Error("RoomControlBar must be used within a RoomProvider");
    const d = we("raiseHand");
    if (!d)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides raiseHand"
      );
    const t = we("reactions");
    if (!t)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides reactions"
      );
    const b = we("roomLayout");
    if (!b)
      throw new Error(
        "RoomControlBar must be used within a RoomProvider that provides roomLayout"
      );
    const r = [
      {
        value: "auto",
        label: "Auto"
      },
      {
        value: "grid",
        label: "Grid"
      },
      {
        value: "speaker",
        label: "Speaker"
      }
    ], {
      // Device lists
      videoDevices: l,
      audioInputDevices: h,
      audioOutputDevices: N,
      // Media states
      isCameraEnabled: m,
      isMicrophoneEnabled: H,
      isScreenShareEnabled: x,
      isScreenShareSupported: U,
      hasMultipleCameras: R,
      // Browser permission states
      cameraPermission: f,
      microphonePermission: y,
      screenSharePermission: _,
      // Selected devices
      selectedCamera: E,
      selectedMicrophone: j,
      selectedSpeaker: ee,
      // Streams
      cameraStream: V,
      microphoneStream: ie,
      screenShareStream: te,
      // Control methods
      toggleCamera: Pe,
      toggleMicrophone: Se,
      toggleScreenShare: Ye,
      startCamera: Fe,
      stopCamera: Qe,
      startMicrophone: Q,
      stopMicrophone: be,
      startScreenShare: he,
      stopScreenShare: ye,
      // Device management
      handleDeviceChange: xe,
      handleCameraFlip: Te
    } = p, Je = we("isInsideRoomViewSlot", !1), Ge = we(
      "showParticipantsModal",
      null
    ), s = we("platform"), S = z(null), F = z(null);
    ht(() => {
      if (S.value) {
        const $ = S.value.parentElement;
        $ && (F.value = $);
      }
    });
    const { width: Z } = ha(F), W = n(() => {
      if (Z.value <= 0) return 16;
      const se = Z.value / 800 * 16;
      return Math.max(12, Math.min(20, se));
    }), Me = n(() => {
      const Ee = 28 + 12 * (W.value - 12) / 8;
      return Math.max(28, Math.min(40, Ee));
    }), _e = n(() => {
      const Ee = 16 + 4 * (W.value - 12) / 8;
      return Math.max(16, Math.min(20, Ee));
    }), ze = n(() => {
      const Ee = 16 + 4 * (W.value - 12) / 8;
      return Math.max(16, Math.min(20, Ee));
    }), oe = n(() => {
      const Ee = 24 + 4 * (W.value - 12) / 8;
      return Math.max(24, Math.min(28, Ee));
    }), Ae = n(() => Math.min(280, Math.max(100, Z.value * 0.8))), nt = n(() => {
      const vt = 8 + Math.min(Z.value, 1200) / 1200 * 8;
      return Math.max(8, Math.min(16, vt));
    }), J = A;
    tt("controlsConfig", J.controls);
    const De = n(() => J.barBackgroundColor !== "none"), L = n(() => J.embeddedPosition === "left" || J.embeddedPosition === "right"), O = n(() => Je), Y = n(() => w(w({
      backgroundColor: J.barBackgroundColor,
      padding: J.padding,
      borderRadius: J.borderRadius,
      boxShadow: J.boxShadow,
      backdropFilter: J.backdropFilter,
      fontFamily: J.fontFamily
    }, J.barBackgroundColor === "none" && !J.containerStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25))"
    } : {}), J.containerStyle)), G = n(() => w(w({}, J.barBackgroundColor === "none" && !J.buttonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), J.buttonStyle)), ne = n(() => w(w({}, J.barBackgroundColor === "none" && !J.activeButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), J.activeButtonStyle)), ve = n(() => w({
      backgroundColor: J.dropdownBackgroundColor,
      borderRadius: J.borderRadius,
      boxShadow: J.boxShadow,
      fontFamily: J.fontFamily
    }, J.dropdownStyle)), ue = n(() => w({
      color: J.textColor
    }, J.dropdownItemStyle)), re = n(() => w(w({
      color: J.textColor,
      fontFamily: J.fontFamily
    }, J.barBackgroundColor === "none" && !J.textStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), J.textStyle)), ge = () => f.value.state === "denied" ? "Camera access denied. Please allow camera access in browser settings." : m.value ? "Turn off camera" : "Turn on camera", He = () => y.value.state === "denied" ? "Microphone access denied. Please allow microphone access in browser settings." : H.value ? "Mute" : "Unmute", Oe = () => _.value.state === "denied" ? "Screen sharing access denied. Please allow screen sharing in browser settings." : U ? x ? "Stop sharing" : "Share screen" : "Screen sharing not supported on this device", le = c, Ne = z(!1), it = z(null), Ze = z(!1), Ve = z(), Ie = z(!1), Ke = ($) => {
      $ && $.stopPropagation(), Ne.value = !Ne.value;
    }, qe = () => {
      Ge && Ge();
    }, rt = ($) => {
      it.value && !it.value.contains($.target) && (Ne.value = !1);
    }, gt = () => me(this, null, function* () {
      try {
        if (f.value.state === "denied") {
          Ie.value = !0;
          return;
        }
        yield Pe(), le("camera", m.value, V.value);
      } catch ($) {
        le(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle camera")
        );
      }
    }), kt = () => me(this, null, function* () {
      try {
        if (y.value.state === "denied") {
          Ie.value = !0;
          return;
        }
        yield Se(), le("microphone", H.value, ie.value);
      } catch ($) {
        le(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle microphone")
        );
      }
    }), wt = () => me(this, null, function* () {
      try {
        yield Ye(), le("screen-share", x.value, te.value);
      } catch ($) {
        le(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle screen share")
        );
      }
    }), pt = ($, ke) => me(this, null, function* () {
      try {
        yield xe($, ke), le("device", $, ke);
      } catch (Ee) {
        le(
          "error",
          Ee instanceof Error ? Ee : new Error(`Failed to change ${$} device`)
        );
      }
    }), Ct = () => me(this, null, function* () {
      try {
        yield Te(), le("camera-flip");
      } catch ($) {
        le(
          "error",
          $ instanceof Error ? $ : new Error("Failed to flip camera")
        );
      }
    }), dt = ($) => {
      b && b.setLayoutMode && (b.clearAllPins(), b.setLayoutMode($)), le("layout-change", $);
    }, St = () => me(this, null, function* () {
      try {
        yield d.toggleRaiseHand(), le("raise-hand", d.isHandRaised.value);
      } catch ($) {
        le(
          "error",
          $ instanceof Error ? $ : new Error("Failed to toggle raise hand")
        );
      }
    }), Pt = ($) => {
      $ && $.stopPropagation(), Ze.value = !Ze.value;
    }, Rt = ($) => me(this, null, function* () {
      try {
        yield t.sendReaction($);
      } catch (ke) {
        le(
          "error",
          ke instanceof Error ? ke : new Error("Failed to send reaction")
        );
      }
    });
    Re(Ne, ($) => {
      $ ? setTimeout(() => {
        document.addEventListener("click", rt);
      }, 100) : document.removeEventListener("click", rt);
    });
    const Tt = n(() => L.value ? e.value ? "down" : "up" : e.value ? "right" : "left"), Mt = n(() => {
      var $;
      return {
        currentMode: (($ = b == null ? void 0 : b.layoutMode) == null ? void 0 : $.value) || "auto",
        availableLayouts: r,
        setLayout: dt,
        isLayoutAvailable: !!b
      };
    });
    return v({
      get selectedCamera() {
        return E.value;
      },
      get selectedMicrophone() {
        return j.value;
      },
      get selectedSpeaker() {
        return ee.value;
      },
      get isCameraEnabled() {
        return m.value;
      },
      get isMicrophoneEnabled() {
        return H.value;
      },
      get isScreenShareEnabled() {
        return x.value;
      },
      // Browser permission states
      get cameraPermission() {
        return f.value;
      },
      get microphonePermission() {
        return y.value;
      },
      get screenSharePermission() {
        return _.value;
      },
      get videoDevices() {
        return l.value;
      },
      get audioInputDevices() {
        return h.value;
      },
      get audioOutputDevices() {
        return N.value;
      },
      get videoStream() {
        return V.value;
      },
      get audioStream() {
        return ie.value;
      },
      get screenShareStream() {
        return te.value;
      },
      toggleCamera: gt,
      toggleMicrophone: kt,
      toggleScreenShare: wt,
      handleDeviceChange: pt,
      startCamera: () => me(this, null, function* () {
        try {
          yield Fe(), le("camera", !0, V.value);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start camera")
          );
        }
      }),
      stopCamera: () => {
        try {
          Qe(), le("camera", !1, null);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop camera")
          );
        }
      },
      startMicrophone: () => me(this, null, function* () {
        try {
          yield Q(), le("microphone", !0, ie.value);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start microphone")
          );
        }
      }),
      stopMicrophone: () => {
        try {
          be(), le("microphone", !1, null);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop microphone")
          );
        }
      },
      startScreenShare: () => me(this, null, function* () {
        try {
          yield he(), le("screen-share", !0, te.value);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to start screen share")
          );
        }
      }),
      stopScreenShare: () => {
        try {
          ye(), le("screen-share", !1, null);
        } catch ($) {
          le(
            "error",
            $ instanceof Error ? $ : new Error("Failed to stop screen share")
          );
        }
      },
      // Layout control functions
      get currentLayoutMode() {
        var $;
        return (($ = b == null ? void 0 : b.layoutMode) == null ? void 0 : $.value) || "auto";
      },
      setLayoutMode: dt,
      get availableLayouts() {
        return r;
      },
      get layoutState() {
        return Mt.value;
      },
      // Raise hand control
      get isHandRaised() {
        return d.isHandRaised.value;
      },
      toggleRaiseHand: St,
      // Reactions control
      sendReaction: ($) => me(this, null, function* () {
        yield Rt($);
      }),
      // Participants modal control
      toggleParticipantsModal: qe,
      handleCameraFlip: Ct
    }), ($, ke) => {
      var Ee, vt;
      return o(), u("div", {
        ref_key: "controlBarRef",
        ref: S,
        class: Be(["control-bar", {
          vertical: L.value,
          [`position-${J.embeddedPosition}`]: O.value,
          collapsed: e.value,
          "no-background": !De.value
        }]),
        style: I(Y.value),
        "data-control-size": Me.value,
        "data-gap-size": _e.value,
        "data-dropdown-width": Ae.value,
        "data-edge-offset": nt.value
      }, [
        q(Da, {
          name: "controls-animation",
          tag: "div",
          class: "controls-group"
        }, {
          default: ot(() => [
            $.controls && $.controls.length > 0 ? (o(), u(Le, { key: 0 }, [
              (o(!0), u(Le, null, Xe(k.value, (se) => (o(), u(Le, { key: se }, [
                se === "camera" ? (o(), Ce(mt, {
                  key: 0,
                  active: P(m),
                  title: ge(),
                  "no-background": !De.value,
                  style: I(
                    P(m) ? ne.value : G.value
                  ),
                  class: Be([{
                    "permission-denied": P(f).state === "denied"
                  }, "control-item"]),
                  onClick: gt
                }, {
                  default: ot(() => [
                    q(zt, {
                      variant: P(m) ? "on" : "mute",
                      size: oe.value
                    }, null, 8, ["variant", "size"]),
                    P(f).state === "denied" ? (o(), u("div", uo, " ! ")) : D("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style", "class"])) : D("", !0),
                se === "microphone" ? (o(), Ce(mt, {
                  key: 1,
                  active: P(H),
                  title: He(),
                  "no-background": !De.value,
                  style: I(
                    P(H) ? ne.value : G.value
                  ),
                  class: Be([{
                    "permission-denied": P(y).state === "denied"
                  }, "control-item"]),
                  onClick: kt
                }, {
                  default: ot(() => [
                    q(ft, {
                      variant: P(H) ? "on" : "mute",
                      size: oe.value
                    }, null, 8, ["variant", "size"]),
                    P(y).state === "denied" ? (o(), u("div", po, " ! ")) : D("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style", "class"])) : D("", !0),
                se === "screen-share" ? (o(), Ce(mt, {
                  key: 2,
                  active: P(x),
                  disabled: !P(U) || P(_).state === "denied",
                  title: Oe(),
                  "no-background": !De.value,
                  style: I(
                    P(x) ? ne.value : G.value
                  ),
                  class: Be([{
                    "permission-denied": P(_).state === "denied"
                  }, "control-item"]),
                  onClick: ke[0] || (ke[0] = (yt) => P(U) && P(_).state !== "denied" ? wt() : void 0)
                }, {
                  default: ot(() => [
                    q(qt, {
                      variant: P(x) ? "on" : "off",
                      size: oe.value
                    }, null, 8, ["variant", "size"]),
                    P(_).state === "denied" ? (o(), u("div", vo, " ! ")) : D("", !0)
                  ]),
                  _: 1
                }, 8, ["active", "disabled", "title", "no-background", "style", "class"])) : D("", !0),
                se === "settings" ? (o(), u("div", mo, [
                  q(mt, {
                    active: Ne.value,
                    title: "Device settings",
                    "no-background": !De.value,
                    style: I(
                      Ne.value ? ne.value : G.value
                    ),
                    onClick: Ke
                  }, {
                    default: ot(() => [
                      q(un, {
                        variant: Ne.value ? "on" : "off",
                        size: oe.value
                      }, null, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }, 8, ["active", "no-background", "style"])
                ])) : D("", !0),
                se === "camera-flip" ? (o(), Ce(mt, {
                  key: 4,
                  disabled: !P(m) || !P(R),
                  title: P(R) ? P(m) ? "Flip camera" : "Enable camera first" : "Camera flip not available - only one camera detected",
                  "no-background": !De.value,
                  style: I(G.value),
                  class: "control-item",
                  onClick: Ct
                }, {
                  default: ot(() => [
                    q(dn, { size: oe.value }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["disabled", "title", "no-background", "style"])) : D("", !0),
                se === "participants" ? (o(), Ce(mt, {
                  key: 5,
                  active: !1,
                  title: "Show participants",
                  "no-background": !De.value,
                  style: I(G.value),
                  class: "control-item",
                  onClick: qe
                }, {
                  default: ot(() => [
                    q(fn, { size: oe.value }, null, 8, ["size"])
                  ]),
                  _: 1
                }, 8, ["no-background", "style"])) : D("", !0),
                se === "raise-hand" ? (o(), Ce(mt, {
                  key: 6,
                  active: P(d).isHandRaised.value,
                  title: P(d).isHandRaised.value ? "Lower hand" : "Raise hand",
                  "no-background": !De.value,
                  style: I(
                    P(d).isHandRaised.value ? ne.value : G.value
                  ),
                  class: "control-item",
                  onClick: St
                }, {
                  default: ot(() => [
                    q(hn, {
                      variant: P(d).isHandRaised.value ? "raised" : "lowered",
                      size: oe.value
                    }, null, 8, ["variant", "size"])
                  ]),
                  _: 1
                }, 8, ["active", "title", "no-background", "style"])) : D("", !0),
                se === "reactions" ? (o(), u("div", {
                  key: 7,
                  ref_for: !0,
                  ref_key: "reactionsButtonEl",
                  ref: Ve,
                  class: "reactions-container control-item"
                }, [
                  q(mt, {
                    active: Ze.value,
                    title: "Send reaction",
                    "no-background": !De.value,
                    style: I(
                      Ze.value ? ne.value : G.value
                    ),
                    onClick: Pt
                  }, {
                    default: ot(() => [
                      q(yn, {
                        variant: Ze.value ? "active" : "default",
                        size: oe.value
                      }, null, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }, 8, ["active", "no-background", "style"])
                ], 512)) : D("", !0)
              ], 64))), 128)),
              $.controls.length > 3 ? (o(), Ce(mt, {
                key: "toggle-button",
                class: "control-item toggle-button",
                active: !1,
                title: e.value ? "Show more controls" : "Show fewer controls",
                "no-background": !De.value,
                style: I(G.value),
                onClick: i
              }, {
                default: ot(() => [
                  q(pn, {
                    variant: Tt.value,
                    size: oe.value
                  }, null, 8, ["variant", "size"])
                ]),
                _: 1
              }, 8, ["title", "no-background", "style"])) : D("", !0)
            ], 64)) : D("", !0)
          ]),
          _: 1
        }),
        $.$slots["end-controls"] ? (o(), u("div", fo, [
          Lt($.$slots, "end-controls", {}, void 0, !0)
        ])) : D("", !0),
        Ne.value ? (o(), u("div", {
          key: 1,
          ref_key: "settingsDropdown",
          ref: it,
          class: "settings-dropdown",
          style: I(ve.value)
        }, [
          a("div", ho, [
            a("div", {
              class: "device-select",
              style: I(ue.value)
            }, [
              a("div", yo, [
                q(gn, {
                  class: "device-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"]),
                a("select", {
                  id: "layout-select",
                  value: ((vt = (Ee = P(b)) == null ? void 0 : Ee.layoutMode) == null ? void 0 : vt.value) || "auto",
                  onChange: ke[1] || (ke[1] = (se) => dt(se.target.value))
                }, [
                  (o(), u(Le, null, Xe(r, (se) => a("option", {
                    key: se.value,
                    value: se.value
                  }, ce(se.label), 9, ko)), 64))
                ], 40, go),
                q(Ht, {
                  class: "arrow-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4),
            $.controls && $.controls.includes("camera") ? (o(), u("div", {
              key: 0,
              class: "device-select",
              style: I(ue.value)
            }, [
              a("div", So, [
                q(zt, {
                  class: "device-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"]),
                a("select", {
                  id: "camera-select",
                  value: P(E),
                  onChange: ke[2] || (ke[2] = (se) => pt("camera", se.target.value))
                }, [
                  (o(!0), u(Le, null, Xe(P(l), (se) => (o(), u("option", {
                    key: se.deviceId,
                    value: se.deviceId
                  }, ce(se.label || `Camera ${P(l).indexOf(se) + 1}`), 9, wo))), 128))
                ], 40, bo),
                q(Ht, {
                  class: "arrow-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4)) : D("", !0),
            $.controls && $.controls.includes("microphone") ? (o(), u("div", {
              key: 1,
              class: "device-select",
              style: I(ue.value)
            }, [
              a("div", Co, [
                q(ft, {
                  class: "device-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"]),
                a("select", {
                  id: "mic-select",
                  value: P(j),
                  onChange: ke[3] || (ke[3] = (se) => pt("microphone", se.target.value))
                }, [
                  (o(!0), u(Le, null, Xe(P(h), (se) => (o(), u("option", {
                    key: se.deviceId,
                    value: se.deviceId
                  }, ce(se.label || `Microphone ${P(h).indexOf(se) + 1}`), 9, Ro))), 128))
                ], 40, Po),
                q(Ht, {
                  class: "arrow-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"])
              ]),
              P(H) ? (o(), u("div", To, [
                q(Ya, {
                  "icon-color": J.iconColor,
                  "icon-size": oe.value * 0.75
                }, null, 8, ["icon-color", "icon-size"])
              ])) : (o(), u("div", {
                key: 1,
                class: "mic-disabled-message",
                style: I(re.value)
              }, " Enable microphone to see audio level ", 4))
            ], 4)) : D("", !0),
            $.controls && $.controls.includes("speaker") ? (o(), u("div", {
              key: 2,
              class: "device-select",
              style: I(ue.value)
            }, [
              a("div", Mo, [
                q(vn, {
                  class: "device-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"]),
                a("select", {
                  id: "speaker-select",
                  value: P(ee),
                  onChange: ke[4] || (ke[4] = (se) => pt("speaker", se.target.value))
                }, [
                  (o(!0), u(Le, null, Xe(P(N), (se) => (o(), u("option", {
                    key: se.deviceId,
                    value: se.deviceId
                  }, ce(se.label || `Speaker ${P(N).indexOf(se) + 1}`), 9, Eo))), 128))
                ], 40, Ao),
                q(Ht, {
                  class: "arrow-icon",
                  size: oe.value * 0.75
                }, null, 8, ["size"])
              ])
            ], 4)) : D("", !0)
          ])
        ], 4)) : D("", !0),
        q(lo, {
          visible: Ze.value,
          emojis: P(t).availableEmojis,
          "anchor-el": Ve.value,
          position: "top",
          onSelect: Rt,
          onClose: ke[5] || (ke[5] = (se) => Ze.value = !1)
        }, null, 8, ["visible", "emojis", "anchor-el"]),
        Ie.value ? (o(), Ce(ma, {
          key: 2,
          "camera-permission": P(f),
          "microphone-permission": P(y),
          platform: P(s),
          onClose: ke[6] || (ke[6] = (se) => Ie.value = !1)
        }, null, 8, ["camera-permission", "microphone-permission", "platform"])) : D("", !0)
      ], 14, co);
    };
  }
}), As = /* @__PURE__ */ We(xo, [["__scopeId", "data-v-84c49836"]]), zo = ["href"], Io = { key: 1 }, $o = /* @__PURE__ */ Ue({
  __name: "MessageText",
  props: {
    text: {},
    preserveWhitespace: { type: Boolean, default: !0 },
    linkStyle: {},
    insidePlayer: { type: Boolean, default: !1 }
  },
  emits: ["link-click"],
  setup(A, { emit: v }) {
    const c = A, e = v, i = n(() => Cn(c.text)), k = (d) => {
      const b = d.target.href;
      e("link-click", b, d);
    }, p = n(() => {
      var t;
      const d = w({
        color: c.insidePlayer ? "#87ceeb" : "#0066cc",
        textDecoration: "underline",
        cursor: "pointer"
      }, c.linkStyle);
      return c.insidePlayer && !((t = c.linkStyle) != null && t.textShadow) && (d.textShadow = "0 1px 2px rgba(0, 0, 0, 0.7)"), d;
    });
    return (d, t) => (o(), u("span", {
      class: Be(["message-text-content", { "preserve-whitespace": d.preserveWhitespace }])
    }, [
      (o(!0), u(Le, null, Xe(i.value, (b, r) => (o(), u(Le, { key: r }, [
        b.type === "link" ? (o(), u("a", {
          key: 0,
          href: b.url,
          target: "_blank",
          rel: "noopener noreferrer",
          class: "message-link",
          style: I(p.value),
          onClick: k
        }, ce(b.content), 13, zo)) : (o(), u("span", Io, ce(b.content), 1))
      ], 64))), 128))
    ], 2));
  }
}), Lo = /* @__PURE__ */ We($o, [["__scopeId", "data-v-f1133e77"]]), Bo = { class: "icon-circle-outer" }, _o = { class: "icon-circle-inner" }, Fo = {
  key: 2,
  class: "message-spacer"
}, Do = { class: "message-content" }, Ho = ["onClick"], No = ["src", "alt"], Oo = ["src"], Vo = ["title"], jo = { class: "attachment-size" }, Uo = ["onClick"], Wo = {
  key: 0,
  class: "drag-overlay"
}, Go = { class: "drag-overlay-content" }, Zo = { class: "drag-icon" }, Ko = {
  key: 0,
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, Yo = {
  key: 1,
  width: "48",
  height: "48",
  viewBox: "0 0 24 24",
  fill: "currentColor"
}, Jo = { class: "drag-text" }, Xo = {
  key: 0,
  class: "file-preview-thumbnail"
}, Qo = ["src", "alt"], qo = ["disabled", "title"], es = ["placeholder", "disabled"], ts = { class: "buttons-row" }, as = { class: "icons-group" }, ns = ["disabled"], is = ["disabled"], os = ["disabled"], ss = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, rs = ["stroke-dasharray"], ls = ["disabled"], cs = { class: "input-wrapper" }, us = ["placeholder", "maxlength", "disabled", "onKeydown"], ds = ["disabled"], ps = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  class: "progress-ring"
}, vs = ["stroke-dasharray"], ms = ["accept"], fs = /* @__PURE__ */ Ue({
  __name: "RoomChat",
  props: {
    containerStyle: {},
    messageListStyle: {},
    maxHeight: {},
    bubbleStyle: {},
    ownBubbleStyle: {},
    otherBubbleStyle: {},
    bubbleShape: { default: "square" },
    messageTextStyle: {},
    senderNameStyle: {},
    timestampStyle: {},
    fontFamily: {},
    inputContainerStyle: {},
    inputFieldStyle: {},
    sendButtonStyle: {},
    attachmentButtonStyle: {},
    emojiButtonStyle: {},
    emojiPickerConfig: {},
    emojiPickerStyle: {},
    avatarStyle: {},
    emptyStateStyle: {},
    emptyStateContentStyle: {},
    emptyStateIconStyle: {},
    emptyStateHeadingStyle: {},
    emptyStateMessageStyle: {},
    loadingIndicatorStyle: {},
    loadingSpinnerStyle: {},
    loadingTextStyle: {},
    skeletonStyle: {},
    skeletonAvatarStyle: {},
    skeletonContentStyle: {},
    skeletonNameStyle: {},
    skeletonTextStyle: {},
    scrollButtonStyle: {},
    newMessageNotificationStyle: {},
    errorNotificationStyle: {},
    errorNotificationContentStyle: {},
    errorNotificationTextStyle: {},
    errorDismissButtonStyle: {},
    filePreviewStyle: {},
    fileIconStyle: {},
    fileInfoStyle: {},
    fileNameStyle: {},
    fileSizeStyle: {},
    fileRemoveButtonStyle: {},
    attachmentContainerStyle: {},
    imageAttachmentStyle: {},
    videoAttachmentStyle: {},
    documentAttachmentStyle: {},
    downloadButtonStyle: {},
    attachmentInfoStyle: {},
    attachmentDetailsStyle: {},
    hostTagStyle: {},
    showAvatars: { type: Boolean, default: !0 },
    showTimestamps: { type: Boolean, default: !0 },
    showSenderNames: { type: Boolean, default: !0 },
    timestampFormat: { default: "HH:mm" },
    enableEmoji: { type: Boolean, default: !0 },
    enableFileAttachment: { type: Boolean, default: !0 },
    maxMessageLength: { default: 500 },
    maxFileSize: { default: 100 * 1024 * 1024 },
    allowedFileTypes: { default: "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.zip" },
    inputPlaceholder: { default: "Type a message..." },
    currentUserName: { default: "You" },
    avatarBackgroundColor: { default: "rgba(0, 0, 0, 0.5)" },
    enableNotificationSound: { type: Boolean, default: !1 },
    autoScroll: { type: Boolean, default: !0 },
    scrollThreshold: { default: 100 }
  },
  emits: ["message-sent", "message-received", "file-selected"],
  setup(A, { expose: v, emit: c }) {
    const e = A, i = c, k = z(), p = z(), d = z(), t = z(), b = z(), r = z(""), l = z(!0), h = z(null), N = z(null), m = z(null), H = z(!1), x = z(!1), U = z(!1), R = z(!1), f = we("isInsideRoomViewSlot", !1), { messages: y, sendMessage: _, clearMessages: E } = Ja(), j = n(() => {
      var C;
      return ((C = V.value) == null ? void 0 : C.name) || e.currentUserName;
    }), { connectionState: ee } = _t(), { localParticipant: V } = Vt(), ie = n(() => "file-transfer-room"), te = n(() => ee.value === ct.Connected), {
      fileMessages: Pe,
      isUploading: Se,
      uploadProgress: Ye,
      sendFile: Fe,
      clearFileMessages: Qe
    } = Xa(ie.value), { recordMessage: Q } = Qa(), be = qa(), he = ta(), {
      historicalMessages: ye,
      hasMore: xe,
      isInitialLoading: Te,
      isLoadingMore: Je,
      loadMoreHistory: Ge
    } = en({
      pageSize: 15,
      onError: (C) => {
      }
    }), s = n(() => {
      const C = [], M = /* @__PURE__ */ new Map();
      y.value.forEach((X) => {
        const de = X.text.match(/^\[FILE:([^\]]+)\](.*)$/);
        if (de) {
          const [, et, xt] = de;
          M.set(et, xt);
        }
      }), y.value.forEach((X) => {
        X.text.startsWith("[FILE:") || C.push(bt(w({}, X), {
          attachment: void 0
        }));
      }), Pe.value.forEach((X) => {
        const de = X.isOwn ? j.value : X.senderName, et = M.get(X.streamId) || "";
        C.push({
          id: X.id,
          text: et,
          // Use associated text from data channel
          senderName: de,
          senderIdentity: X.senderIdentity,
          senderIdentityType: X.senderIdentityType,
          senderAvatar: X.senderAvatar,
          senderRole: X.senderRole,
          timestamp: X.timestamp,
          isOwn: X.isOwn,
          attachment: {
            id: X.streamId,
            name: X.fileName,
            size: X.fileSize,
            type: X.mimeType,
            url: X.url
          }
        });
      });
      const T = ye.value.map((X) => {
        var de;
        return bt(w({}, X), {
          isOwn: X.senderIdentity === ((de = V.value) == null ? void 0 : de.identity)
        });
      });
      return tn(
        T,
        C
      );
    }), S = n(() => w(w({
      fontFamily: e.fontFamily
    }, f && !e.containerStyle ? {
      background: "transparent",
      backdropFilter: "none"
    } : {}), e.containerStyle)), F = n(() => w(w({
      maxHeight: e.maxHeight
    }, f && !e.messageListStyle ? {
      background: "transparent"
    } : {}), e.messageListStyle)), Z = n(() => w(w({}, f && !e.messageTextStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.messageTextStyle)), W = n(() => w(w({}, f && !e.senderNameStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.senderNameStyle)), Me = n(() => w(w({}, f && !e.timestampStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.timestampStyle)), _e = n(() => w(w({}, f && !e.inputContainerStyle ? {
      background: "transparent",
      borderTop: "none"
    } : {}), e.inputContainerStyle)), ze = n(() => w(w({
      fontFamily: e.fontFamily
    }, f && !e.inputFieldStyle ? {
      background: "transparent",
      borderColor: "rgba(255, 255, 255)",
      backdropFilter: "none",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.inputFieldStyle)), oe = n(() => w(w({}, f && !e.sendButtonStyle ? {
      background: "rgba(0, 0, 0, 0.5)",
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.sendButtonStyle)), Ae = n(() => w(w({}, f && !e.attachmentButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.attachmentButtonStyle)), nt = n(() => w(w({}, f && !e.emojiButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.3))"
    } : {}), e.emojiButtonStyle)), J = n(() => w(w({}, f && !e.avatarStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.avatarStyle)), De = n(() => w(w({}, f && !e.emptyStateStyle ? {
      background: "transparent"
    } : {}), e.emptyStateStyle)), L = n(() => w(w({}, f && !e.emptyStateContentStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.emptyStateContentStyle)), O = n(() => w(w({}, f && !e.emptyStateIconStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.4))"
    } : {}), e.emptyStateIconStyle)), Y = n(() => w(w({}, f && !e.emptyStateHeadingStyle ? {
      color: "white",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateHeadingStyle)), G = n(() => w(w({}, f && !e.emptyStateMessageStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 2px rgba(0, 0, 0, 0.5)"
    } : {}), e.emptyStateMessageStyle)), ne = n(() => w(w({}, f && !e.loadingIndicatorStyle ? {
      filter: "drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3))"
    } : {}), e.loadingIndicatorStyle)), ve = n(() => w(w({}, f && !e.loadingSpinnerStyle ? {
      borderColor: "rgba(255, 255, 255, 0.3)",
      borderTopColor: "white"
    } : {}), e.loadingSpinnerStyle)), ue = n(() => w(w({}, f && !e.loadingTextStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.loadingTextStyle)), re = n(() => w(w({}, f && !e.skeletonStyle ? {
      background: "rgba(255, 255, 255, 0.05)",
      borderTopColor: "rgba(255, 255, 255, 0.1)"
    } : {}), e.skeletonStyle)), ge = n(() => w(w({}, f && !e.skeletonAvatarStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonAvatarStyle)), He = n(() => w(w({}, f && !e.skeletonContentStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.skeletonContentStyle)), Oe = n(() => w(w({}, f && !e.skeletonNameStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonNameStyle)), le = n(() => w(w({}, f && !e.skeletonTextStyle ? {
      background: "linear-gradient(90deg, rgba(255, 255, 255, 0.1) 25%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.1) 75%)"
    } : {}), e.skeletonTextStyle)), Ne = n(() => w(w({}, f && !e.scrollButtonStyle ? {
      background: "rgba(0, 0, 0, 0.7)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.scrollButtonStyle)), it = n(() => w(w({}, f && !e.newMessageNotificationStyle ? {
      background: "rgba(0, 0, 0, 0.8)",
      backdropFilter: "blur(10px)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)"
    } : {}), e.newMessageNotificationStyle)), Ze = n(() => w(w({}, f && !e.errorNotificationStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))"
    } : {}), e.errorNotificationStyle)), Ve = n(() => w(w({}, f && !e.errorNotificationContentStyle ? {
      background: "rgba(255, 215, 0, 0.95)",
      backdropFilter: "blur(8px)"
    } : {}), e.errorNotificationContentStyle)), Ie = n(() => w(w({}, f && !e.errorNotificationTextStyle ? {
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.2)"
    } : {}), e.errorNotificationTextStyle)), Ke = n(() => w(w({}, f && !e.errorDismissButtonStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.errorDismissButtonStyle)), qe = n(() => w(w({}, f && !e.filePreviewStyle ? {
      background: "rgba(240, 242, 245, 0.95)",
      backdropFilter: "blur(8px)",
      border: "1px solid rgba(255, 255, 255, 0.2)"
    } : {}), e.filePreviewStyle)), rt = n(() => w(w({}, f && !e.fileIconStyle ? {
      background: "rgba(233, 236, 239, 0.9)",
      color: "rgba(108, 117, 125, 0.9)"
    } : {}), e.fileIconStyle)), gt = n(() => w(w({}, f && !e.fileInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.fileInfoStyle)), kt = n(() => w(w({}, f && !e.fileNameStyle ? {
      color: "white",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileNameStyle)), wt = n(() => w(w({}, f && !e.fileSizeStyle ? {
      color: "rgba(255, 255, 255, 0.8)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.fileSizeStyle)), pt = n(() => w(w({}, f && !e.fileRemoveButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      color: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(4px)"
    } : {}), e.fileRemoveButtonStyle)), Ct = n(() => w(w({}, f && !e.attachmentContainerStyle ? {
      filter: "drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentContainerStyle)), dt = n(() => w(w({}, f && !e.imageAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.imageAttachmentStyle)), St = n(() => w(w({}, f && !e.videoAttachmentStyle ? {
      border: "2px solid rgba(255, 255, 255, 0.3)",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)"
    } : {}), e.videoAttachmentStyle)), Pt = n(() => w(w({}, f && !e.documentAttachmentStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.2)",
      backdropFilter: "blur(8px)"
    } : {}), e.documentAttachmentStyle)), Rt = n(() => w(w({}, f && !e.downloadButtonStyle ? {
      background: "rgba(255, 255, 255, 0.1)",
      borderColor: "rgba(255, 255, 255, 0.3)",
      color: "white"
    } : {}), e.downloadButtonStyle)), Tt = n(() => w(w({}, f && !e.attachmentInfoStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentInfoStyle)), Mt = n(() => w(w({}, f && !e.attachmentDetailsStyle ? {
      filter: "drop-shadow(0 1px 1px rgba(0, 0, 0, 0.2))"
    } : {}), e.attachmentDetailsStyle)), $ = n(() => w(w({}, f && !e.hostTagStyle ? {
      background: "rgba(87, 115, 255, 0.9)",
      backdropFilter: "blur(4px)",
      textShadow: "0 1px 1px rgba(0, 0, 0, 0.3)"
    } : {}), e.hostTagStyle)), ke = n(() => te.value && (r.value.trim() || h.value) && !Se.value), Ee = (C) => {
      let M = e.bubbleStyle || {};
      f && !e.bubbleStyle && (M = w({
        background: "transparent"
      }, M));
      const T = C.isOwn ? e.ownBubbleStyle || (f ? { background: "transparent" } : {}) : e.otherBubbleStyle || (f ? { background: "transparent" } : {});
      return bt(w(w({}, M), T), {
        marginLeft: "0",
        marginRight: "auto"
      });
    }, vt = (C) => {
      const M = new Date(C);
      return e.timestampFormat === "HH:mm" ? M.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : M.toLocaleString();
    }, se = () => me(this, null, function* () {
      if (!p.value) return;
      const { scrollTop: C, scrollHeight: M, clientHeight: T } = p.value;
      if (l.value = M - C - T < e.scrollThreshold, H.value = !l.value && s.value.length > 0, C < 100 && xe.value && !Je.value && !Te.value) {
        const de = M;
        yield Ge(), $t(() => {
          if (p.value) {
            const xt = p.value.scrollHeight - de;
            p.value.scrollTop = C + xt;
          }
        });
      }
    }), yt = (C = !0) => {
      p.value && (p.value.scrollTop = p.value.scrollHeight);
    }, g = (C) => {
      C.shiftKey || (C.preventDefault(), K());
    }, B = () => {
      if (!d.value || f) return;
      const C = d.value;
      C.tagName === "TEXTAREA" && (C.style.height = "auto", C.style.height = Math.min(C.scrollHeight, 120) + "px");
    }, K = () => me(this, null, function* () {
      if (!ke.value) return;
      const C = r.value.trim();
      if (!(!C && !h.value))
        try {
          let M = null;
          if (h.value) {
            const T = yield Fe(
              h.value,
              void 0,
              // Don't pass text since attributes aren't supported
              ie.value
            );
            C && (yield _(`[FILE:${T.streamId}]${C}`)), M = {
              id: T.id,
              text: C || "",
              // Text is now sent separately via data channel
              senderName: j.value,
              senderIdentity: T.senderIdentity,
              senderIdentityType: T.senderIdentityType,
              senderAvatar: T.senderAvatar,
              senderRole: T.senderRole,
              timestamp: T.timestamp,
              attachment: {
                id: T.streamId,
                name: T.fileName,
                size: T.fileSize,
                type: T.mimeType,
                url: T.url
              }
            };
          } else if (C) {
            const T = yield _(C);
            T && (M = {
              id: T.id,
              text: C || "",
              // Text is now sent separately via data channel
              senderName: j.value,
              senderAvatar: T.senderAvatar,
              senderRole: T.senderRole,
              senderIdentity: T.senderIdentity,
              senderIdentityType: T.senderIdentityType,
              timestamp: T.timestamp
            });
          }
          M && Q(M).catch((T) => null).then((T) => {
            T && i("message-sent", T);
          }), r.value = "", N.value && (URL.revokeObjectURL(N.value), N.value = null), h.value = null;
        } catch (M) {
        }
    }), fe = () => {
      var C;
      (C = t.value) == null || C.click();
    }, ae = (C) => e.allowedFileTypes ? e.allowedFileTypes.split(",").map((T) => T.trim()).some((T) => {
      if (T.startsWith("."))
        return C.name.toLowerCase().endsWith(T.toLowerCase());
      if (T.includes("*")) {
        const X = T.split("/")[0];
        return C.type.startsWith(X + "/");
      } else
        return C.type === T;
    }) : !0, lt = (C) => {
      if (!e.enableFileAttachment || !te.value || h.value) return;
      const M = C.clipboardData;
      if (!M) return;
      const X = Array.from(M.items).find((de) => de.kind === "file");
      if (X) {
        C.preventDefault();
        const de = X.getAsFile();
        if (!de) return;
        if (!ae(de)) {
          m.value = "File type not supported. Please select a supported file type.", setTimeout(() => {
            m.value = null;
          }, 5e3);
          return;
        }
        if (de.size > e.maxFileSize) {
          const et = Math.round(e.maxFileSize / 1048576);
          m.value = `File too large. Please select a file smaller than ${et} MB.`, setTimeout(() => {
            m.value = null;
          }, 5e3);
          return;
        }
        h.value = de, Et(de.type) && (N.value = URL.createObjectURL(de)), i("file-selected", de);
      }
    }, At = (C) => {
      var M;
      e.enableFileAttachment && te.value && (h.value || (M = C.dataTransfer) != null && M.types.includes("Files") && (U.value = !0, R.value = !1));
    }, Wt = (C) => {
      var M;
      if (e.enableFileAttachment && te.value && !h.value && (M = C.dataTransfer) != null && M.types.includes("Files")) {
        const T = C.dataTransfer.items;
        if (T && T.length > 0) {
          const X = T[0];
          if (X.kind === "file") {
            const de = X.getAsFile();
            de && !ae(de) ? (C.dataTransfer.dropEffect = "none", R.value = !0) : (C.dataTransfer.dropEffect = "copy", R.value = !1);
          }
        } else
          C.dataTransfer.dropEffect = "copy", R.value = !1;
        U.value = !0;
      }
    }, aa = (C) => {
      const M = C.currentTarget;
      M && !M.contains(C.relatedTarget) && (U.value = !1, R.value = !1);
    }, Sa = (C) => {
      var X;
      if (U.value = !1, R.value = !1, !e.enableFileAttachment || !te.value || h.value) return;
      const M = (X = C.dataTransfer) == null ? void 0 : X.files;
      if (!M || M.length === 0) return;
      const T = M[0];
      if (!ae(T)) {
        m.value = "File type not supported. Please select a supported file type.", setTimeout(() => {
          m.value = null;
        }, 5e3);
        return;
      }
      if (T.size > e.maxFileSize) {
        const de = Math.round(e.maxFileSize / 1048576);
        m.value = `File too large. Please select a file smaller than ${de} MB.`, setTimeout(() => {
          m.value = null;
        }, 5e3);
        return;
      }
      h.value = T, Et(T.type) && (N.value = URL.createObjectURL(T)), i("file-selected", T);
    }, ba = () => {
      x.value = !0;
    }, na = () => me(this, null, function* () {
      if (!(!b.value || !d.value))
        try {
          const M = w(w({}, {
            theme: f ? "dark" : "auto",
            perLine: 8,
            emojiSize: 24,
            emojiButtonSize: 32,
            searchPosition: "none"
          }), e.emojiPickerConfig), T = {};
          e.emojiPickerStyle && Object.entries(e.emojiPickerStyle).forEach(([X, de]) => {
            if (de != null) {
              const et = X.replace(/([A-Z])/g, "-$1").toLowerCase();
              T[et] = String(de);
            }
          }), yield be.togglePicker(
            b.value,
            (X) => {
              wa(X.native);
            },
            M,
            T
          );
        } catch (C) {
        }
    }), wa = (C) => {
      const M = d.value;
      if (!M) return;
      const T = M.selectionStart || 0, X = M.selectionEnd || 0, de = r.value, et = de.slice(0, T) + C + de.slice(X);
      r.value = et, $t(() => {
        const xt = T + C.length;
        M.setSelectionRange(xt, xt), M.focus();
      });
    }, Ca = (C) => {
      var X;
      const M = C.target, T = (X = M.files) == null ? void 0 : X[0];
      if (T) {
        if (T.size > e.maxFileSize) {
          const de = Math.round(e.maxFileSize / 1048576);
          m.value = `File too large. Please select a file smaller than ${de} MB.`, setTimeout(() => {
            m.value = null;
          }, 5e3), M.value = "";
          return;
        }
        h.value = T, Et(T.type) && (N.value = URL.createObjectURL(T)), i("file-selected", T), M.value = "";
      }
    }, Pa = () => {
      Se.value || (N.value && (URL.revokeObjectURL(N.value), N.value = null), h.value = null, t.value && (t.value.value = ""));
    }, ia = (C) => {
      if (C === 0) return "0 Bytes";
      const M = 1024, T = ["Bytes", "KB", "MB", "GB"], X = Math.floor(Math.log(C) / Math.log(M));
      return Math.round(C / Math.pow(M, X) * 100) / 100 + " " + T[X];
    }, Ra = (C) => {
      const M = C.split(".");
      return M.length > 1 ? M[M.length - 1] : "";
    }, Ta = (C, M = 50) => {
      if (C.length <= M) return C;
      const T = C.lastIndexOf(".");
      if (T === -1)
        return C.substring(0, M) + "...";
      const X = C.substring(T), de = C.substring(0, T), et = M - X.length - 3;
      return et <= 0 ? C.substring(0, M) + "..." : de.length <= et ? C : de.substring(0, et) + "..." + X;
    }, Et = (C) => C.startsWith("image/"), Ma = (C) => C.startsWith("video/"), Aa = (C) => {
      if (!C.url)
        return;
      const M = document.createElement("a");
      M.href = C.url, M.download = C.name, document.body.appendChild(M), M.click(), document.body.removeChild(M);
    }, Ea = (C) => {
      C.url && Et(C.type) && window.open(C.url, "_blank");
    }, xa = (C, M) => {
    };
    return Re(s, () => {
      e.autoScroll && l.value && $t(() => yt());
    }), Re(
      () => y.value.length,
      (C, M) => me(this, null, function* () {
        if (C > M) {
          const T = y.value[y.value.length - 1];
          if (T && !T.isOwn && (i("message-received", T), e.enableNotificationSound))
            try {
              yield he.playSound(
                Nt.MESSAGE_RECEIVED
              );
            } catch (X) {
            }
        }
      })
    ), ht(() => {
      yt(!1);
      const C = document.createElement("link");
      C.rel = "prefetch", C.href = "https://cdn.jsdelivr.net/npm/emoji-mart@5.6.0/dist/browser.js", document.head.appendChild(C);
      const M = document.createElement("link");
      M.rel = "prefetch", M.href = "https://cdn.jsdelivr.net/npm/@emoji-mart/data", document.head.appendChild(M);
    }), v({
      // Methods
      sendMessage: K,
      clearMessages: () => {
        E(), Qe();
      },
      scrollToBottom: yt,
      // State
      messages: s,
      isConnected: n(() => te.value),
      messageInput: r,
      // Refs
      inputRef: d
    }), (C, M) => (o(), u("div", {
      ref_key: "chatContainerRef",
      ref: k,
      class: Be(["room-chat", { "inside-player": P(f) }]),
      style: I(S.value)
    }, [
      a("div", {
        ref_key: "messageListRef",
        ref: p,
        class: "message-list",
        style: I(F.value),
        onScroll: se
      }, [
        P(Je) ? (o(), u("div", {
          key: 0,
          class: "loading-more-indicator",
          style: I(ne.value)
        }, [
          a("div", {
            class: "loading-spinner",
            style: I(ve.value)
          }, null, 4),
          a("span", {
            class: "loading-text",
            style: I(ue.value)
          }, "Loading older messages...", 4)
        ], 4)) : D("", !0),
        !P(Te) && s.value.length === 0 && !P(f) ? (o(), u("div", {
          key: 1,
          class: "empty-state",
          style: I(De.value)
        }, [
          a("div", {
            class: "empty-state-content",
            style: I(L.value)
          }, [
            x.value ? (o(), u("div", {
              key: 1,
              class: "empty-state-icon",
              style: I(O.value)
            }, [
              a("div", Bo, [
                a("div", _o, [
                  q(mn, { size: 20 })
                ])
              ])
            ], 4)) : (o(), u("img", {
              key: 0,
              src: "https://storage.googleapis.com/revex-assets-drm-staging/live-session-assets/images/no-chat-illustration.webp",
              alt: "No chat illustration",
              class: "empty-state-illustration",
              onError: ba
            }, null, 32)),
            a("h3", {
              class: "empty-state-heading",
              style: I(Y.value)
            }, ce(te.value ? "No conversations yet" : "Welcome to Chat"), 5),
            a("p", {
              class: "empty-state-message",
              style: I(G.value)
            }, ce(te.value ? "Start a new chat to get the conversation going!" : "Start the session to get conversation going!"), 5)
          ], 4)
        ], 4)) : P(Te) ? D("", !0) : (o(), u("div", Fo)),
        (o(!0), u(Le, null, Xe(s.value, (T) => (o(), u("div", {
          key: T.id,
          class: Be(["message-wrapper", { "own-message": T.isOwn }])
        }, [
          C.showAvatars ? (o(), u("div", {
            key: 0,
            class: "message-avatar",
            style: I(J.value)
          }, [
            q(jt, {
              name: T.senderName,
              image: T.senderAvatar,
              size: "small",
              "background-color": C.avatarBackgroundColor
            }, null, 8, ["name", "image", "background-color"])
          ], 4)) : D("", !0),
          a("div", Do, [
            C.showSenderNames ? (o(), u("div", {
              key: 0,
              class: "message-sender",
              style: I(W.value)
            }, [
              Ha(ce(T.senderName) + " ", 1),
              T.senderRole === "host" ? (o(), u("span", {
                key: 0,
                class: "host-tag",
                style: I($.value)
              }, "Host", 4)) : D("", !0),
              C.showTimestamps ? (o(), u("span", {
                key: 1,
                class: "message-timestamp inline",
                style: I(Me.value)
              }, ce(vt(T.timestamp)), 5)) : D("", !0)
            ], 4)) : D("", !0),
            a("div", {
              class: Be(["message-bubble", `bubble-${C.bubbleShape}`]),
              style: I(Ee(T))
            }, [
              T.text ? (o(), Ce(Lo, {
                key: 0,
                text: T.text,
                "preserve-whitespace": !0,
                "inside-player": P(f),
                style: I(Z.value),
                class: "message-text",
                onLinkClick: xa
              }, null, 8, ["text", "inside-player", "style"])) : D("", !0),
              T.attachment ? (o(), u("div", {
                key: 1,
                class: "message-attachment-container",
                style: I(Ct.value)
              }, [
                Et(T.attachment.type) ? (o(), u("div", {
                  key: 0,
                  class: "message-attachment image-attachment",
                  style: I(dt.value),
                  onClick: (X) => Ea(T.attachment)
                }, [
                  a("img", {
                    src: T.attachment.url || "#",
                    alt: T.attachment.name,
                    class: "attachment-preview-image"
                  }, null, 8, No)
                ], 12, Ho)) : Ma(T.attachment.type) ? (o(), u("div", {
                  key: 1,
                  class: "message-attachment video-attachment",
                  style: I(St.value)
                }, [
                  a("video", {
                    src: T.attachment.url || "#",
                    class: "attachment-preview-video",
                    controls: "",
                    preload: "metadata"
                  }, " Your browser does not support the video tag. ", 8, Oo)
                ], 4)) : (o(), u("div", {
                  key: 2,
                  class: "message-attachment document-attachment",
                  style: I(Pt.value)
                }, [
                  a("div", {
                    class: "attachment-info",
                    style: I(Tt.value)
                  }, [
                    q(Kt, { size: 20 }),
                    a("div", {
                      class: "attachment-details",
                      style: I(Mt.value)
                    }, [
                      a("span", {
                        class: "attachment-name",
                        title: T.attachment.name
                      }, ce(Ta(T.attachment.name, 25)), 9, Vo),
                      a("span", jo, ce(ia(T.attachment.size)), 1)
                    ], 4)
                  ], 4),
                  a("button", {
                    type: "button",
                    class: "download-button",
                    style: I(Rt.value),
                    title: "Download",
                    onClick: (X) => Aa(T.attachment)
                  }, M[6] || (M[6] = [
                    a("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "currentColor"
                    }, [
                      a("path", { d: "M10.75 2.75a.75.75 0 00-1.5 0v8.614L6.295 8.235a.75.75 0 10-1.09 1.03l4.25 4.5a.75.75 0 001.09 0l4.25-4.5a.75.75 0 00-1.09-1.03l-2.955 3.129V2.75z" }),
                      a("path", { d: "M3.5 12.75a.75.75 0 00-1.5 0v2.5A2.75 2.75 0 004.75 18h10.5A2.75 2.75 0 0018 15.25v-2.5a.75.75 0 00-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5z" })
                    ], -1)
                  ]), 12, Uo)
                ], 4))
              ], 4)) : D("", !0)
            ], 6)
          ])
        ], 2))), 128))
      ], 36),
      P(Te) ? (o(), u("div", {
        key: 0,
        class: "initial-loading-bottom",
        style: I(re.value)
      }, [
        (o(!0), u(Le, null, Xe(P(f) ? 2 : 3, (T) => (o(), u("div", {
          key: T,
          class: "message-skeleton"
        }, [
          a("div", {
            class: "skeleton-avatar",
            style: I(ge.value)
          }, null, 4),
          a("div", {
            class: "skeleton-content",
            style: I(He.value)
          }, [
            a("div", {
              class: "skeleton-name",
              style: I(Oe.value)
            }, null, 4),
            a("div", {
              class: "skeleton-text",
              style: I(le.value)
            }, null, 4),
            P(f) ? D("", !0) : (o(), u("div", {
              key: 0,
              class: "skeleton-text short",
              style: I(le.value)
            }, null, 4))
          ], 4)
        ]))), 128))
      ], 4)) : D("", !0),
      q(Qt, { name: "new-message-notification" }, {
        default: ot(() => [
          H.value && !l.value ? (o(), u("div", {
            key: 0,
            class: "new-message-notification",
            style: I(it.value),
            onClick: M[0] || (M[0] = (T) => yt(!0))
          }, M[7] || (M[7] = [
            a("svg", {
              width: "16",
              height: "16",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              a("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1),
            a("span", { class: "new-message-text" }, "See latest", -1)
          ]), 4)) : D("", !0)
        ]),
        _: 1
      }),
      q(Qt, { name: "scroll-button" }, {
        default: ot(() => [
          H.value && l.value ? (o(), u("button", {
            key: 0,
            type: "button",
            class: Be(["scroll-to-bottom-button", { "inside-player": P(f) }]),
            style: I(Ne.value),
            onClick: M[1] || (M[1] = (T) => yt(!0))
          }, M[8] || (M[8] = [
            a("svg", {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "currentColor"
            }, [
              a("path", { d: "M10 3a.75.75 0 01.75.75v10.638l3.96-4.158a.75.75 0 111.08 1.04l-5.25 5.5a.75.75 0 01-1.08 0l-5.25-5.5a.75.75 0 111.08-1.04l3.96 4.158V3.75A.75.75 0 0110 3z" })
            ], -1)
          ]), 6)) : D("", !0)
        ]),
        _: 1
      }),
      m.value ? (o(), u("div", {
        key: 1,
        class: "file-size-error-notification",
        style: I(Ze.value)
      }, [
        a("div", {
          class: "error-content",
          style: I(Ve.value)
        }, [
          a("span", {
            class: "error-text",
            style: I(Ie.value)
          }, ce(m.value), 5),
          a("button", {
            type: "button",
            class: "error-dismiss-button",
            style: I(Ke.value),
            onClick: M[2] || (M[2] = (T) => m.value = null)
          }, " × ", 4)
        ], 4)
      ], 4)) : D("", !0),
      a("form", {
        class: Be(["input-container", {
          "drag-over": U.value,
          "drag-invalid": R.value
        }]),
        style: I(_e.value),
        onSubmit: M[5] || (M[5] = je(() => {
        }, ["prevent"])),
        onDragover: je(Wt, ["prevent"]),
        onDragenter: je(At, ["prevent"]),
        onDragleave: aa,
        onDrop: je(Sa, ["prevent"])
      }, [
        U.value ? (o(), u("div", Wo, [
          a("div", Go, [
            a("div", Zo, [
              R.value ? (o(), u("svg", Yo, M[10] || (M[10] = [
                a("path", { d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" }, null, -1)
              ]))) : (o(), u("svg", Ko, M[9] || (M[9] = [
                a("path", { d: "M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" }, null, -1)
              ])))
            ]),
            a("div", Jo, ce(R.value ? "File type not supported" : "Drop file here"), 1)
          ])
        ])) : D("", !0),
        P(f) ? (o(), u(Le, { key: 2 }, [
          C.enableEmoji ? (o(), u("button", {
            key: 0,
            ref_key: "emojiButtonRef",
            ref: b,
            type: "button",
            class: "emoji-button",
            style: I(nt.value),
            disabled: !te.value || P(be).isLoading.value,
            onClick: na
          }, [
            q(ua, { size: 20 })
          ], 12, ls)) : D("", !0),
          a("div", cs, [
            Jt(a("input", {
              id: "message-input",
              ref_key: "inputRef",
              ref: d,
              "onUpdate:modelValue": M[4] || (M[4] = (T) => r.value = T),
              type: "text",
              class: "message-input",
              style: I(ze.value),
              placeholder: C.inputPlaceholder,
              maxlength: C.maxMessageLength,
              disabled: !te.value,
              onKeydown: ra(je(K, ["prevent"]), ["enter"]),
              onPaste: lt
            }, null, 44, us), [
              [Xt, r.value]
            ])
          ]),
          a("button", {
            type: "button",
            class: "send-button",
            style: I(oe.value),
            disabled: !ke.value,
            onClick: je(K, ["prevent"])
          }, [
            P(Se) ? (o(), u("svg", ps, [
              M[13] || (M[13] = a("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                opacity: "0.2"
              }, null, -1)),
              a("circle", {
                cx: "10",
                cy: "10",
                r: "8",
                stroke: "currentColor",
                "stroke-width": "2",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-dasharray": `${P(Ye) * 50.3} 50.3`,
                transform: "rotate(-90 10 10)",
                class: "progress-ring-circle"
              }, null, 8, vs)
            ])) : (o(), Ce(da, {
              key: 1,
              size: 20
            }))
          ], 12, ds)
        ], 64)) : (o(), u(Le, { key: 1 }, [
          h.value ? (o(), u("div", {
            key: 0,
            class: "file-preview",
            style: I(qe.value)
          }, [
            N.value && Et(h.value.type) ? (o(), u("div", Xo, [
              a("img", {
                src: N.value,
                alt: h.value.name
              }, null, 8, Qo)
            ])) : (o(), u("div", {
              key: 1,
              class: "file-icon",
              style: I(rt.value)
            }, [
              q(Kt, { size: 24 })
            ], 4)),
            a("div", {
              class: "file-info",
              style: I(gt.value)
            }, [
              a("div", {
                class: "file-name",
                style: I(kt.value)
              }, ce(h.value.name), 5),
              a("div", {
                class: "file-size",
                style: I(wt.value)
              }, ce(ia(h.value.size)) + ", " + ce(Ra(h.value.name)), 5)
            ], 4),
            a("button", {
              type: "button",
              class: "file-remove-button",
              style: I(pt.value),
              disabled: P(Se),
              title: P(Se) ? "Upload in progress" : "Remove file",
              onClick: Pa
            }, M[11] || (M[11] = [
              a("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "currentColor"
              }, [
                a("path", { d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" })
              ], -1)
            ]), 12, qo)
          ], 4)) : D("", !0),
          Jt(a("textarea", {
            id: "message-input",
            ref_key: "inputRef",
            ref: d,
            "onUpdate:modelValue": M[3] || (M[3] = (T) => r.value = T),
            class: "message-input standalone",
            style: I(ze.value),
            placeholder: C.inputPlaceholder,
            disabled: !te.value,
            rows: "2",
            onKeydown: ra(g, ["enter"]),
            onInput: B,
            onPaste: lt
          }, null, 44, es), [
            [Xt, r.value]
          ]),
          a("div", ts, [
            a("div", as, [
              C.enableEmoji ? (o(), u("button", {
                key: 0,
                ref_key: "emojiButtonRef",
                ref: b,
                type: "button",
                class: "emoji-button",
                style: I(nt.value),
                disabled: !te.value || P(be).isLoading.value,
                onClick: na
              }, [
                q(ua, { size: 20 })
              ], 12, ns)) : D("", !0),
              C.enableFileAttachment ? (o(), u("button", {
                key: 1,
                type: "button",
                class: "attachment-button",
                style: I(Ae.value),
                disabled: !te.value,
                onClick: fe
              }, [
                q(Kt, { size: 20 })
              ], 12, is)) : D("", !0)
            ]),
            a("button", {
              type: "button",
              class: "send-button",
              style: I(oe.value),
              disabled: !ke.value,
              onClick: je(K, ["prevent"])
            }, [
              P(Se) ? (o(), u("svg", ss, [
                M[12] || (M[12] = a("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  opacity: "0.2"
                }, null, -1)),
                a("circle", {
                  cx: "10",
                  cy: "10",
                  r: "8",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  fill: "none",
                  "stroke-linecap": "round",
                  "stroke-dasharray": `${P(Ye) * 50.3} 50.3`,
                  transform: "rotate(-90 10 10)",
                  class: "progress-ring-circle"
                }, null, 8, rs)
              ])) : (o(), Ce(da, {
                key: 1,
                size: 20
              }))
            ], 12, os)
          ])
        ], 64))
      ], 38),
      a("input", {
        ref_key: "fileInputRef",
        ref: t,
        type: "file",
        accept: C.allowedFileTypes,
        style: { display: "none" },
        onChange: Ca
      }, null, 40, ms)
    ], 6));
  }
}), Es = /* @__PURE__ */ We(fs, [["__scopeId", "data-v-22d3ee82"]]);
export {
  ui as P,
  Ts as R,
  Ms as a,
  As as b,
  Es as c,
  lo as d
};
